export default {
  "bcase": {
    "header": {
      "tooltip": {
        "save": "Salva",
        "edit_enable": "Abilita modifica",
        "edit_disable": "Disabilita modifica",
        "maximize": "Massimizza",
        "minimize": "Minimizza",
        "attachments": "Allegati"
      }
    }
  },
    "oauth2_consent": {
        "title": "Consentire a {application} di accedere a Liftbase?",
        "intro": "Prima di continuare, verifichi a quali dati potrà accedere questa applicazione.",
        "application": "Applicazione",
        "client_id": "ID applicazione",
        "callback": "Destinazione di callback",
        "identity_notice": "Il nome dell'applicazione proviene dall'app. Verifichi la destinazione di callback prima di consentire l'accesso.",
        "permissions": "Autorizzazione",
        "duration": "Durata dell'accesso",
        "token_lifetime": "Validità del token",
        "token_lifetime_value": "{accessMinutes} minuti",
        "renewal": "Rinnovo senza richiesta",
        "renewal_value": "fino a {authorizationDays} giorni",
        "readonly": "Solo lettura",
        "notice": "L'accesso resta limitato alle autorizzazioni Liftbase esistenti e vale solo per questa applicazione.",
        "allow": "Consenti accesso",
        "deny": "Nega",
        "submit_error": "Impossibile avviare l'autorizzazione. Riprovi.",
        "submit_error_invalid_request": "Questa richiesta di autorizzazione è scaduta o non valida. Avvia di nuovo la connessione dall'applicazione.",
        "submit_error_invalid_redirect": "La destinazione di ritorno dell'applicazione non è valida. Avvia di nuovo la connessione.",
        "error_title": "La richiesta di autorizzazione non è valida",
        "error_description": "Torni all'applicazione e avvii nuovamente la connessione.",
        "unverified_title": "Applicazione non verificata",
        "unverified_warning": "Questa applicazione non è stata verificata da Liftbase come provider terzo affidabile. Il nome mostrato potrebbe provenire da un altro provider. Controlla attentamente l'URL di reindirizzamento prima di consentire l'accesso.",
        "scope": {
            "mcp": {
                "title": "Leggere i dati Liftbase consentiti",
                "description": "Acquisti, fatture, contratti, workflow, estratti conto e liquidità — solo lettura, nessun accesso in scrittura."
            }
        }
    },
    "administration": "Amministrazione",
    "master_data": "Dati master",
    "admin_page": {
        "no_permission": "Non ha il permesso di accedere all'area di amministrazione.",
        "confirm_before_delete_msg": "Vuole davvero rimuovere questa voce? (ID #{id})",
        "confirm_before_delete_from_db_msg": "Vuole davvero eliminare questa voce? (ID #{id})",
        "confirm_before_delete_from_db_title": "Cancellare in modo permanente",
        "confirm_before_delete_from_db_btn": "Cancellare",
        "block_user_msg": "Vuole davvero bloccare {name}? La persona non potrà quindi accedere.",
        "block_user_title": "Blocco di accesso",
        "block_user_btn": "Blocco",
        "unblock_user_msg": "Vuole davvero sbloccare {name}? La persona potrà quindi accedere di nuovo.",
        "unblock_user_title": "Sbloccare il login",
        "unblock_user_btn": "Sbloccare",
        "tour": {
            "menu_title": "Sezioni",
            "menu": "Qui può vedere le sezioni dell'area di amministrazione dove può gestire e modificare i dati anagrafici e le impostazioni.",
            "client_menu_title": "Gestire le aziende",
            "client_menu": "Qui può aggiungere, visualizzare o modificare tutte le aziende.",
            "client_list": "Qui può vedere tutte le aziende.",
            "new_client": "Clicchi qui per creare una nuova azienda.",
            "view_mode": "<p> Qui può passare dalla vista elenco alla vista tabella per impostare più voci contemporaneamente o per avere una migliore panoramica.</p> La vista tabella può essere utilizzata anche per l'esportazione o l'importazione di dati. Non dimentichi di salvare la tabella dopo la modifica."
        }
    },
    "version": "Versione",
    "yes": "Sì",
    "no": "No",
    "recommended": "Consigliato",
    "never": "Mai",
    "add": "Aggiungi",
    "edit": "Modifica",
    "delete": "Cancellare",
    "save": "Salva",
    "cancel": "Annulla",
    "apply": "Applica",
    "next": "Avanti",
    "back": "Indietro",
    "finish": "Finitura",
    "ok": "Ok",
    "open": "Aperto",
    "dashboard": "Dashboard",
    "dashboards": "Dashboards",
    "einvoice_dashboard": "Dashboard Fattura Elettronica",
    "invoice_dashboard": "Incoming Invoice Dashboard",
    "outgoing_invoice_dashboard": "Outgoing Invoice Dashboard",
    "overview": "Panoramica",
    "operator": "Operator",
    "profile": "Profilo",
    "help": "Aiuto",
    "logout": "Esci",
    "tenant_switcher": {
        "error": "Impossibile cambiare tenant.",
        "error_passkey": "Il cambio tenant non e disponibile per le sessioni con passkey.",
        "error_saml": "Questo tenant non puo essere aperto dalla sessione SSO corrente."
    },
    "list_view": "Visualizza elenco",
    "table_view": "Visualizza tabella",
    "archive": "Archivio",
    "active": "Attivo",
    "email": "Email",
    "name": "Nome",
    "tax": "Imposte (%)",
    "value": "Importo",
    "number": "Numero",
    "currency": "Valuta",
    "actions": "Azioni",
    "system": "Sistema",
    "from": "Da",
    "of": "Di",
    "until": "fino a quando",
    "up_to": "fino a",
    "show_more": "Mostra di più",
    "refresh": "Aggiorna",
    "calculate": "Calcola",
    "calc_brutto_from_net": "Calcola lordo da netto",
    "calc_net_from_brutto": "Calcola netto da lordo",
    "cost_center_id": "Centro di costo",
    "cost_centers": "Centri di costo",
    "budget_id": "Budget",
    "budgets": "Budget",
    "branch_id": "Filiale",
    "branches": "Filiali",
    "employee_id": "Dipendente",
    "employees": "Dipendenti",
    "vehicles": "Veicoli",
    "financial_dimension_id": "Dimensione finanziaria",
    "financial_dimensions": "Dimensioni finanziaria",
    "tax_group_id": "Gruppo imposta sulle vendite",
    "tax_groups": "Gruppi imposta sulle vendite",
    "tax_item_group_id": "Gruppo articoli imposta sulle vendite",
    "tax_item_groups": "Gruppi articoli imposta sulle vendite",
    "profit_center_id": "Centro di profitto",
    "profit_centers": "Centri di profitto",
    "client_id": "Azienda",
    "clients": "Aziende",
    "ai_prompts": "Prompts",
    "ai_prompt": {
        "description": "Prompt",
        "title": "Titolo",
        "slug": "Slug",
        "category": "Categoria",
        "active": "Attivo",
        "is_published": "Pubblicato",
        "changelog": "Cronologia modifiche",
        "system_prompt": "System Prompt",
        "developer_prompt": "Developer Prompt",
        "user_prompt_tpl": "Template Prompt Utente",
        "output_format": "Formato di output",
        "output_schema": "Schema di output",
        "preview": "Anteprima",
        "context_json": "JSON di Contesto",
        "output_json": "Output (JSON)",
        "highlighted_preview": "Anteprima Evidenziata",
        "apply_placeholders": "Applica Placeholder",
        "available_objects": "Oggetti disponibili",
        "search_objects": "Cerca oggetti e campi",
        "suggestions": "Suggerimenti",
        "fields": "Campi",
        "relations": "Relazioni",
        "execute": "Esegui",
        "execute_prompt": "Esegui Prompt",
        "simulated_result_message": "Questo è un risultato simulato dell'esecuzione del prompt.",
        "test_data_selection": "Selezione Dati di Test",
        "click_to_see_result": "Clicca su \"{action}\" per vedere il risultato.",
        "tab_general": "Generale",
        "tab_content": "Contenuto",
        "tab_test": "Test",
        "page": {
            "new": "Nuovo Prompt",
            "validation": {
                "title_required": "Inserisci un titolo.",
                "slug_required": "Inserisci uno slug."
            }
        }
    },
    "department_id": "Reparto",
    "departments": "Reparti",
    "d365_branch_id": "Filiale",
    "d365_employee_id": "Dipendente",
    "d365_department_id": "D365 Reparto",
    "d365_area_id": "Area D365",
    "d365_labor_wert_id": "Valore laboratorio D365",
    "d365_project_id": "Progetto D365",
    "d365_sales_channel_id": "Canale di vendita D365",
    "d365_vehicle_id": "Veicolo",
    "d365_branches": "Filiali",
    "d365_employees": "Dipendenti",
    "d365_departments": "D365 Reparti",
    "location_id": "Posizione",
    "consignee_id": "Ricevimento della merce",
    "address_id": "Indirizzo di consegna",
    "cost_type_id": "Tipo di costo",
    "incoming_revenue_type": "Tipo di ricavo",
    "incoming_revenue_type_id": "Tipo di ricavo",
    "lb_user_id": "Persona",
    "users": "Persone",
    "task_group_id": "Gruppo di compiti",
    "task_groups": "Gruppi di compiti",
    "user_task_group": "Utente/Gruppo di attività",
    "user_task_groups": "Utenti/Gruppi di attività",
    "product": "Prodotto",
    "products": "Catalogo dei prodotti",
    "product_group_id": "Gruppo di prodotti",
    "product_groups": "Gruppi di prodotti",
    "supplier_id": "Fornitore",
    "business_partner_id": "Partner commerciale",
    "suppliers": "Fornitori",
    "business_partners": "Partner commerciali",
    "procurement_id": "Ordine di acquisto",
    "procurements": "Ordini di acquisto",
    "contract_id": "Contratto",
    "contracts": "Contratti",
    "user_select_product_id": "Persona 'Selezione del prodotto'",
    "user_send_order_id": "Persona 'Ordinato da'",
    "user_clearing_id": "Persona 'Chiarimenti sull'acquisto'",
    "user_consignee_id": "Persona 'Ricevimento della merce'",
    "user_invoice_manual_check_id": "Persona 'Controllo manuale (fattura)'",
    "user_invoice_clearing_id": "Persona 'Chiarimenti contabile'",
    "user_accounting_id": "Utente 'Contabilità'",
    "user_contract_clearing_id": "Persona 'Chiarimenti contratto'",
    "ledger_account_id": "Conto del libro mastro",
    "ledger_accounts": "Conti del libro mastro",
    "posting_key_id": "Posting key",
    "posting_keys": "Posting keys",
    "permission_id": "Gruppo di autorizzazione",
    "permissions": "Gruppi di autorizzazione",
    "invoices": "Fatture",
    "invoice_id": "Fattura",
    "outgoing_invoice_id": "Fattura in uscita",
    "outgoing_invoices": "Fatture in uscita",
    "configurations": "Impostazioni",
    "marketplace_id": "Marketplace",
    "provider_id": "Fornitore del Marketplace",
    "notes": "Nota",
    "search": "Trova",
    "no_data": "Nessuna voce trovata",
    "months": "Mesi",
    "select_valid_option": "Selezioni una voce valida.",
    "price_restricted": "Le informazioni sui prezzi sono attualmente disattivate.",
    "procurement_line": {
        "description": "Prodotto",
        "item_number": "Numero di articolo",
        "is_cost_center_fixed": "Preset fisso",
        "image_url": "URL immagine",
        "webshop_url": "URL del negozio",
        "offer_number": "Numero dell'offerta",
        "offer_date": "Data dell'offerta",
        "include_tax": "incl. {tax} IVA",
        "offer_msg": "In base all'offerta {offer_number}",
        "offer_date_msg": "in data {offer_date}",
        "delivery_completed": "Posizione completata",
        "total_price_brutto": "Totale lordo",
        "total_price_netto": "Totale netto",
        "type_total_price_brutto": "currency",
        "type_price_brutto": "currency",
        "type_total_price_netto": "currency",
        "type_price_netto": "currency"
    },
    "product_catalog": {
        "description": "Articolo",
        "alias": "Descrizione per la ricerca",
        "add_product_btn": "Aggiungi prodotto",
        "item_number": "Numero di articolo",
        "is_cost_center_fixed": "Assegnazione fissa",
        "image_url": "URL immagine",
        "webshop_url": "URL del negozio",
        "offer_number": "Numero dell'offerta",
        "offer_date": "Data dell'offerta",
        "type_price_netto": "currency",
        "type_price_brutto": "currency",
        "form_sequence": "name,item_number,product_group_id,supplier_id,location_id,cost_center_id,is_cost_center_fixed,tax,price_netto,price_brutto,unit,image_url,webshop_url,offer_number,offer_date",
        "page": {
            "new": "Nuovo prodotto",
            "supplier_tooltip": "Selezioni un fornitore dai suoi dati anagrafici o ne aggiunga uno nuovo digitando un nuovo nome.",
            "supplier_new_tooltip": "Questo fornitore sarà salvato nei suoi dati anagrafici quando aggiungerà il prodotto.",
            "should_save": "Salva nel catalogo prodotti",
            "sections": {
                "basic": "Dati di base",
                "supplier": "Classificazione e fornitore",
                "pricing": "Prezzi e imposte",
                "accounting": "Contabilità",
                "media_offer": "Media e offerta",
                "permissions": "Autorizzazioni"
            },
            "validation": {
                "name_required": "La preghiamo di inserire un nome.",
                "supplier_required": "Selezioni un fornitore o ne aggiunga uno nuovo.",
                "image_url_invalid": "Inserisca un URL valido.",
                "webshop_url_invalid": "Inserisca un URL valido.",
                "tax_invalid": "Inserisca un'aliquota fiscale valida."
            },
            "tour": {
                "name": "Fornisca un nome significativo per il prodotto.",
                "number": "Qui può inserire il numero di articolo del prodotto.",
                "product_group": "Scelga il gruppo di prodotti a cui appartiene il prodotto.",
                "supplier": "Scelga il fornitore del prodotto da cui ordinarlo.",
                "price": "Specifichi un'aliquota fiscale e un prezzo netto o lordo. L'altro prezzo sarà calcolato utilizzando l'aliquota fiscale.",
                "unit": "Indicare l'unità di misura del prodotto, ad esempio \"articoli\", \"kg\" o \"litri\".",
                "url": "Qui può aggiungere un'immagine URL al prodotto. Inoltre, se disponibile, può aggiungere un link alla pagina del prodotto nel negozio.",
                "offer": "Se esiste un'offerta per il prodotto, può inserire qui il numero e la data dell'offerta per visualizzarli sul PDF dell'ordine.",
                "btn_save": "Salvi il prodotto nel catalogo prodotti una volta aggiunte tutte le informazioni."
            }
        }
    },
    "product_group": {
        "form_sequence": "name,description,user_select_product_id",
        "page": {
            "new": "Nuovo gruppo di prodotti",
            "no_product_group": "Senza gruppo di articoli",
            "validation": {
                "name_required": "La preghiamo di inserire un nome."
            },
            "tour": {
                "name": "Fornisca un nome significativo per il gruppo di prodotti.",
                "btn_save": "Una volta fornite tutte le informazioni, aggiunga il gruppo di prodotti."
            }
        }
    },
    "procurement": {
        "description": "Ordine di acquisto",
        "order_description": "Ordine",
        "name": "Nome",
        "number": "Numero d'ordine",
        "order_number_formatted": "Numero d'ordine",
        "contract_number": "Numero del contratto",
        "creator_id": "Creato da",
        "created_at": "Data di creazione",
        "delivery_date": "Data di consegna",
        "delivery_address_id": "Indirizzo di consegna",
        "billing_address_text": "Indirizzo di fatturazione",
        "status": "Stato",
        "show_notes_pdf": "Mostra nel PDF dell'ordine",
        "open_value": "Valore d'ordine aperto",
        "open_value_recurring": "∞ dKueZ",
        "open_value_exceeds_with_invoice": "Questa fattura supera il valore dell'ordine.",
        "total_brutto": "Totale lordo",
        "total_netto": "Totale netto",
        "total_netto_abbr": "-Rete",
        "payment_in_advance": "Pagamento anticipato",
        "has_invoices": "Fattura registrata",
        "invoice_count": "Fatture (quantità)",
        "completely_invoiced": "Completamente fatturato",
        "is_fully_allocated": "Completamente fatturato",
        "payment_timing": "Tipo di pagamento",
        "usage_type": "Frequenza",
        "type": "Tipo di ordine",
        "type_options": {
            "single_invoice": "eKuez con fattura singola",
            "recurring_invoice": "dKuez con fattura singola",
            "recurring_contract": "dKuez con fattura ricorrente"
        },
        "statuses": {
            "open": "Selezione dei prodotti",
            "approved": "Ordine di acquisto",
            "ordered": "In attesa della consegna",
            "declined": "Rifiutato",
            "completed": "Completato",
            "historical-imported": "Importato come storico",
            "approval": "Approvato",
            "clearing": "Chiarimenti sull'acquisto",
            "draft": "Bozza"
        },
        "page": {
            "ai_fill_menu": "Compila ordine con IA",
            "completely_invoiced_auto_tooltip": "Contrassegnato automaticamente dal sistema perché l'importo allocato con le fatture è uguale o superiore al valore dell'ordine.",
            "completely_invoiced_final_invoice_tooltip": "Contrassegnato come completamente fatturato da {invoices}.",
            "completely_invoiced_final_invoice_tooltip_prefix": "Contrassegnato come completamente fatturato da ",
            "completely_invoiced_final_invoice_tooltip_separator": ", ",
            "completely_invoiced_final_invoice_tooltip_suffix": ".",
            "ai": {
                "title": "Assistente Acquisti (IA)",
                "months": "Periodo (mesi)",
                "products_limit": "Prodotti (quantità)",
                "suppliers_limit": "Fornitori (quantità)",
                "contracts_limit": "Contratti (quantità)",
                "order_without_template_btn": "Ordinare senza modello",
                "or_create_based_on_existing_msg": "oppure crea un nuovo ordine in base ai seguenti ordini o contratti esistenti:",
                "recent_products": "I tuoi ultimi prodotti ordinati",
                "top_products": "Prodotti top",
                "top_suppliers": "Fornitori top",
                "orders_count": "{n} ordini",
                "active_contracts": "Contratti attivi",
                "contract_end_date": "Data di fine",
                "procurements_count": "{n} ordini",
                "loading_text": "Elaborazione del suggerimento IA…",
                "processing_title": "Creazione dell'ordine con l'IA",
                "processing_subtitle": "Questo potrebbe richiedere 15–20 secondi. Mantenga aperta questa pagina.",
                "invoices_count": "{n} fatture",
                "magic_order": {
                    "label": "Crea ordine basato sulle abitudini di acquisto recenti",
                    "tooltip": ""
                },
                "msg_success": "I dati dell'ordine sono stati precompilati automaticamente",
                "msg_not_found": "Nessun ordine corrispondente trovato",
                "msg_failed": "Suggerimento IA non riuscito",
                "msg_not_possible": "Precompilazione IA non possibile"
            },
            "new_from_contract": "Ordine da contratto",
            "no_delivery_address": "Nessun indirizzo di consegna",
            "no_budget": "Nessun budget",
            "new": "Nuovo ordine di acquisto",
            "create_btn": "Avvio dell'ordine di acquisto",
            "copy_btn_tooltip": "Copia dell'ordine di acquisto",
            "magic_suggestions_btn_tooltip": "Ottieni suggerimenti intelligenti basati su criteri dinamici (acquisti recenti, fornitori, contratti). Possono essere applicati costi di IA in base alle impostazioni del tenant.",
            "magic_suggestions_no_data": "Nessun suggerimento IA trovato per i criteri selezionati.",
            "magic_suggestions_applied": "Suggerimenti IA applicati.",
            "magic_suggestions_dialog": {
                "title": "Suggerimenti per questo ordine di acquisto",
                "message": "Seleziona i campi che desideri compilare in base ai suggerimenti dell'IA.",
                "info_based_on_last_order": "Questo suggerimento è stato generato dall'IA in base al tuo ultimo ordine.",
                "no_data": "Nessun suggerimento trovato per questo ordine di acquisto."
            },
            "offer_document": {
                "add_from_document": "Aggiungi da offerta",
                "dialog_title": "Importa righe dall'offerta",
                "loading_text": "Riconoscimento offerta...",
                "upload_info1": "Trascina qui il PDF dell'offerta <br>o <br> <em>seleziona file</em>.",
                "upload_info2": "File PDF fino a 30 MB.",
                "preview_message": "Seleziona le righe da aggiungere come prodotti.",
                "no_lines": "Nessuna riga di offerta trovata.",
                "new_upload": "Scarta e carica di nuovo",
                "retry": "Riprova",
                "retry_wait": "oppure attendere ancora qualche secondo",
                "file_invalid": "Carica solo file PDF.",
                "file_too_large": "Carica solo file fino a 30 MB.",
                "extract_failed": "Non è stato possibile riconoscere l'offerta.",
                "file_save_failed": "Impossibile salvare il PDF dell'offerta.",
                "lines_applied": "Righe dell'offerta aggiunte.",
                "supplier_required": "Seleziona un fornitore prima di importare le righe.",
                "supplier_recognized": "Fornitore riconosciuto: {supplier_name}.",
                "supplier_missing": "Seleziona o crea un fornitore.",
                "create_supplier": "Crea \"{supplier_name}\"",
                "create_supplier_confirm_title": "Crea fornitore",
                "create_supplier_confirm_message": "Vuoi creare \"{supplier_name}\" come nuovo fornitore?",
                "create_supplier_confirm_btn": "Crea",
                "create_supplier_success": "Fornitore creato.",
                "create_supplier_failed": "Impossibile creare il fornitore.",
                "supplier_note_website": "Sito web",
                "supplier_note_contact": "Contatto",
                "supplier_note_extra_ibans": "IBAN aggiuntivi"
            },
            "delivery_date_tooltip": "La data di consegna sarà stampata sul PDF dell'ordine e potrà essere inviata al fornitore.",
            "order_sender": "Ordine di acquisto",
            "product_selector": "Selezione dei prodotti",
            "product_search": "Trova prodotti",
            "before_leave_msg": "Il suo ordine di acquisto non è stato salvato. È sicuro di voler lasciare la pagina?",
            "confirm_without_approval_limit_msg": "Nessuna delle persone selezionate ha il limite di approvazione necessario per il valore di questo ordine. È possibile aggiungere ulteriori approvazioni in un secondo momento. È sicuro di voler procedere?",
            "confirm_without_approval_limit_title": "Limite di approvazione",
            "confirm_product_selection_without_product_msg": "Non ha selezionato alcun prodotto. È sicuro di voler procedere?",
            "confirm_product_selection_without_product_title": "Nessun prodotto selezionato",
            "no_approval_limit_msg": "Il suo limite di approvazione non è sufficiente per questo ordine. La preghiamo di aggiungere un'altra persona con un limite di approvazione adeguato per l'approvazione.",
            "no_approval_limit_title": "Limite di approvazione",
            "product_group_missing_msg": "Tutti i prodotti devono essere assegnati ad un gruppo di prodotti. Vada alla scheda 'Gruppi di prodotti' sopra l'elenco dei prodotti e assegni un gruppo di prodotti a ciascun prodotto.",
            "product_group_missing_title": "Assegnazione del gruppo di prodotti",
            "product_group_missing_btn": "Capito",
            "min_approval_one_person": "1 persona",
            "min_approval_qty": "{qty} persone diverse",
            "min_approval_error_msg": "L'approvazione non è sufficiente per questo ordine d'acquisto. Aggiunga un'altra persona per l'approvazione. Questo ordine di acquisto deve essere approvato da <b>almeno {min_approval_msg}</b>.",
            "min_approval_error_title": "Approvazione insufficiente",
            "order_not_completed_msg": "Non ha ordinato tutti i prodotti o non li ha confermati. Si assicuri di aver ordinato tutti i prodotti dell'elenco e li confermi, se necessario, per procedere.",
            "order_not_completed_title": "Completi prima gli ordini",
            "order_not_completed_btn": "Capito",
            "confirm_delivery_not_completed_msg": "Non ha confermato tutte le ricevute della merce. È sicuro di voler completare l'ordine di acquisto? <br> <i>Questa azione non può essere annullata</i>.",
            "confirm_delivery_not_completed_title": "Ricevute in sospeso di merci",
            "confirm_delivery_not_completed_btn": "Completa",
            "default_confirm_btn": "Continua",
            "budget_exceeded_msg": "Budget superato",
            "approval_limit_exceeded_msg": "Limite di approvazione superato",
            "external_order_number_msg": "Inserisca il numero d'ordine esterno.",
            "external_order_number_title": "Inserisca il numero d'ordine esterno",
            "no_edit_permission": "Non ha l'autorizzazione a modificare i dati. La preghiamo di inviare l'ordine di acquisto per chiarimenti tramite azioni per apportare modifiche ai dati.",
            "add_invoice_after_order_message": "È possibile creare una fattura dopo l'avvio della richiesta d'acquisto.",
            "no_invoice": "Non sono ancora state registrate fatture per questa richiesta d'acquisto.",
            "tabs": {
                "lines": "Articoli",
                "invoices": "Fatture"
            },
            "delivery_dialog": {
                "title": "Confermare la ricezione della merce",
                "confirm_btn": "Confermare",
                "message": "Inserisca la quantità ricevuta di recente.<br> {quantità_mancanti} di {quantità} {unità} sono mancanti.",
                "qty_exceeded_msg": "La quantità mancante non deve essere superata.",
                "qty_must_be_greater_msg": "La quantità deve essere maggiore di 0.",
                "invalid_format": "Utilizzi un formato numerico valido."
            },
            "order_sender_dialog": {
                "title": "Ruolo predefinito per l'inserimento degli ordini",
                "info": "La persona nella fase 'Inserimento dell'ordine' viene determinata in base ai ruoli predefiniti per il reparto, l'azienda, i ruoli predefiniti globali e la persona che ha creato l'ordine di acquisto. La persona in cima all'elenco è preselezionata per il compito."
            },
            "consignee_dialog": {
                "title": "Ruolo predefinito per il ricevimento della merce",
                "info": "La persona nella fase 'Ricevimento merci' viene determinata in base ai ruoli predefiniti per il reparto, la società, i ruoli globali predefiniti e la persona che ha creato l'ordine di acquisto. La persona in cima all'elenco è preselezionata per il compito."
            },
            "select_product_dialog": {
                "title": "Ruolo predefinito per la selezione dei prodotti",
                "info": "La persona nella fase 'Selezione del prodotto' viene determinata in base ai ruoli predefiniti per il reparto, l'azienda, i ruoli predefiniti globali e la persona che ha creato l'ordine di acquisto. La persona in cima all'elenco è preselezionata per il compito."
            },
            "marketplace_change_dialog": {
                "title": "L'ordine sarà annullato",
                "info": "È stato rilevato un cambio di azienda. Tuttavia, esiste un ordine nel marketplace {marketplace_name} che non è collegato alla nuova azienda {client_name}. Se procedi, questo ordine sarà annullato.",
                "btn_confirm": "Annulla ordine"
            },
            "dialog_assignment": {
                "department_form": "Reparto in forma",
                "department_creator": "Reparto della persona ordinata",
                "client_form": "Azienda in forma",
                "client_creator": "Azienda della persona ordinata",
                "no_selection": "Non ancora selezionato",
                "no_action": "Non applicabile",
                "configuration": "Ruolo globale predefinito"
            },
            "draft": {
                "title": "Bozza",
                "save": "Salvare la bozza",
                "delete": "Cancellare la bozza",
                "confirm_before_delete_msg": "È sicuro di voler eliminare questa bozza in modo permanente?",
                "confirm_before_delete_title": "Cancellare la bozza",
                "confirm_before_delete_btn": "Cancellare"
            },
            "punchout": {
                "pending_msg": "Ci sono prodotti in sospeso da Punchout.",
                "error_title": "Errore di perforazione",
                "error_msg": "Si è verificato un errore. Controlli le impostazioni di Punch-out o contatti una persona con diritti di amministratore.",
                "error_start_url_msg": "Non è stato fornito un URL di avvio, non è possibile avviare il Punch-out.",
                "error_invalid_domain_msg": "Le credenziali non sono valide. Controlla la configurazione del punch-out o contatta l'amministratore.",
                "error_invalid_credentials_msg": "{provider} ha rifiutato l'accesso per l'e-mail \"{email}\" perché il dominio \"{domain}\" non è abilitato nell'account {provider}. Pertanto, il punch-out non può essere avviato.",
                "no_config": "La preghiamo di impostare prima la configurazione per utilizzare il Punch-out.",
                "no_config_by_client": "Questo fornitore non è consentito per l'azienda attualmente selezionata. <br>Si prega di selezionare un'azienda compatibile o di modificare le impostazioni.",
                "pending_dialog": {
                    "title": "Prodotti in attesa da Punchout",
                    "add_products": "Aggiungi all'ordine",
                    "add_all_products": "Aggiungi tutti all'ordine",
                    "delete_products": "Rimuovi i prodotti"
                },
                "log_dialog": {
                    "title": "Richiesta/Risposta {supplier_name}",
                    "request": "Richiesta",
                    "response": "Risposta",
                    "no_log": "Nessun log",
                    "url": "Url",
                    "header": "Header",
                    "method": "Method",
                    "body": "Body"
                },
                "delete_dialog": {
                    "title": "Rimuova i prodotti da {fornitore} #{index}",
                    "info1": "Desidera davvero rimuovere tutti i seguenti prodotti da {fornitore} #{index}?",
                    "info2": "Questa azione non può essere annullata.",
                    "delete_btn": "Rimuovere"
                },
                "loading": "Completi la selezione del prodotto nel pop-up aperto. Se non appare alcun pop-up, deve prima autorizzarlo.",
                "can_not_edit": "I prodotti eliminati non possono essere modificati. Esegua nuovamente il Punch-out o cancelli l'intero carrello.",
                "no_provider_found": "Purtroppo, il fornitore di Punch-out selezionato non è ancora supportato."
            },
            "download_pdf": {
                "title": "Scarica PDF",
                "confirm_btn": "Conferma",
                "title_confirm_save_changes": "Salva dati non salvati",
                "text_confirm_save_changes": "Desideri salvare i dati non salvati e applicarli al documento d'acquisto?",
                "invalid_form": "Si prega di compilare tutti i campi obbligatori nel modulo prima di procedere con l'azione."
            },
            "lines": {
                "no_line": "Non sono stati selezionati prodotti, la preghiamo di aggiungere prodotti.",
                "add_lines_from_contract": "Aggiungi tutti gli articoli dal contratto",
                "show_all_info": "Vista avanzata",
                "invoice": {
                    "title": "Fattura",
                    "created_at": "Registrato",
                    "date": "Data della fattura",
                    "created_by": "Creato da"
                },
                "automatic_order": "Inviare elettronicamente",
                "automatic_ordered": "Inviato elettronicamente",
                "supplier_connect_order": "Invia via SupplierConnect",
                "manual_order_confirmation": "Conferma manualmente",
                "confirm_order": "Confermare l'ordine",
                "finish_order": "Ordine di finitura",
                "order_finished": "Ordine completato",
                "confirm_order_tooltip": "Si prega di notare che è necessario <b>inviare l'ordine al fornitore via e-mail</b>, l'ordine non verrà <b>trasmesso elettronicamente.</b>",
                "ordered_at": "Trasmesso",
                "ordered_by": "Da",
                "confirm_receipt": "Confermare la ricezione della merce",
                "no_cost_center": "Nessun Centro di costo",
                "include_taxes": "IVA inclusa",
                "budget": "Bilancio",
                "no_budget": "Nessun budget",
                "no_product_group": "Nessun gruppo di prodotti",
                "no_ledger_account": "Nessun conto contabile",
                "select_product": "Selezione dei prodotti",
                "quantity_to_show": "ricevuto: <b>{quantity_received}/{quantity}</b>",
                "delivery_completed": "Posizione completata",
                "from": "da",
                "item_number": "Codice articolo. #",
                "delete_msg": "È sicuro di voler rimuovere questo prodotto?",
                "delete_title": "Rimuovi il prodotto",
                "delete_btn": "Rimuovere",
                "automatic_order_dialog": {
                    "confirm_order": "Inviare l'ordine",
                    "confirm_order_btn": "Inviare",
                    "finish_order": "Ordine di finitura",
                    "finish_order_btn": "Finitura",
                    "info1": "Vuole <span style=\"font-weight: bold\">inviare elettronicamente</span> questo ordine al fornitore <span style=\"font-weight: bold\">ora</span>?",
                    "info2": "Questa azione non può essere annullata."
                },
                "order_dialog": {
                    "confirm_order": "Confermare l'ordine",
                    "confirm_order_btn": "Confermare",
                    "finish_order": "Ordine di finitura",
                    "finish_order_btn": "Finitura",
                    "info1": "Ha trasmesso l'ordine al fornitore (ad esempio, via e-mail o fax)?",
                    "info2": "Questa azione non può essere annullata."
                },
                "more_actions": {
                    "delete_products": "Rimuovi i prodotti",
                    "add_external_id": "Aggiungere il numero d'ordine esterno",
                    "download_pdf": "Ordine (PDF)",
                    "download_pdf_with_attachments": "Ordine incluso allegato PDF",
                    "write_email": "Comporre l'e-mail",
                    "email_with_pdf": "E-Mail con PDF",
                    "show_cxml": "Mostra Punchout CXML"
                },
                "file": {
                    "open_btn": "Aprire il PDF",
                    "add_btn": "Aggiungi PDF",
                    "upload_info1": "Trascini qui <br>o <br>selezioni il file</em>.",
                    "upload_info2": "File PDF fino a 30MB.",
                    "delete_msg": "Vuole davvero rimuovere questo documento?",
                    "delete_title": "Rimuovi documento",
                    "delete_btn": "Rimuovere",
                    "delete_error_msg": "Non è stato possibile rimuovere il documento."
                }
            },
            "validation": {
                "delivery_date_format": "Inserisca una data di consegna.",
                "client_id_required": "Selezioni un'azienda.",
                "department_id_required": "Selezioni un reparto.",
                "department_id_required_client_missing": "Prima seleziona l'azienda.",
                "cost_center_id_required": "Selezioni un centro di costo.",
                "cost_center_id_required_filters_missing": "Prima seleziona l'azienda e il dipartimento.",
                "cost_center_id_required_department_missing": "Prima seleziona il dipartimento.",
                "cost_center_id_required_client_missing": "Prima seleziona l'azienda.",
                "ledger_account_id_required": "Selezionare un conto contabile.",
                "consignee_id_required": "La preghiamo di selezionare una persona responsabile.",
                "delivery_address_id_required": "Selezioni un indirizzo di consegna.",
                "billing_address_text_required": "L'indirizzo di fatturazione manca nei dati aziendali.",
                "usage_type_required": "Seleziona un ritmo.",
                "payment_timing_required": "Seleziona un tipo di pagamento."
            },
            "tour": {
                "main": {
                    "description": "Nei primi campi, specifica un nome per la richiesta d'ordine, insieme alla tua azienda e al reparto per cui deve essere effettuato l'ordine. Il reparto viene filtrato in base all'azienda e il centro di costo in base al reparto.",
                    "organization": "Specifichi l'azienda, il reparto e il centro di costo per l'ordine di acquisto. L'elenco dei reparti è filtrato dall'azienda selezionata e l'elenco dei centri di costo è filtrato dal reparto selezionato.",
                    "address": "L'indirizzo di consegna sarà fornito al fornitore. Può scegliere tra gli indirizzi dell'azienda, della persona incaricata di ricevere la merce e i suoi indirizzi personali.",
                    "total": "Qui può vedere il valore totale del suo ordine d'acquisto, che è la somma dei prodotti selezionati.",
                    "delivery_date": "La data di consegna può essere registrata dopo il ricevimento della merce a scopo di documentazione. Non sarà inviata al fornitore.",
                    "product_selector": "Questo indica chi è responsabile della selezione del prodotto nella fase successiva. Dipende da vari ruoli predefiniti, per maggiori dettagli clicchi sull'icona informativa.",
                    "order_sender": "Questo mostra chi è responsabile dell'inserimento degli ordini, che dipende da vari ruoli predefiniti. Per maggiori dettagli, clicchi sull'icona Info.",
                    "consignee": "Selezioni la persona che riceverà la merce e confermi la ricezione nella fase finale dell'ordine di acquisto per completare il processo.",
                    "approvers": "Qui vede se è stata impostata l'approvazione per il centro di costo selezionato. Può anche aggiungere persone per l'approvazione.",
                    "product_search": "Qui può cercare un prodotto nel catalogo prodotti interno e aggiungerlo all'ordine di acquisto.",
                    "punchout": "Qui può selezionare i prodotti da marketplace integrati come Amazon o Mercateo. La selezione dei prodotti può essere trasmessa elettronicamente al marketplace dopo l'approvazione.",
                    "new_product": "Se il prodotto desiderato non è presente nel catalogo prodotti, può aggiungerlo all'ordine di acquisto qui.",
                    "save_btn": "Dopo aver inserito tutte le informazioni richieste, può avviare il processo dell'ordine d'acquisto e passare alla fase successiva."
                },
                "product": {
                    "pdf": "Qui può aggiungere documenti al prodotto.",
                    "remove": "Può anche rimuovere i prodotti dalla selezione cliccando qui.",
                    "more_actions": "Può documentare qui il numero d'ordine esterno al momento della ricezione.",
                    "tabs": "Qui può raggruppare la vista dei suoi prodotti per fornitore, centro di costo o gruppo di prodotti.",
                    "expand_view": "Qui può mostrare o nascondere le impostazioni avanzate per i prodotti e selezionare un centro di costo, un indirizzo di consegna o un gruppo di prodotti."
                },
                "new_product": {
                    "name": "Fornisca un nome significativo per il prodotto.",
                    "number": "Può anche inserire un numero di articolo per il prodotto.",
                    "supplier": "Selezioni il fornitore presso il quale il prodotto è offerto o presso il quale deve essere ordinato.",
                    "price": "Specifichi un'aliquota fiscale e un prezzo netto o lordo. L'altro prezzo sarà calcolato utilizzando l'aliquota fiscale.",
                    "unit": "Specificare l'unità di misura del prodotto, come \"articoli\", \"kg\" o \"litri\".",
                    "url": "Può aggiungere un'immagine URL per il prodotto e un link alla pagina del prodotto nel negozio, se disponibile.",
                    "offer": "Se esiste un'offerta per il prodotto, può inserire qui il numero e la data dell'offerta per visualizzarli sul PDF dell'ordine.",
                    "should_save": "Qui sceglie di aggiungere il prodotto creato al catalogo prodotti. Questo assicura che questo prodotto specifico sarà disponibile per gli ordini futuri.",
                    "save_btn": "Aggiunga il prodotto all'ordine d'acquisto quando ha inserito tutte le informazioni."
                },
                "cost_center_view": "I centri di costo possono anche essere assegnati a singoli prodotti in un ordine di acquisto. Gli indirizzi di consegna associati al centro di costo possono poi essere selezionati per il prodotto.",
                "product_group_view": "Ogni prodotto può essere assegnato ad un gruppo di prodotti. La persona responsabile del gruppo di prodotti riceverà un compito nella timeline per modificare o confermare la selezione del prodotto.",
                "send_order": {
                    "send_btn": "Nella fase di conferma dell'ordine, può inviare elettronicamente l'ordine o confermare l'ordine effettuato via e-mail con il fornitore.",
                    "more_actions": "Nelle opzioni per il fornitore selezionato, può generare un PDF d'ordine o un'e-mail con o senza PDF d'ordine per il fornitore. In questo modo, potrà effettuare l'ordine all'azienda o fare una richiesta via e-mail."
                },
                "delivery_btn": "Se ha ricevuto una consegna parziale o l'intero ordine, può indicarlo qui. Le posizioni possono anche essere contrassegnate come completate. Anche la conferma della ricezione della merce sarà annotata nella timeline."
            }
        }
    },
    "quantity": "Quantità",
    "price_netto": "Prezzo netto",
    "price_brutto": "Prezzo lordo",
    "unit": "Unità",
    "default_unit": "Articolo",
    "tenant": {
        "tab_general": "Generale",
        "description": "Inquilino",
        "main_language": "Lingua di fallback",
        "show_invoices": "Mostra menu fatture",
        "monthly_document_limit": "Documenti al mese",
        "base_price": "Prezzo base",
        "price_extra_document": "Prezzo di ogni documento aggiuntivo",
        "monthly_procurement_limit": "Ordini di acquisto al mese in prezzo base",
        "monthly_invoice_limit": "Fatture al mese nel Prezzo Base",
        "base_price_procurement": "Ordini di acquisto Prezzo base",
        "base_price_invoice": "Fatture Prezzo base",
        "price_extra_procurement": "Prezzo per ogni ordine di acquisto aggiuntivo",
        "price_extra_invoice": "Prezzo per ogni fattura aggiuntiva",
        "invoice_recognition_unit_price": "Prezzo per documento del riconoscimento delle fatture",
        "invoice_recognition_custom_field_unit_price": "Prezzo per documento con campi personalizzati",
        "ai_validation_unit_price": "Prezzo per documento della validazione AI con scoring",
        "easybill_id": "ID Easybill",
        "bank_account": "Numero di conto",
        "bank_account_owner": "Titolare del conto",
        "bank_bic": "BIC",
        "bank_country": "Paese della banca",
        "bank_code": "Codice bancario",
        "bank_iban": "IBAN",
        "bank_name": "Nome della banca",
        "address": "Indirizzo di fatturazione",
        "sepa_agreement": "Accordo di addebito diretto SEPA",
        "sepa_agreement_date": "SEPA - Data di iscrizione del mandato",
        "sepa_mandate_reference": "Riferimento del mandato",
        "automatic_billing": "Generazione automatica della fatturazione",
        "automatic_billing_mail": "Invia automaticamente la fatturazione via e-mail",
        "bank": "Connessione bancaria",
        "datev": "DATEV",
        "billing_address_name": "Azienda",
        "billing_address_consignee_name": "Nome del destinatario",
        "billing_address_street": "Via e numero.",
        "billing_address_zipcode": "Codice postale",
        "billing_address_city": "Città",
        "billing_address_state": "Stato",
        "billing_address_country": "Paese",
        "billing_address_phone": "Numero di telefono",
        "contact_email": "Contatto Email",
        "billing_email": "Email di fatturazione",
        "contact": "Informazioni di contatto",
        "sepa": "Addebito diretto SEPA",
        "add_sepa": "Aggiungere l'addebito diretto SEPA",
        "remove_sepa": "Revoca dell'addebito diretto SEPA",
        "import_invoice_email": "Importazione automatica delle fatture via e-mail",
        "send_email_notifications": "Inviare notifiche e-mail",
        "storage_usage": "Utilizzo dello spazio di archiviazione",
        "storage_current": "Utilizzo attuale",
        "storage_included_gb": "Spazio incluso (GB)",
        "storage_price_per_gb": "Prezzo per ogni GB aggiuntivo",
        "storage_free_included": "Volume gratuito incluso",
        "storage_billable": "GB fatturabili",
        "storage_billable_price": "Costo extra mensile",
        "storage_billing_hint": "I primi {included} GB sono gratuiti. Ogni ulteriore GB iniziato viene addebitato a {price}.",
        "tab_mailbox": "Caselle postali",
        "debit_credit_reverse": "Scambia conto/contropartita",
        "default_decimal_places": "Cifre decimali predefinite",
        "tab_sso": "Single Sign-On (SAML)",
        "sso_saml_enabled": "Attiva login SAML",
        "sso_saml_provider_label": "Etichetta pulsante di accesso",
        "sso_saml_entity_id": "Entity ID Identity Provider",
        "sso_saml_sso_url": "URL SSO Identity Provider",
        "sso_saml_x509_cert": "Certificato X509 Identity Provider (PEM)",
        "sso_saml_sp_entity_id": "Entity ID Service Provider (opzionale)",
        "sso_saml_attr_email": "Nome attributo e-mail (opzionale)",
        "sso_saml_help": "Abilitare solo dopo aver ricevuto i valori dal proprio identity provider.",
        "sso_saml_validation_required": "Compili tutti i campi SAML obbligatori."
    },
    "datev_access": {
        "description": "Integrazione DATEV",
        "label_log": "Azienda DATEV (datev_client_id)",
        "label_log_fields": "datev_client_id",
        "connected_info": "Connessione a DATEV stabilita.",
        "disconnected_info": "Connessione a DATEV rimossa.",
        "connected_client_info": "Connessione con l'azienda DATEV {datev_client_id} stabilita.",
        "disconnected_client_info": "Connessione con l'azienda DATEV {datev_client_id} disattivata."
    },
    "ms365_access": {
        "description": "Integrazione D365",
        "connected_info": "Connessione a D365 stabilita.",
        "disconnected_info": "Connessione a D365 rimossa.",
        "data_loaded_info": "Dati da D365 caricati manualmente.",
        "journal_created_info": "Il journal D365 è stato aggiunto.<br>Nome del Journal: {journal_name} <br>URL dell'org: {org_url}.",
        "journal_edited_info": "Il nome del journal D365 è stato modificato: {journal_name}."
    },
    "client": {
        "description": "Azienda",
        "alias": "Alias azienda",
        "tab_invoice_recognition_prompt": "Prompt personalizzato",
        "min_approval": "Numero minimo di approvatori",
        "branch_required": "La filiale è richiesta per il modulo di fatturazione.",
        "department_required": "Il reparto è richiesto per il modulo della fattura.",
        "cost_center_required": "Il centro di costo è obbligatorio per il modulo d'ordine.",
        "client_number": "Numero",
        "consultant_number": "Numero del consulente",
        "ledger_account_length": "Lunghezza del conto contabile",
        "vat_number": "ID IVA",
        "address_name": "Nome",
        "consignee": "Nome del destinatario - Indirizzo di fatturazione",
        "dropoff_location": "Nome del luogo di consegna - Indirizzo di fatturazione",
        "address": "Via e numero civico - Indirizzo di fatturazione",
        "address_complement": "Via 2 - Indirizzo di fatturazione",
        "country": "Paese - Indirizzo di fatturazione",
        "zipcode": "Codice postale - Indirizzo di fatturazione",
        "city": "Città - Indirizzo di fatturazione",
        "phone_country_code": "Codice paese del telefono - Indirizzo di fatturazione",
        "phone_number": "Numero di telefono - Indirizzo di fatturazione",
        "can_delete_document_directly": "I documenti possono essere eliminati senza cancellare.",
        "default_product_tax": "Aliquota fiscale standard (%)",
        "default_product_currency": "Valuta predefinita",
        "default_product_unit": "Unità predefinita",
        "invoice_recognition_prompt": "Prompt personalizzato per il riconoscimento delle fatture",
        "form_sequence": "name,email,client_number,currency,min_approval,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id,user_invoice_manual_check_id,user_invoice_clearing_id",
        "page": {
            "tab_general": "Generale",
            "tab_bank_data": "Dati bancari",
            "tab_billing_address": "Indirizzo di fatturazione",
            "tab_shipping_address": "Indirizzi di spedizione",
            "tab_default_roles": "Ruoli predefiniti",
            "tab_communication_signature": "Firma comunicazione",
            "tab_permissions": "Permessi",
            "tab_departments": "Reparti",
            "tab_cost_centers": "Centri di costo",
            "tab_ledger_accounts": "Conti del libro mastro",
            "tab_required_fields": "Campi obbligatori",
            "tab_datev_csv": "DATEV CSV Export",
            "new": "Nuova azienda",
            "invoice_recognition_prompt_placeholder": "Ad es. applicare queste istruzioni durante il riconoscimento delle fatture per questa azienda.",
            "select_logo": "Seleziona il logo",
            "select_logo_tooltip_content": "Aggiungi un logo che verrà stampato sui documenti degli ordini approvati. È meglio utilizzare un file immagine con sfondo trasparente.",
            "communication_signature_html": "Firma comunicazione fornitore",
            "communication_signature_html_hint": "Questa firma HTML viene precompilata automaticamente nella comunicazione esterna con il fornitore di un documento. La formattazione HTML e supportata.",
            "communication_signature_editor_visual": "Visuale",
            "communication_signature_editor_html": "HTML",
            "communication_signature_editor_visual_disabled_hint": "L'editor visuale è disattivato per questo codice HTML per conservarne la formattazione.",
            "communication_signature_placeholders": "Placeholder",
            "communication_signature_placeholders_hint": "Clicchi su un placeholder per inserirlo nella posizione corrente del cursore nell'editor HTML.",
            "communication_signature_placeholder_first_name": "Nome dipendente",
            "communication_signature_placeholder_last_name": "Cognome dipendente",
            "communication_signature_placeholder_name": "Nome completo dipendente",
            "communication_signature_placeholder_email": "E-mail dipendente",
            "communication_signature_placeholder_company_name": "Nome azienda",
            "communication_signature_placeholder_company_email": "E-mail azienda",
            "communication_signature_preview": "Anteprima della firma",
            "communication_signature_preview_hint": "Usa dati di esempio del dipendente e i dati attuali dell'azienda, se disponibili.",
            "communication_signature_preview_empty": "Aggiunga una firma qui sopra per vedere l'anteprima.",
            "select_letterhead": "Seleziona intestazione",
            "select_letterhead_tooltip_content": "Aggiungi un'intestazione che verrà stampata sul documento d'ordine delle tue approvazioni.",
            "billing_address": "Indirizzo di fatturazione",
            "state_placeholder": "Select state/region",
            "state_tooltip_content": "Used to calculate holidays.",
            "roles": "Predefiniti dei ruoli generali",
            "user_clearing_id_tooltip_content": "Per il chiarimento nei processi di ordinazione.",
            "user_invoice_clearing_id_tooltip_content": "Per il chiarimento durante la fatturazione.",
            "bank_accounts_title": "Conti bancari",
            "bank_accounts_hint": "Qui può gestire più conti bancari aziendali. IBAN e BIC vengono validati quando inseriti.",
            "bank_accounts_empty": "Non sono ancora stati aggiunti conti bancari aggiuntivi.",
            "add_bank_account": "Aggiungi conto bancario",
            "bank_account_label": "Descrizione",
            "bank_account_holder": "Intestatario del conto",
            "bank_account_bank_name": "Nome della banca",
            "bank_account_iban": "IBAN",
            "bank_account_bic": "BIC",
            "no_selection": "Non è stata scelta un'azienda specifica, quindi è condivisa da tutti.",
            "validation": {
                "name_required": "La preghiamo di inserire un nome.",
                "name_max_length": "Non deve superare i 50 caratteri.",
                "email_invalid": "Inserisca un indirizzo e-mail valido.",
                "iban_invalid": "Inserisca un numero IBAN valido.",
                "bic_invalid": "Inserisca un BIC valido.",
                "bank_account_iban_required": "Inserisca un IBAN per questo conto bancario.",
                "bank_account_iban_duplicate": "Questo IBAN è già stato aggiunto.",
                "bank_accounts_invalid": "Controlli la sezione dei conti bancari.",
                "client_number_invalid": "Inserisca un numero valido.",
                "min_approval_invalid": "La preghiamo di inserire un numero valido.",
                "address_incomplete": "La preghiamo di compilare i dati obbligatori relativi all'indirizzo.",
                "delivery_address_missing": "Aggiunga almeno un indirizzo di consegna.",
                "error_address_incomplete": "Si prega di completare i dati obbligatori per l'indirizzo di consegna."
            },
            "tour": {
                "name": "Inizia inserendo il nome della sua azienda.",
                "email": "Inserisca l'e-mail della sua azienda alla quale, ad esempio, deve essere inviata la consegna della fattura.",
                "timeline_assignment": "Può opzionalmente pre-assegnare persone responsabili per le varie fasi degli ordini di acquisto per l'azienda. Ad esempio, se c'è sempre una persona responsabile dell'approvazione degli ordini.",
                "billing_address": "L'indirizzo di fatturazione è necessario per l'ordine e può essere inviato al fornitore con l'ordine.",
                "shipping_address": "Qui può inserire uno o più indirizzi di consegna che possono essere selezionati in un ordine di acquisto.",
                "btn_save": "Dopo aver inserito tutte le informazioni richieste, aggiunga la società."
            }
        }
    },
    "client_form_config": {
        "field": "Campo",
        "form": "Modulo",
        "required": "Obbligatorio",
        "not_available_for_d365": "La configurazione dei campi obbligatori per le fatture non è disponibile poiché, per l'integrazione con D365, vengono utilizzate le regole di convalida di D365."
    },
    "department": {
        "description": "Reparto",
        "code": "Numero",
        "form_sequence": "name,code,client_id,user_select_product_id,user_send_order_id,user_clearing_id,user_consignee_id",
        "page": {
            "new": "Nuovo Reparto",
            "tab_general": "Generale",
            "tab_clients": "Aziende",
            "tab_cost_centers": "Centri di costo",
            "tab_approvers": "Approvatori",
            "tab_permissions": "Gruppi di autorizzazioni",
            "tab_employees": "Dipendenti",
            "tab_assignment": "Assegnazioni di ruolo",
            "validation": {
                "name_required": "La preghiamo di inserire un nome.",
                "email_required": "Inserisca un indirizzo e-mail valido."
            },
            "tour": {
                "name": "Inizia inserendo il nome del reparto.",
                "client": "Se assegna il reparto a un'azienda, il reparto può essere selezionato solo all'interno di quell'azienda quando crea un ordine d'acquisto.",
                "timeline_assignment": "Può designare i responsabili delle varie fasi degli ordini di acquisto per il reparto. Ad esempio, se una persona specifica è sempre responsabile della ricezione della merce per ogni reparto.",
                "cost_centers": "Qui può assegnare i centri di costo esistenti al reparto. Se non assegna alcun centro di costo, durante la creazione di ordini di acquisto per il reparto, potranno essere selezionati solo i centri di costo non assegnati ad alcun reparto.",
                "employees": "Può aggiungere diverse persone che fanno parte di questo reparto. Quando le persone di questo reparto creano ordini di acquisto, il reparto sarà precompilato.",
                "btn_save": "Una volta fornite tutte le informazioni, aggiunga il reparto."
            }
        }
    },
    "permission": {
        "description": "Gruppo di autorizzazione",
        "name": "Nome",
        "page": {
            "new": "Nuovo gruppo di autorizzazioni",
            "validation": {
                "name_required": "La preghiamo di inserire un nome."
            },
            "tour": {
                "name": "Qui può creare un gruppo di autorizzazioni. Può poi assegnare questo gruppo a varie entità (reparti, prodotti del catalogo prodotti, gruppi di prodotti, ecc.) Può anche assegnare uno o più gruppi di autorizzazioni alle persone. Se un'entità non deve avere alcuna restrizione di autorizzazione, non assegni un gruppo."
            },
            "no_selection": "Non è stata selezionata alcuna autorizzazione, quindi è visibile a tutti."
        }
    },
    "task_group": {
        "description": "Gruppo di compiti",
        "name": "Nome",
        "priority_approval_limit": "Livello di priorità del limite di approvazione",
        "page": {
            "new": "Nuovo gruppo di compiti",
            "validation": {
                "name_required": "Si prega di inserire un nome."
            },
            "tour": {
                "name": "Qui puoi creare un gruppo di compiti. Puoi quindi assegnare compiti a questo gruppo."
            },
            "no_selection": "Nessun gruppo di compiti selezionato"
        }
    },
    "budget": {
        "description": "Bilanci",
        "label_log": "value€ (start - end)",
        "label_log_fields": "value,start,end",
        "value": "Importo",
        "type_value": "currency",
        "start": "Valido da",
        "end": "Valido fino a",
        "add_foreach_ledger_account": "Inserisci tutti i conti contabili",
        "component": {
            "validation": {
                "end_date_before_start_date": "La data di fine non può essere precedente alla data di inizio.",
                "end_date_required": "La data di fine non può essere vuota.",
                "time_overlap": "I bilanci non possono sovrapporsi nel tempo.",
                "field_missing": "Inserisca tutte le informazioni."
            }
        }
    },
    "address": {
        "description": "Indirizzo di consegna",
        "description_plural": "Indirizzi di consegna",
        "address_name": "Nome",
        "consignee": "Nome del destinatario",
        "dropoff_location": "Nome della località di consegna",
        "address": "Via e numero.",
        "address_complement": "Via 2",
        "complement": "Via 2",
        "country": "Paese",
        "zipcode": "Codice postale",
        "city": "Città",
        "phone_country_code": "Codice paese del telefono",
        "phone_number": "Numero di telefono",
        "component": {
            "new": "Nuovo indirizzo di consegna",
            "copy_btn": "Copia indirizzo di fatturazione",
            "required_field": "La preghiamo di compilare i campi obbligatori dell'indirizzo.",
            "phone_required": "La preghiamo di inserire entrambe le informazioni.",
            "no_address": "Nessun indirizzo di consegna"
        }
    },
    "cost_center": {
        "name": "Nome",
        "number": "Numero",
        "free_budget": "Budget disponibile",
        "description": "Centro di costo",
        "label_log": "cost_center_name",
        "budgets": "Bilanci",
        "form_sequence": "name,number",
        "page": {
            "new": "Nuovo Centro di costo",
            "department_tooltip_content": "Quali reparti sono autorizzati a utilizzare questo centro di costo.",
            "tab_general": "Generale",
            "tab_budgets": "Budget",
            "tab_shipping_address": "Indirizzi di spedizione",
            "tab_approvers": "Approvatori",
            "tab_permissions": "Gruppi di autorizzazioni",
            "tab_departments": "Dipartimenti",
            "tab_clients": "Aziende",
            "validation": {
                "name_required": "La preghiamo di inserire un nome.",
                "number_required": "La preghiamo di inserire un numero.",
                "number_length": "Deve essere lungo al massimo 36 caratteri e può avere solo spazi al centro.",
                "number_exists": "Il numero esiste già."
            },
            "tour": {
                "name_number": "Fornisca un nome e un numero unico per il centro di costo.",
                "budget": "È possibile assegnare diversi budget al proprio centro di costo e allocare i budget a un conto contabile.",
                "approver": "Definisce qui chi deve approvare gli ordini di acquisto con questo centro di costo. È possibile aggiungere altri approvatori al momento della creazione degli ordini di acquisto.",
                "department": "Qui può definire in quali reparti può essere utilizzato il centro di costo. Se non aggiunge alcun reparto, il centro di costo può essere selezionato in tutti i reparti.",
                "btn_save": "Dopo aver fornito tutte le informazioni necessarie, aggiunga il centro di costo al database."
            }
        }
    },
    "bank_statement": {
        "abbr": "BS",
        "description": "Carica estratto conto",
        "transactions_menu": "Transazioni estratto conto",
        "page": {
            "upload": {
                "title": "Carica estratto conto",
                "info": "Carichi un estratto conto strutturato.",
                "client_hint": "L'azienda selezionata verrà assegnata all'estratto conto caricato e alle sue transazioni.",
                "client_required": "Selezioni un'azienda prima del caricamento.",
                "supported_hint": "Supporta file XML camt.052/.053/.054 e file di testo MT940.",
                "error_invalid": "I formati supportati sono XML camt.052, camt.053, camt.054 e gli estratti conto testuali MT940.",
                "abort_upload": "Annulla caricamento",
                "processing_in_background_notice": "L'estratto conto è stato salvato. {count} movimenti vengono ora elaborati in background.",
                "large_statement_notice": "L'estratto conto con {count} movimenti è stato caricato. L'abbinamento automatico è stato saltato per questo caricamento grande, così da non bloccare il caricamento.",
                "account_identifier_match_notice": "L'estratto conto caricato contiene solo l'identificativo del conto {identifier}, non un IBAN valido. Non è stato creato alcun nuovo conto bancario aziendale. L'identificativo corrisponde all'IBAN già presente {iban}.",
                "account_identifier_only_notice": "L'estratto conto caricato contiene solo l'identificativo del conto {identifier}, non un IBAN valido. Per questo caricamento non è stato creato alcun nuovo conto bancario aziendale.",
                "update_client_iban": "Aggiungi IBAN come nuovo conto",
                "continue_without_update": "Continua senza aggiungere il conto",
                "continue_upload": "Continua il caricamento",
                "statement_account_title": "Conto nell'estratto conto caricato",
                "statement_account_hint": "Questo IBAN è stato rilevato nell'estratto conto caricato.",
                "client_accounts_title": "Conti bancari aziendali attivi",
                "client_accounts_count": "{count} attivi",
                "client_accounts_table_label": "Etichetta",
                "client_accounts_table_bank": "Banca",
                "client_accounts_table_account_holder": "Intestatario del conto",
                "client_accounts_table_bic": "BIC",
                "client_accounts_table_iban": "IBAN",
                "client_iban_missing_title": "Conto bancario aziendale mancante",
                "client_iban_missing_intro": "Per {clientName} non è ancora stato salvato nei dati anagrafici alcun conto bancario aziendale attivo corrispondente.",
                "client_iban_mismatch_title": "Conto bancario aziendale diverso",
                "client_iban_mismatch_intro": "L'IBAN dell'estratto conto è diverso dai conti bancari aziendali attivi salvati nei dati anagrafici di {clientName}.",
                "client_iban_document": "IBAN dell'estratto conto: {iban}",
                "client_iban_masterdata": "Conto bancario aziendale esistente: {iban}",
                "client_iban_masterdata_empty": "Nei dati anagrafici non è ancora salvato alcun conto bancario aziendale attivo.",
                "client_iban_update_question": "Vuole aggiungere questo IBAN come nuovo conto bancario aziendale prima del caricamento?",
                "client_iban_readonly_hint": "Può continuare il caricamento senza creare un nuovo conto bancario aziendale."
            },
            "form": {
                "title": "Estratto conto",
                "back_to_upload": "Nuovo caricamento",
                "delete": "Elimina estratto conto",
                "delete_confirm_title": "Elimina estratto conto",
                "delete_confirm_message": "Vuole davvero eliminare questo estratto conto? Gli abbinamenti esistenti verranno scollegati e gli stati di pagamento derivati dall'estratto conto verranno ripristinati se provengono solo da questo estratto.",
                "delete_success": "L'estratto conto è stato eliminato.",
                "delete_error": "Non è stato possibile eliminare l'estratto conto.",
                "download": "Scarica file",
                "format": "Formato",
                "status": "Stato",
                "account_iban": "Conto",
                "account_owner": "Intestatario del conto",
                "period": "Periodo",
                "matched_entries": "Abbinati automaticamente",
                "processing_title": "L'estratto conto è in elaborazione",
                "processing_notice": "Il caricamento è già stato salvato. {inserted} di {count} movimenti sono già stati importati; il resto è ancora in importazione e abbinamento in background. Usi il pulsante di aggiornamento quando vuole controllare l'avanzamento corrente.",
                "processing_matching_title": "Movimenti importati, abbinamento ancora in corso",
                "processing_matching_notice": "Tutti i {count} movimenti sono già stati importati e ora vengono abbinati in background. Finora {matched} movimenti sono stati abbinati automaticamente. Usi il pulsante di aggiornamento quando vuole controllare l'avanzamento corrente.",
                "processing_refresh": "Aggiorna stato",
                "processing_finished_notice": "L'elaborazione dell'estratto conto è terminata.",
                "entries": "Movimenti",
                "entry_index": "N.",
                "booking_date": "Data registrazione",
                "value_date": "Data valuta",
                "amount": "Importo",
                "counterparty": "Controparte",
                "reference": "Causale",
                "match_status": "Abbinamento",
                "matched_invoice": "Fattura abbinata",
                "status_labels": {
                    "processing": "In elaborazione",
                    "processed": "Elaborato",
                    "partial": "Parzialmente elaborato",
                    "failed": "Non riuscito"
                },
                "match_status_labels": {
                    "unmatched": "Non abbinato",
                    "matched": "Abbinato",
                    "ambiguous": "Ambiguo",
                    "ignored": "Ignorato"
                }
            },
            "list": {
                "identifier": "Identificativo",
                "uploaded_at": "Caricato il",
                "empty": "Nessun estratto conto caricato finora."
            },
            "transactions": {
                "title": "Transazioni estratto conto",
                "subtitle": "Panoramica centrale di tutti i movimenti dell'estratto conto. Selezioni prima un'azienda; il filtro fornitore e facoltativo.",
                "clear_filters": "Reimposta filtri",
                "client_required_notice": "Selezioni prima un'azienda per visualizzare le transazioni.",
                "empty": "Nessuna transazione trovata.",
                "no_permission": "Non dispone dell'autorizzazione per aprire questa vista.",
                "active_filters": "Filtri attivi",
                "transaction_date": "Data transazione",
                "direction": "Tipo",
                "incoming": "Entrata",
                "outgoing": "Uscita",
                "client": "Azienda",
                "supplier": "Fornitore",
                "account_filter": "Conto",
                "statement": "Apri estratto conto",
                "amount_filter": "Tipo importo",
                "transaction_type": "Tipo transazione",
                "text_search": "Filtro testo",
                "text_search_placeholder": "Cerca nelle colonne selezionate",
                "text_search_columns": "Colonne di ricerca",
                "text_search_columns_placeholder": "Seleziona colonne",
                "export": "Esporta XLSX",
                "export_success": "L'esportazione XLSX e stata creata.",
                "export_error": "Non e stato possibile creare l'esportazione XLSX.",
                "export_empty": "Non ci sono transazioni disponibili per i filtri correnti.",
                "export_end_balance": "Saldo finale",
                "export_adjustment_type": "Registrazione di compensazione",
                "export_adjustment_description": "Registrazione di compensazione per copertura mancante dell'estratto ({from} - {to})",
                "export_gap_description": "Copertura mancante dell'estratto ({from} - {to})",
                "transaction_type_labels": {
                    "transfer": "Bonifico",
                    "direct_debit": "Addebito diretto SEPA",
                    "card": "Pagamento con carta",
                    "standing_order": "Ordine permanente",
                    "fee": "Commissione",
                    "cash": "Contanti",
                    "refund": "Rimborso"
                },
                "description": "Descrizione",
                "coverage_gap_alert_title": "Rilevate lacune nella copertura degli estratti conto",
                "coverage_gap_alert_summary": "{days} giorno(i) nel periodo selezionato non sono coperti da alcun estratto conto caricato.",
                "coverage_gap_row_label": "Copertura mancante: {from} - {to} ({days} giorno(i))",
                "coverage_gap_row_context_between": "Lacuna tra {previous} e {next}.",
                "coverage_gap_row_context_before_first": "Nessun estratto conto precedente nel periodo selezionato. Prossimo estratto disponibile: {next}.",
                "coverage_gap_row_context_after_last": "Nessun estratto conto successivo nel periodo selezionato. Ultimo estratto disponibile: {previous}.",
                "coverage_gap_row_context_unknown": "Nessun estratto conto adiacente trovato per questa lacuna.",
                "coverage_gap_closing_balance_difference": "Differenza saldo finale A/B: {previous} -> {next} ({difference}).",
                "coverage_gap_closing_balance_difference_unavailable": "Differenza saldo finale A/B non disponibile per uno o entrambi gli estratti.",
                "manual_match": {
                    "action": "Azioni",
                    "assignment": "Assegnazione",
                    "details": "Dettagli",
                    "open": "Abbina",
                    "edit": "Modifica",
                    "dialog_title": "Abbina manualmente il pagamento",
                    "dialog_title_single": "Assegna transazione",
                    "dialog_title_split": "Ripartisci pagamento",
                    "eyebrow": "Abbinamento manuale del pagamento",
                    "single_option": "Abbina singolo..",
                    "split_option": "Ripartisci",
                    "bulk_actions_select": "Azioni di massa ({count})",
                    "bulk_action": "Assegna tipo di costo ({count})",
                    "bulk_dialog_title": "Assegna tipo di costo in massa",
                    "bulk_dialog_text": "Assegna direttamente questo tipo di costo a {count} transazioni selezionate. Le assegnazioni manuali esistenti verranno sostituite.",
                    "bulk_save": "Assegna tipo di costo",
                    "incoming_revenue_bulk_action": "Assegna tipo di ricavo",
                    "revenue_bulk_dialog_title": "Assegna tipo di ricavo in massa",
                    "revenue_bulk_dialog_text": "Assegna direttamente questo tipo di ricavo a {count} movimenti in entrata selezionati. Gli abbinamenti manuali esistenti verranno sostituiti.",
                    "revenue_bulk_save": "Assegna tipo di ricavo",
                    "filtered_batch_action": "Assegna filtrate in massa ({count})",
                    "filtered_batch_incoming_action": "Assegna entrate filtrate ({count})",
                    "filtered_batch_outgoing_action": "Assegna uscite filtrate ({count})",
                    "filtered_batch_empty": "Non ci sono transazioni filtrate disponibili per l'assegnazione in massa.",
                    "filtered_batch_direction_warning": "I risultati filtrati contengono sia entrate sia uscite. Restringi i filtri prima di usare l'assegnazione in massa.",
                    "filtered_batch_load_error": "Non e stato possibile preparare le transazioni filtrate per l'assegnazione in massa.",
                    "transaction_total": "Totale transazione",
                    "allocated_total": "Totale abbinato",
                    "remaining_difference": "Differenza residua",
                    "ready_to_save": "Totale coerente.",
                    "remaining_message": "Residuo: {amount}",
                    "allocations_title": "Ripartisci sulle fatture",
                    "allocations_subtitle": "Selezioni una o piu fatture e inserisca per ogni riga l'importo coperto da questa transazione.",
                    "add_invoice": "Aggiungi fattura",
                    "outgoing_invoice": "Fattura in uscita (pagamento cliente)",
                    "cost_type": "Tipo di costo",
                    "cost_type_bulk_action": "Assegna tipo di costo",
                    "invoice_gross": "Lordo fattura",
                    "match_amount": "Importo abbinato",
                    "use_transaction_total": "Usa totale transazione",
                    "use_invoice_gross": "Usa lordo",
                    "use_remaining": "Usa residuo",
                    "clear_matches": "Rimuovi abbinamento",
                    "save": "Salva abbinamento",
                    "alerts": {
                        "invoice_conflict_title": "Fattura già collegata a un'altra transazione",
                        "invoice_conflict_message": "Almeno una delle fatture selezionate è già assegnata a un'altra transazione bancaria.",
                        "invoice_conflict_hint": "Apri prima l'abbinamento esistente e modifica lì la ripartizione, oppure rimuovilo, prima di salvare questa transazione."
                    }
                }
            }
        }
    },
    "supplier": {
        "address": "Indirizzo",
        "alias": "Alias fornitore",
        "external_id": "DATEV ID",
        "supplier_number": "Numero fornitore",
        "client_number": "Numero cliente",
        "delivery_in_days": "Tempi di consegna in giorni lavorativi",
        "delivery_terms": "Termini di consegna",
        "payment_terms": "Termini di pagamento",
        "vat_number": "ID IVA",
        "city": "Città",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Paese della banca",
        "bank_account": "Numero di conto",
        "bank_code": "Codice bancario",
        "bank": "Banca",
        "discount_percentage": "Sconto 1 - percentuale",
        "discount_days": "Sconto 1 - giorni",
        "discount_percentage2": "Sconto 2 - percentuale",
        "discount_days2": "Sconto 2 - giorni",
        "invoice_recognition_prompt": "Prompt personalizzato per il riconoscimento delle fatture",
        "form_sequence": "name,email,city,address,external_id,delivery_terms,payment_terms,iban,bic,vat_number",
        "payment_method": "Metodo di pagamento",
        "payment_method_info": "Le fatture delle aziende fornitrici con il metodo di pagamento addebito diretto SEPA o carta di credito vengono contrassegnate come pagate direttamente",
        "page": {
            "new": "Nuovo fornitore",
            "department_tooltip_content": "Quali reparti sono autorizzati a utilizzare questo fornitore.",
            "delivery_in_days_tooltip_content": "Il tempo di consegna stimato serve per la ricezione della merce compito e-mail.",
            "notes_tooltip_content": "Questo promemoria viene visualizzato solo internamente su liftbase e non viene stampato sul PDF dell'ordine.",
            "external_id_tooltip_content": "L'ID del fornitore di un sistema di terze parti che ha integrato.",
            "client_number_tooltip_content": "Numero assegnato a voi da questo fornitore (opzionale).",
            "supplier_number_tooltip_content": "Numero che avete assegnato a questo fornitore.",
            "delivery_terms_tooltip_content": "I termini di pagamento e di consegna concordati con il fornitore saranno visualizzati sul PDF dell'ordine di acquisto.",
            "payment_terms_tooltip_content": "I termini di pagamento e di consegna concordati con il fornitore saranno visualizzati sul PDF dell'ordine di acquisto.",
            "tab_general": "Generale",
            "tab_delivery_info": "Informazioni sulla consegna",
            "tab_payment_info": "Informazioni di pagamento",
            "tab_permissions": "Gruppi di autorizzazioni",
            "tab_departments": "Dipartimenti",
            "tab_approvers": "Approvatori",
            "tab_clients": "ID specifici per azienda",
            "tab_invoice_recognition": "Valori predefiniti per il riconoscimento delle fatture",
            "tab_invoice_recognition_prompt": "Prompt personalizzato",
            "invoice_recognition_prompt_placeholder": "Ad es. utilizzare il \"codice del ticket\" come numero di fattura.",
            "default_clients_ids": "Se un'azienda non è elencata in questa tabella con ID specifici, <br>verranno utilizzati i seguenti ID predefiniti: <br>ID DATEV: {external_id} <br>Numero cliente: {client_number}.",
            "no_default_id": "Nessun ID predefinito disponibile.",
            "validation": {
                "name_required": "La preghiamo di inserire un nome.",
                "name_length": "Deve essere lungo al massimo 50 caratteri.",
                "email_invalid": "Inserisca un indirizzo e-mail valido.",
                "supplier_number_invalid": "Inserisca un numero valido.",
                "vat_number_invalid": "Può contenere numeri, lettere maiuscole e minuscole, punti, spazi e trattini bassi. Deve essere lungo al massimo 15 caratteri.",
                "iban_invalid": "Deve avere una lunghezza minima di 15 e massima di 34 caratteri. Non può contenere spazi. Inizia con due lettere maiuscole, seguite da 2 numeri e poi da 11 a 30 caratteri alfanumerici.",
                "bic_invalid": "Deve essere lungo almeno 8 e al massimo 11 caratteri e contenere solo lettere maiuscole e numeri. I primi sei caratteri devono essere lettere.",
                "external_id_length": "L'ID DATEV deve contenere solo numeri interi e non può essere inferiore a 10000."
            },
            "tour": {
                "name": "Inserisca il nome del fornitore.",
                "email": "L'indirizzo e-mail del fornitore viene utilizzato, ad esempio, per la preparazione dei messaggi e-mail per l'inserimento dell'ordine.",
                "address": "Qui può fornire l'indirizzo del fornitore.",
                "external_id": "L'ID esterno è il numero del fornitore memorizzato in un sistema esterno. Questo numero viene utilizzato nell'API.",
                "terms": "Inserisca i termini di pagamento e di consegna concordati con il fornitore. Queste informazioni saranno visualizzate sul PDF dell'ordine d'acquisto.",
                "btn_save": "Una volta inserite tutte le informazioni, salvi il fornitore qui."
            }
        }
    },
    "business_partner": {
        "address": "Indirizzo",
        "business_partner_number": "Numero",
        "delivery_in_days": "Tempi di consegna in giorni lavorativi",
        "delivery_terms": "Termini di consegna",
        "payment_terms": "Termini di pagamento",
        "vat_number": "Partita IVA",
        "city": "Città",
        "iban": "IBAN",
        "bic": "BIC",
        "bank_country": "Paese della banca",
        "bank_account": "Numero di conto",
        "bank_code": "Codice bancario",
        "bank": "Banca",
        "discount_percentage": "Sconto 1 - percentuale",
        "discount_days": "Sconto 1 - giorni",
        "discount_percentage2": "Sconto 2 - percentuale",
        "discount_days2": "Sconto 2 - giorni",
        "payment_method": "Metodo di pagamento",
        "payment_method_info": "I documenti con metodo di pagamento addebito diretto SEPA o carta di credito possono essere contrassegnati direttamente come pagati.",
        "page": {
            "new": "Aggiungi partner commerciale",
            "delivery_in_days_tooltip_content": "Il tempo di consegna viene salvato come dato anagrafico di questo partner commerciale.",
            "notes_tooltip_content": "Questa nota viene mostrata solo internamente in liftbase.",
            "business_partner_number_tooltip_content": "Numero assegnato da voi a questo partner commerciale.",
            "delivery_terms_tooltip_content": "Qui può memorizzare le condizioni di consegna concordate con il partner commerciale.",
            "payment_terms_tooltip_content": "Qui può memorizzare i termini di pagamento concordati con il partner commerciale.",
            "vat_number_tooltip_content": "La partita IVA aiuta ad associare i documenti a questo partner commerciale.",
            "name_tooltip_content": "Inserisca il nome del partner commerciale esattamente come deve apparire sui documenti.",
            "tab_general": "Generale",
            "tab_delivery_info": "Dati di consegna",
            "tab_payment_info": "Dati di pagamento",
            "tab_permissions": "Gruppi di autorizzazioni",
            "tab_clients": "Aziende",
            "import_legacy_suppliers_button": "Importa fornitori come partner",
            "import_legacy_suppliers_title": "Importare i fornitori come partner commerciali?",
            "import_legacy_suppliers_confirm": "Per ogni fornitore del tenant non ancora collegato a un partner commerciale, crea un partner (con riferimento al fornitore legacy), copia conti bancari, collegamenti aziende e gruppi di permessi, e aggiorna le fatture in uscita. I fornitori già importati vengono ignorati. È possibile eseguire di nuovo in sicurezza.",
            "import_legacy_suppliers_run": "Avvia importazione",
            "import_legacy_suppliers_loading": "Importazione fornitori in corso…",
            "import_legacy_suppliers_success": "Importazione completata. Nuovi partner: {inserted}. Ignorati (già collegati): {skipped}. Conti bancari aggiunti: {bankAccounts}. Fatture in uscita aggiornate (principale / riconosciuto): {invoicesBp} / {invoicesRec}. Collegamenti clienti: {clients}. Permessi: {permissions}.",
            "tab_invoice_recognition": "Predefiniti per il riconoscimento dei documenti",
            "validation": {
                "name_required": "La preghiamo di inserire un nome.",
                "name_length": "Deve essere lungo al massimo 50 caratteri.",
                "email_invalid": "Inserisca un indirizzo e-mail valido.",
                "vat_number_invalid": "Può contenere numeri, lettere maiuscole e minuscole, punti, spazi e trattini bassi. Deve essere lungo al massimo 15 caratteri.",
                "iban_invalid": "Deve avere una lunghezza minima di 15 e massima di 34 caratteri. Non può contenere spazi. Inizia con due lettere maiuscole, seguite da 2 numeri e poi da 11 a 30 caratteri alfanumerici.",
                "bic_invalid": "Deve essere lungo almeno 8 e al massimo 11 caratteri e contenere solo lettere maiuscole e numeri. I primi sei caratteri devono essere lettere."
            },
            "tour": {
                "name": "Inserisca il nome del partner commerciale.",
                "email": "L'indirizzo e-mail del partner commerciale può essere utilizzato per la comunicazione e nei processi documentali.",
                "address": "Qui può memorizzare l'indirizzo del partner commerciale.",
                "terms": "Inserisca qui i termini di pagamento e di consegna concordati con il partner commerciale.",
                "btn_save": "Dopo aver inserito tutte le informazioni, salvi qui il partner commerciale."
            }
        }
    },
    "user": {
        "name": "Nome",
        "client_id": "Azienda principale",
        "approval_limit": "Limite di approvazione",
        "priority_approval_limit": "Livello di priorità del limite di approvazione",
        "show_tour": "Mostra tutti i tour di Liftbase",
        "tooltip_edit_master_data_permission": "Con questo permesso è possibile modificare i dati master anche al di fuori dell’area di amministrazione tramite le seguenti funzioni:<br>" +
            "- Aggiungere fornitori direttamente durante la creazione di un prodotto<br>" +
            "- Modificare/aggiungere coordinate bancarie, metodo di pagamento e partita IVA durante la registrazione della fattura",
        "roles": {
            "user-admin": "Amministratore",
            "user-price": "Visualizzare prezzi",
            "user-dashboard": "Visualizzare tutte le dashboard",
            "user-procurement-dashboard": "Visualizzare la dashboard degli acquisti",
            "user-invoice-dashboard": "Visualizzare la dashboard delle fatture in entrata",
            "user-outgoing-invoice-dashboard": "Visualizzare la dashboard delle fatture in uscita",
            "user-einvoice-dashboard": "Visualizzare la dashboard delle fatture elettroniche",
            "user-change-order": "Modificare l'ordine successivamente",
            "user-see-orders": "Visualizzare ordini:",
            "user-see-all-orders": "Tutte le aziende",
            "user-see-all-orders-belonging-to-accessible-companies": "Tutte le aziende accessibili",
            "user-see-all-orders-belonging-to-own-company": "Propria azienda",
            "user-see-all-orders-belonging-to-own-department": "Proprio reparto",
            "user-see-orders-from-involved-invoices": "Visualizzare ordini da fatture coinvolte",
            "user-see-own-orders-and-involved": "Propri e coinvolti",
            "user-see-all-invoices": "Tutte le aziende",
            "user-see-all-invoices-belonging-to-accessible-companies": "Tutte le aziende accessibili",
            "user-see-invoices": "Visualizzare fatture:",
            "user-see-all-invoices-belonging-to-own-company": "Propria azienda",
            "user-see-invoices-from-own-orders": "Visualizzare le fatture dei propri ordini",
            "user-see-own-invoices-and-involved": "Propri e coinvolti",
            "user-can-change-invoices": "Modificare fattura successivamente",
            "user-see-outgoing-invoices": "Visualizzare fatture in uscita:",
            "user-see-all-outgoing-invoices": "Tutte le aziende",
            "user-see-all-outgoing-invoices-belonging-to-accessible-companies": "Tutte le aziende accessibili",
            "user-see-all-outgoing-invoices-belonging-to-own-company": "Propria azienda",
            "user-see-own-outgoing-invoices-and-involved": "Propri e coinvolti",
            "user-can-change-outgoing-invoices": "Modificare fattura in uscita successivamente",
            "user-bank-statement-transactions": "Visualizzare transazioni estratto conto",
            "user-liquidity-planning": "Aprire la pianificazione della liquidità",
            "user-supplier-dashboard": "Visualizzare dashboard fornitori",
            "user-ai-dashboard": "AI-Stats (solo operatori)",
            "user-see-client-addresses": "Visualizzare tutti gli indirizzi aziendali",
            "user-export-invoice": "Trasmettere fatture a {export_name}",
            "user-can-delete-document-directly": "Annullare/escludere documenti senza chiarimento",
            "user-can-insert-product": "Salvare nel catalogo prodotti",
            "user-can-insert-supplier": "Modificare indirettamente i dati master",
            "user-see-contracts": "Visualizzare contratti:",
            "user-see-all-contracts": "Tutte le aziende",
            "user-see-all-contracts-belonging-to-accessible-companies": "Tutte le aziende accessibili",
            "user-see-all-contracts-belonging-to-own-company": "Propria azienda",
            "user-see-all-contracts-belonging-to-own-department": "Proprio reparto",
            "user-see-own-contracts-and-involved": "Propri e coinvolti",
            "masterdata-edit-clients": "Modificare aziende",
            "masterdata-edit-cost-centers": "Modificare centri di costo",
            "masterdata-edit-posting-keys": "Modificare chiavi di registrazione",
            "masterdata-edit-departments": "Modificare reparti",
            "masterdata-edit-suppliers": "Modificare fornitori",
            "masterdata-edit-business-partners": "Modificare partner commerciali",
            "masterdata-edit-products": "Modificare catalogo prodotti",
            "masterdata-edit-product-groups": "Modificare gruppi di prodotti"
        },
        "blocked": "Accesso bloccato",
        "token_issued_at": "Token API emesso alle",
        "form_sequence": "name,email,client_id,department_id,cost_center_id,location_id,approval_limit,roles,blocked",
        "page": {
            "tab_general": "Generale",
            "tab_roles": "Permessi",
            "tab_roles_general": "Autorizzazioni generali",
            "tab_roles_dashboards": "Dashboard",
            "tab_roles_procurement": "Richieste di acquisto",
            "tab_roles_invoice": "Fatture",
            "tab_roles_outgoing_invoice": "Fatture in uscita",
            "tab_roles_bank_statements": "Estratti conto",
            "tab_roles_masterdata": "Dati master",
            "tab_roles_block": "Blocchi",
            "tab_permissions": "Gruppi di autorizzazione",
            "tab_addresses": "Indirizzi di consegna",
            "tab_task_groups": "Gruppi di compiti",
            "tab_communication_contacts": "Contatti",
            "tab_passkeys": "Passkeys",
            "tab_oauth_permissions": "Accessi app",
            "oauth_permissions": "Accessi concessi alle applicazioni",
            "oauth_permissions_description": "Le applicazioni elencate qui sono state autorizzate esplicitamente ad accedere a Liftbase per conto di questa persona.",
            "oauth_permissions_empty": "Non è stato concesso alcun accesso alle applicazioni.",
            "oauth_application": "Applicazione",
            "oauth_redirect_uri": "URL di reindirizzamento",
            "oauth_unverified": "Non verificata",
            "oauth_permission": "Autorizzazione",
            "oauth_scope_mcp": "Leggere i dati Liftbase consentiti",
            "oauth_granted_at": "Concesso",
            "oauth_expires_at": "Scade",
            "oauth_status": "Stato",
            "oauth_status_active": "Attivo",
            "oauth_status_expired": "Scaduto",
            "oauth_revoke": "Revoca",
            "oauth_revoke_title": "Revocare l'accesso dell'applicazione",
            "oauth_revoke_confirm": "Revocare l'accesso per {application}? Il rinnovo dell'accesso verrà interrotto immediatamente; un token di accesso già emesso può restare valido fino a 15 minuti.",
            "oauth_revoked": "Accesso dell'applicazione revocato.",
            "communication_contacts_description": "Gestisca qui i contatti e-mail suggeriti solo per la sua comunicazione con i fornitori. Può rinominare i contatti salvati o rimuoverli affinché non vengano più suggeriti.",
            "communication_contacts_empty": "Nessun contatto salvato.",
            "communication_contact_name": "Nome",
            "communication_contact_name_placeholder": "Nome visualizzato opzionale",
            "communication_contact_email": "E-mail",
            "communication_contact_last_used": "Ultimo utilizzo",
            "communication_contact_saved": "Contatto aggiornato.",
            "communication_contact_deleted": "Contatto rimosso.",
            "communication_contact_delete_confirm": "Vuole davvero rimuovere il contatto salvato \"{email}\"?",
            "accessible_companies_title": "Aziende accessibili per questo utente",
            "accessible_companies_empty": "Nessuna azienda derivata dalle autorizzazioni correnti.",
            "new": "Nuovo utente",
            "block_btn": "Bloccare l'utente",
            "unblock_btn": "Sbloccare l'utente",
            "login_as_btn": "Asse di accesso",
            "no_permission": "Non è stato selezionato alcun gruppo di autorizzazione.",
            "task_group_permissions": "Autorizzazioni dai miei gruppi di attività:",
            "approval_limit_tooltip_content": "Definisca qui il limite di approvazione finale per questa persona. <br> Possono essere approvati importi superiori, ma devono essere approvati definitivamente da un'altra persona con un limite di approvazione superiore.",
            "approval_limit_placeholder": "Illimitato",
            "upload_signature_label": "Firma (immagine)",
            "upload_signature_btn": "Selezionare la firma",
            "upload_signature_tooltip_content": "Aggiunga una firma che verrà stampata sul documento d'ordine dei suoi ordini d'acquisto approvati. <br/> Si consiglia di utilizzare un file immagine con sfondo trasparente.",
            "email_signature_html": "Firma e-mail",
            "email_signature_html_hint": "Questa firma viene precompilata nella comunicazione fornitore per il primo messaggio del documento.",
            "api_token_btn": "Generare il token API",
            "api_token_dialog_title": "Generare il token API",
            "api_token_dialog_content": "I token API sono necessari per l'integrazione di applicazioni di terze parti e consentono l'accesso ai dati per conto del rispettivo utente.",
            "api_token_dialog_date_placeholder": "Data di scadenza del gettone",
            "api_token_dialog_generate_btn": "Generare",
            "api_token_dialog_copy_btn": "Copia",
            "api_token_dialog_copy_info": "Copi e incolli il seguente token API nell'applicazione di terze parti:",
            "api_token_dialog_copied": "Copiato!",
            "language": "Lingua",
            "role_dashboard_tooltip": "Consente l'accesso a tutte le dashboard.",
            "role_ai_dashboard_tooltip": "AI-Stats è disponibile solo agli operatori.",
            "role_supplier_dashboard_tooltip": "Consente esclusivamente l'accesso alla dashboard fornitori. Questo permesso è indipendente da \"Visualizzare dashboard\".",
            "passkey": "Passkey",
            "passkeys": "Passkeys",
            "passkey_name": "Nome",
            "passkey_last_login": "Ultimo accesso",
            "passkey_dialog": {
                "title": "Aggiungere la chiave d'accesso",
                "info1": "<b>Cosa sono i Passkeys? </b><ul><li>Accede senza aspettare un'e-mail</li><li>Con l'impronta digitale, il suo volto o il PIN</li><li>Sicuro e conveniente</li></ul>",
                "info2": "<b>Impostare ora in 3 passi:</b><ol><li>Inserisca il nome, ad esempio \"PC Home Office\" o \"Notebook\"</li><li>Clicchi su \"Avanti\"</li><li>Segua le istruzioni del suo browser/sistema operativo</li></ol>.",
                "info3": "Le istruzioni passo-passo <a href=\"https://liftbase.de/handbuch/anmeldung/passkeys/\" target=\"_blank\">sono disponibili nel manuale</a>.",
                "name_input_label": "Nome della chiave di accesso",
                "name_input_placeholder": "Ad esempio, 'PC Home Office' o 'Notebook'.",
                "added_msg": "È stata aggiunta la chiave d'accesso.",
                "deleted_msg": "La chiave d'accesso è stata cancellata.",
                "exist_msg": "Ha già una chiave di accesso su questo dispositivo, provi con un altro dispositivo."
            },
            "validation": {
                "name_required": "La preghiamo di inserire un nome.",
                "name_exists": "Il nome esiste già.",
                "email_required": "Inserisca un indirizzo e-mail.",
                "email_invalid": "Inserisca un indirizzo e-mail valido.",
                "email_exists": "L'indirizzo e-mail esiste già.",
                "approval_limit_length": "Il limite di approvazione deve essere maggiore di 0 o vuoto."
            },
            "tour": {
                "name": "Inserisca il nome dell'utente, preferibilmente nome e cognome.",
                "email": "Inserisca l'indirizzo e-mail attraverso il quale l'utente può accedere.",
                "organization": "Assegna l'utente ad un'azienda, ad un reparto e ad un centro di costo. Queste informazioni saranno precompilate nel modulo dell'ordine d'acquisto.",
                "approval_limit": "Qui può definire un limite di approvazione per l'utente. Se un ordine d'acquisto ha un importo totale superiore, deve essere approvato definitivamente da una persona con un limite di approvazione più alto. Se non viene definito alcun limite, l'utente può approvare definitivamente tutti gli importi.",
                "signature": "Qui può aggiungere la firma dell'utente. Quando l'utente approva un ordine di acquisto, la sua firma sarà aggiunta al PDF dell'ordine di acquisto.",
                "roles": "Qui è possibile impostare le autorizzazioni per la persona, ad esempio se e quali processi o informazioni possono essere visualizzati o modificati. C'è anche l'opzione di bloccare la persona se, ad esempio, ha lasciato l'azienda.",
                "roles_price": "Specificare se l'utente può visualizzare i prezzi dei prodotti.",
                "role_change_order": "Può concedere ad un utente fidato il permesso di modificare gli ordini di acquisto dopo l'approvazione, senza rimandarli indietro per chiarimenti ed evitando così una nuova approvazione. Questo può essere utile, ad esempio, per modificare in seguito gli indirizzi di consegna o i prezzi dei prodotti.",
                "admin": "Scelga se questa persona deve avere accesso all'area di amministrazione, ad esempio per aggiungere altri utenti, dati anagrafici o impostazioni.",
                "block": "Selezioni questa opzione se vuole impedire ad un utente di accedere a liftbase, ad esempio se ha temporaneamente lasciato l'azienda.",
                "api_token": "I token API sono necessari per l'integrazione di applicazioni di terze parti e consentono l'accesso ai dati per conto del rispettivo utente.",
                "addresses": "Può aggiungere indirizzi di consegna personali per l'utente, ad esempio se lavora da casa e vuole che i prodotti vengano consegnati lì.",
                "btn_save": "Salvi l'utente e le informazioni associate.",
                "profile_signature": "Può caricare la sua firma qui. Quando approva gli ordini di acquisto, la sua firma sarà aggiunta al PDF dell'ordine di acquisto.",
                "profile_addresses": "Può aggiungere indirizzi di consegna personali per l'utente, ad esempio se lavora da casa e vuole che i prodotti vengano consegnati lì.",
                "profile_btn_save": "Salvi le informazioni associate."
            }
        }
    },
    "lb_user": {
        "description": "Utente"
    },
    "posting_key": {
        "name": "Nome",
        "tax": "Aliquota fiscale (%)",
        "number": "Key",
        "form_sequence": "name,number,tax",
        "page": {
            "new": "Nuovo Posting key",
            "validation": {
                "name_required": "La preghiamo di inserire un nome.",
                "number_required": "Inserisca un numero valido.",
                "number_length": "Può contenere fino a 9 numeri a partire da 1."
            },
            "tour": {
                "name": "Inserisca la chiave e l'aliquota fiscale associata."
            }
        }
    },
    "ledger_account": {
        "name": "Nome",
        "description": "Descrizione",
        "form_sequence": "name,number,description",
        "page": {
            "new": "Nuovo conto del libro mastro",
            "validation": {
                "name_required": "Inserisci un nome.",
                "number_required": "Inserisca un numero valido.",
                "number_length": "Possono contenere solo numeri e non possono iniziare con 0.",
                "tax_required": "Inserisca un'aliquota fiscale valida.",
                "tax_length": "Il valore percentuale può avere solo due cifre con una virgola e al massimo due cifre decimali."
            },
            "tour": {
                "name": "Inserisca il numero e il nome del conto del libro mastro."
            }
        }
    },
    "profit_center": {
        "name": "Nome",
        "form_sequence": "name,number",
        "page": {
            "new": "Nuovo centro di profitto",
            "validation": {
                "name_required": "Inserisci un nome.",
                "number_required": "Inserisci un numero valido.",
                "number_length": "Deve contenere solo numeri e non iniziare con 0 per numeri a più cifre.",
            },
            "tour": {
                "name": "Specifica il numero e il nome del centro di profitto."
            }
        }
    },
    "tax_group": {
        "code": "ID",
        "name": "Nome",
        "form_sequence": "name,code,client_id",
        "page": {
            "new": "Nuovo gruppo imposta sulle vendite",
            "validation": {
                "name_required": "Inserisci un nome.",
                "code_required": "Inserisci un ID.",
                "client_required": "Seleziona un cliente.",
            },
            "tour": {
                "name": "Specifica l'ID e il nome del gruppo imposta sulle vendite."
            }
        }
    },
    "financial_dimension": {
        "code": "ID",
        "name": "Nome",
        "form_sequence": "name,code",
        "page": {
            "new": "Nuovo Dipendente",
            "validation": {
                "name_required": "Si prega di inserire un nome.",
                "code_required": "Si prega di inserire un ID.",
                "client_required": "Si prega di selezionare un'azienda."
            },
            "tour": {
                "name": "Inserisci l'ID e il nome del dipendente."
            }
        }
    },
    "tax_item_group": {
        "code": "ID",
        "tax_code": "Codice Fiscale",
        "name": "Denominazione",
        "form_sequence": "name,code,tax_code,client_id",
        "page": {
            "new": "Nuovo Gruppo di Elementi Fiscali",
            "validation": {
                "name_required": "Si prega di inserire un nome.",
                "code_required": "Si prega di inserire un ID.",
                "tax_code_required": "Si prega di inserire un Codice Fiscale.",
                "client_required": "Si prega di selezionare un'azienda.",
            },
            "tour": {
                "name": "Inserisci l'ID e la denominazione del gruppo di imposte sul valore aggiunto."
            }
        }
    },
    "approver": {
        "description": "Approval",
        "label_log": "lb_user_name",
        "table_log": "lb_user",
        "approver_required": "Selezioni un approvatore.",
        "is_required": "Obbligatorio",
        "is_required_info": "Deve anche approvare, anche se i revisori precedenti avevano già il limite di approvazione necessario.",
        "conversion_info": "L'importo dell'approvazione è stato convertito nella valuta del documento al tasso di cambio attuale della BCE.",
        "max_approvers": "N. max. di approvatori",
        "max_approvers_placeholder": "opzionale",
        "max_approvers_info": "Opzionale. Se impostato, solo gli N approvatori più alti (per limite di approvazione) devono approvare. Gli approvatori obbligatori contano nel massimo e possono superarlo. Vuoto = regola attuale (tutti gli approvatori corrispondenti).",
        "test_order_value": "Valore ordine di prova",
        "test_order_value_placeholder": "es. 5000",
        "test_order_value_info": "Inserisca un valore d'ordine fittizio per vedere quali approvatori sarebbero richiesti con le impostazioni attuali.",
        "test_preview_section_title": "Test approvazione",
        "test_preview_title": "Approvatori richiesti",
        "test_preview_empty": "Nessun approvatore per questo valore.",
        "test_preview_required_overflow_short": "{requiredCount} obbligatori > max {max}"
    },
    "invoice": {
        "grouped_sum_tax": "Somma {tax}% imposta",
        "description": "Fattura",
        "name": "Nome",
        "creator_id": "Caricato da",
        "created_at": "Data caricamento",
        "number": "Numero di fattura",
        "invoice_prefix": "Prefisso della fattura",
        "is_final_invoice": "Contrassegna l'ordine di acquisto collegato come completato",
        "is_final_invoice_short": "Chiudi PO",
        "is_final_invoice_info": "Se questa opzione viene attivata, l'ordine di acquisto collegato viene automaticamente contrassegnato come completato. Successivamente non è più possibile collegare altre fatture a questo ordine.",
        "invoice_prefix_options": {
            "RE": "fattura normale",
            "AZ": "richiesta di acconto / fattura pro forma",
            "VK": "fattura di pagamento anticipato",
            "SR": "fattura finale",
            "GS": "nota di credito"
        },
        "invoice_number_formatted": "Numero interno RE",
        "due_date": "Data di scadenza",
        "delivery_date": "Data di consegna",
        "invoice_date": "Data fattura",
        "vat_due_date": "Data di registrazione IVA",
        "tax": "Tax Rate %",
        "total_brutto": "Totale lordo",
        "total_netto": "Totale netto",
        "total_netto_abbr": "-Rete",
        "document_discount_amount": "Importo sconto documento",
        "document_discount_base_amount": "Base sconto documento",
        "document_discount_percentage": "Sconto documento %",
        "document_discount_tax_percentage": "IVA dello sconto documento %",
        "document_discount_percentage_tooltip": "Percentuale dello sconto a livello documento applicata alla base (EN 16931 BT-94).",
        "document_discount_amount_tooltip": "Importo assoluto dello sconto a livello documento (EN 16931 BT-92).",
        "document_discount_base_amount_tooltip": "Importo netto su cui viene calcolato lo sconto documento (EN 16931 BT-93).",
        "document_discount_tax_percentage_tooltip": "Aliquota IVA utilizzata per l'assegnazione fiscale dello sconto documento.",
        "supplier_vat_number": "Partita IVA",
        "supplier_payment_method": "Metodo di pagamento",
        "supplier_iban": "IBAN",
        "supplier_bic": "BIC",
        "supplier_bank_country": "Paese della banca",
        "supplier_bank_account": "Numero di conto",
        "supplier_bank_code": "Codice bancario",
        "payment_reference": "Riferimento di pagamento",
        "fix_recognition": "Insoddisfatto del riconoscimento dei dati",
        "fix_recognition_checkbox": "Non sono soddisfatto del riconoscimento dei dati.",
        "paid": "Già pagato",
        "paid_auto_by_bank_statement_hint": "Contrassegnata automaticamente come pagata tramite analisi dell'estratto conto in data {date}.",
        "paid_manual_by_bank_statement_hint": "Contrassegnata come pagata tramite abbinamento manuale dell'estratto conto in data {date}.",
        "review_status": "Risultato della revisione",
        "selected_review_status": "Motivo selezionato",
        "review_status_options": {
            "content_rejection": "Fattura respinta per motivi contenutistici",
            "insolvency_rejection": "Fattura respinta per motivi di diritto fallimentare",
            "further_review_required": "Fattura da sottoporre a ulteriore revisione",
            "other_reason_rejection": "Annullato per altro motivo",
            "approved": "Fattura approvata"
        },
        "currency": "Valuta",
        "notes": "Note",
        "order_notes": "Note sull'ordine",
        "discount_percentage": "Sconto 1 (%)",
        "discount_amount": "Sconto 1 - Importo",
        "discount_days": "Sconto 1 - Giorni",
        "discount_payment_date": "Sconto 1 - Data",
        "discount_percentage2": "Sconto 2 (%)",
        "discount_amount2": "Sconto 2 - Importo",
        "discount_days2": "Sconto 2 - Giorni",
        "discount_payment_date2": "Sconto 2 - Data",
        "type_discount_amount": "currency",
        "type_discount_amount2": "currency",
        "payment_in_advance": "Pagamento anticipato",
        "einvoice_status": {
            "is_einvoice": "Fattura elettronica",
            "not_einvoice": "Nessuna fattura elettronica",
            "not_relevant_hint": "Nessuna fattura elettronica, non rilevante per la detrazione dell'IVA",
            "tax_not_refundable_hint": "L'IVA per un importo di {amount} non potrà essere rimborsata dal 01/01/2027.",
            "zugferd10_hint": "ZUGFeRD 1.0 non è una fattura elettronica valida ai sensi dell'obbligo di fatturazione elettronica (EN 16931)."
        },
        "electronic_validation": {
            "blocked_title": "La fattura non soddisfa i requisiti di legge",
            "blocked_message": "Poiché la fattura non soddisfa i requisiti di legge, non se ne consiglia l'ulteriore elaborazione. L'elaborazione manuale è comunque possibile.",
            "blocked_status": "Verifica necessaria",
            "manual_export_warning_title": "Errori tecnici della fattura elettronica",
            "manual_export_warning_message": "La validazione tecnica di questa fattura elettronica contiene errori. È comunque possibile continuare manualmente, ma non è consigliato. Vuoi continuare consapevolmente con l'esportazione?",
            "manual_export_bulk_warning_message": "Almeno una delle fatture elettroniche selezionate contiene errori tecnici. È comunque possibile continuare manualmente, ma non è consigliato. Vuoi continuare consapevolmente con l'esportazione?",
            "manual_export_warning_confirm": "Continua esportazione",
            "manual_export_warning_cancel": "Annulla",
            "show_details": "Mostra dettagli",
            "hide_details": "Nascondi dettagli",
            "rule_set": "Pacchetto di regole",
            "external_reference_uris": "Riferimenti esterni",
            "notify_supplier": "Avvisa il fornitore",
            "admin_report_hint": "Solo gli amministratori possono scaricare il rapporto tecnico completo.",
            "issue": {
                "malformed_xml": "Il file XML non è ben formato o contiene costrutti XML non consentiti.",
                "external_reference_not_resolved": "La fattura elettronica fa riferimento a una risorsa esterna. Per motivi di sicurezza e privacy, Liftbase non recupera né risolve automaticamente le risorse esterne.",
                "unknown_format": "Il formato XML della fattura non è supportato.",
                "unsupported_version": "Nessun pacchetto di regole attivo supporta la famiglia di versioni rilevata.",
                "outdated_version": "La fattura utilizza la versione XRechnung precedente {version}. Viene mostrato come avviso e non impedisce di per sé l'elaborazione consentita dalla legge.",
                "unsupported_profile": "Il formato e il profilo rilevati non soddisfano i requisiti di legge della EN 16931 e pertanto non possono essere accettati come fattura elettronica conforme. Utilizzare un formato o profilo di fattura conforme alla EN 16931, ad esempio ZUGFeRD con il profilo EN 16931 o XRechnung in una versione legalmente valida.",
                "zugferd_10_unsupported": "È stato rilevato il formato obsoleto ZUGFeRD 1.0 (profilo: {profile}). Questa versione non è supportata. Il fornitore deve emettere nuovamente la fattura come Factur-X/ZUGFeRD attuale o XRechnung.",
                "electronic_invoice_extraction_failed": "Non è stato possibile estrarre i dati dalla fattura elettronica tecnicamente valida.",
                "kosit_execution_failed": "Non è stato possibile eseguire la validazione tecnica della fattura elettronica.",
                "kosit_processing_failed": "Si è verificato un errore durante la validazione tecnica della fattura elettronica.",
                "processing_error": "Non è stato possibile completare la validazione tecnica della fattura elettronica.",
                "multiple_bodies": "Sono stati trovati più corpi fattura. Secondo le regole locali FatturaPA sono processabili solo documenti con un unico body.",
                "format_mismatch": "Il formato di trasmissione FatturaPA (versione / FormatoTrasmissione) non corrisponde alle regole locali FatturaPA.",
                "fatturapa_total_mismatch": "I totali del documento non corrispondono secondo le regole locali FatturaPA.",
                "unsupported_document_type": "Questo tipo documento FatturaPA non è supportato secondo le regole locali FatturaPA.",
                "fatturapa_schema_violation": "Il documento non ha superato la validazione XSD locale FatturaPA.",
                "fatturapa_line_total_mismatch": "Il totale di una riga non corrisponde a quantità × prezzo unitario dopo sconti (regole locali FatturaPA).",
                "fatturapa_riepilogo_mismatch": "I totali delle righe non corrispondono al riepilogo IVA (regole locali FatturaPA).",
                "fatturapa_destinatario_missing": "Il codice destinatario (CodiceDestinatario / PEC) manca o è incompleto (regole locali FatturaPA).",
                "fatturapa_tax_mismatch": "Gli importi IVA non corrispondono a imponibile × aliquota (regole locali FatturaPA).",
                "fatturapa_business_rule_failed": "Non è stato possibile valutare le regole di business locali FatturaPA.",
                "fatturapa_iban_format": "Un IBAN sulla fattura non supera i controlli di formato (regole locali FatturaPA).",
                "fatturapa_vat_id_sanity": "Un identificativo IVA (IdFiscaleIVA) non supera i controlli base di lunghezza/caratteri (regole locali FatturaPA).",
                "fatturapa_destinatario_length": "La lunghezza di CodiceDestinatario non corrisponde al formato di trasmissione atteso (regole locali FatturaPA)."
            },
            "local_scope_hint": "Validazione FatturaPA solo locale — non equivale all'accettazione SDI e non costituisce certezza giuridica per la detrazione IVA.",
            "local_accepted_title": "Valida secondo le regole locali FatturaPA",
            "warning_title": "Avvisi sulla validazione tecnica",
            "status": {
                "acceptable": "Accettata",
                "rejected": "Rifiutata",
                "undefined": "Non definita",
                "technical_error": "Errore tecnico"
            },
            "supplier_template": {
                "subject": "La sua fattura {number} del {invoiceDate}",
                "unknown_value": "non indicata",
                "rule_set_unavailable": "nessun pacchetto di regole corrispondente",
                "no_specific_reason": "Il validatore non ha restituito un messaggio di errore specifico. Verificare il rapporto di validazione tecnica completo.",
                "reasons_heading": "Cosa deve essere corretto?",
                "body": "<p>Buongiorno,</p><p>La fattura non può essere accettata nella forma attuale come fattura elettronica conforme alla legge, poiché il formato o il profilo rilevato non soddisfa i requisiti di legge.</p><p style=\"margin-bottom:-4px\"><strong>Fattura interessata:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Numero fattura:</strong> {number}</li><li><strong>Data fattura:</strong> {invoiceDate}</li><li><strong>Formato rilevato:</strong> {standard}</li><li><strong>Versione rilevata:</strong> {version}</li><li><strong>Profilo rilevato:</strong> {profile}</li></ul>{reasonsSection}<br><p>Utilizzi un formato o profilo di fattura conforme alla EN 16931, ad esempio ZUGFeRD con il profilo EN 16931 o XRechnung in una versione supportata.</p><p>Emetta una fattura elettronica corretta e ce la invii nuovamente.</p><p>Grazie per la collaborazione.</p>",
                "body_fatturapa": "<p>Buongiorno,</p><p>La fattura non può essere accettata nella forma attuale come fattura elettronica conforme alla legge, poiché il formato o il profilo rilevato non soddisfa i requisiti di legge.</p><p style=\"margin-bottom:-4px\"><strong>Fattura interessata:</strong></p><ul style=\"margin-bottom:12px\"><li><strong>Numero fattura:</strong> {number}</li><li><strong>Data fattura:</strong> {invoiceDate}</li><li><strong>Formato rilevato:</strong> {standard}</li><li><strong>Versione rilevata:</strong> {version}</li><li><strong>Profilo rilevato:</strong> {profile}</li></ul>{reasonsSection}<br><p>Utilizzi un formato o profilo di fattura conforme alla EN 16931, ad esempio ZUGFeRD con il profilo EN 16931 o XRechnung in una versione supportata.</p><p>Emetta una fattura elettronica corretta e ce la invii nuovamente.</p><p>Grazie per la collaborazione.</p>"
            }
        },
        "einvoice": {
            "title": "Dashboard Fattura Elettronica",
            "analysis_period": "Periodo di Analisi",
            "filters": {
                "date_range": "Intervallo date",
                "client": "Azienda",
                "supplier": "Fornitore",
                "select_period": "Seleziona Periodo"
            },
            "placeholders": {
                "all": "Tutti"
            },
            "kpis": {
                "percent_einvoices": "Quota Fatture Elettroniche",
                "total_tax_eur": "Totale IVA a Credito",
                "potential_loss": "Rischio IVA a Credito",
                "total_invoices": "Totale Fatture",
                "non_einvoice_quote": "Quota Fatture Non Elettroniche",
                "top_10_risk_share": "Quota Rischio IVA Top-10 Fornitori",
                "total_suppliers": "Totale Fornitori",
                "suppliers_with_einvoice": "Fornitori con Fattura Elettronica",
                "suppliers_without_einvoice": "Fornitori senza Fattura Elettronica",
                "avg_einvoice_quote": "Quota E-Quote Media (fornitori attivi)",
                "evaluated_months": "Mesi Valutati",
                "data_coverage": "Copertura Dati",
                "risk_concentration": "Concentrazione del Rischio",
                "only_suppliers_with_min_1": "solo fornitori con almeno 1 fattura elettronica"
            },
            "charts": {
                "format_distribution": "Distribuzione Formato",
                "format_distribution_subtitle": "Quota di XML, PDF+XML e fatture non strutturate",
                "monthly_trend": "Trend Mensile per Formato Fattura",
                "monthly_trend_subtitle": "Quantità in pila per mese",
                "top_suppliers_risk": "Top Fornitori per Rischio IVA",
                "top_suppliers_risk_subtitle": "Alta concentrazione di rischio su singoli fornitori"
            },
            "table": {
                "monthly_evolution": "Evoluzione Mensile",
                "all_suppliers": "Tutti i Fornitori per E-quote (decrescente)",
                "month": "MESE",
                "xml": "XML",
                "pdf_xml": "PDF+XML",
                "non_einvoice": "NON FATTURA ELETTRONICA",
                "risk": "RISCHIO IVA",
                "supplier": "FORNITORE",
                "quote": "E-QUOTE",
                "total_tax": "TOTALE IVA"
            },
            "banner": {
                "title": "Importo stimato dell'IVA che dal 01.01.2027 non verrà rimborsata dall'Agenzia delle Entrate:",
                "subtitle": "{percent}% dell'IVA stimata (Modello Rischio Formale)",
                "description": "Periodo: da {start} a {end}. Obbligo di ricezione dal 01.01.2025. La pressione normativa aumenta dal 01.01.2027. Aumento del rischio di validità formale per fatture B2B nazionali non strutturate dal 01.01.2028. Il modello valuta solo la conformità del formato."
            },
            "hint": "Attenzione: lo Stato smetterà presto di rimborsare l'IVA per le fatture non elettroniche. Contatta i tuoi fornitori il prima possibile per assicurarti di ricevere correttamente le tue fatture elettroniche e non perdere denaro.",
            "alert": {
                "title": "Attenzione: Maggiore rischio fiscale e formale per fatture non elettroniche",
                "item_1": "Dal 01.01.2027 il rischio per le fatture non strutturate aumenta sensibilmente.",
                "item_2": "Per tali fatture, l'Agenzia delle Entrate può rifiutare il rimborso dell'IVA a credito.",
                "item_3": "Dal 01.01.2028 questo vale per tutti i fornitori, anche sotto 800.000 € di fatturato (regola transitoria solo per il 2027).",
                "item_4": "Raccomandazione: Convertite tutti i vostri fornitori alle e-fatture in anticipo e richiedete una fatturazione adeguata."
            },
            "action_button": "Notifica Fornitori",
            "email_dialog": {
                "title": "Notifica Fornitore",
                "to": "Email Destinatario",
                "subject": "Oggetto",
                "message": "Messaggio",
                "download_eml": "Scarica .eml",
                "select_supplier_warning": "Seleziona prima un fornitore.",
                "default_subject": "Importante: Transizione alle Fatture Elettroniche - {supplier}",
                "default_message": "Gentile team di {supplier},\n\nstiamo attualmente revisionando i nostri processi di rimborso IVA. Tra il {startDate} e il {endDate}, abbiamo identificato un totale di {amount} di imposte dalle vostre fatture che non sono state inviate come fatture elettroniche (ZUGFeRD o XRechnung).\n\nVi informiamo che lo Stato smetterà presto di rimborsare l'IVA per le fatture non elettroniche. Per garantire la nostra continua collaborazione ed evitare perdite finanziarie, vi chiediamo gentilmente di passare all'invio di fatture elettroniche il prima possibile.\n\nGrazie per la collaborazione.\n\nCordiali saluti,\n{userName}\n{tenantName}\nIl vostro team di contabilità"
            }
        },
        "export_individual_items": "Esportare voci singole",
        "export_individual_items_tooltip": "Se questa casella è selezionata, le posizioni vengono trasmesse al posto dei dati di intestazione.",
        "status": "Stato",
        "statuses": {
            "open": "Riconoscimento delle fatture",
            "export": "Pronto per l'esportazione",
            "declined": "Scartato",
            "declined-exported": "Annullato-Esportato",
            "completed": "Completato",
            "historical-imported": "Importata come storico",
            "approval": "Controllo manuale",
            "financial-approval": "Approvazione",
            "clearing": "Chiarimento contabile",
            "accounting": "Contabilità"
        },
        "page": {
            "ai_validation_result": {
                "title": "Risultato Validazione IA",
                "result": "Risultato",
                "green_flags": "Segnali Positivi (Green Flags)",
                "red_flags": "Segnali di Rischio (Red Flags)",
                "score": "Punteggio",
                "check_method": "Metodo di Controllo",
                "signals_considered": "Segnali Considerati",
                "signals_missing": "Segnali Mancanti",
                "system_prompt": "Prompt di Sistema",
                "user_prompt": "Prompt Utente",
                "context": "Contesto",
                "no_data": "Nessun dato di validazione IA disponibile per questa fattura.",
                "response": "Risposta (JSON)",
                "trust_level": "Affidabile",
                "not_trust_level": "Non affidabile",
                "btn_tooltip": "Mostra dettagli validazione IA",
                                "decision_summary": "Motivazione",
                "what_decided": "Cosa ha deciso?",
                "positive_contributions": "Contributi positivi",
                "risk_contributions": "Contributi di rischio",
                "scoring_method": "Metodo",
                "scoring_method_linear": "Lineare",
                "scoring_method_multiplicative": "Moltiplicativo",
                "scoring_method_confidence": "Confidenza",
                "score_kind_risk": "Punteggio di rischio",
                "score_kind_confidence": "Punteggio di confidenza",
                "score_kind_green_sum": "Somma dei segnali positivi",
                "score_explanation_title": "Come l'IA giunge alla decisione",
                "score_scale_hint_risk": "Guida: 0 = nessun rischio residuo evidente, 1 = rischio massimo. Più basso è il valore, più probabile è l'approvazione automatica.",
                "score_scale_hint_confidence": "Guida: 0 = molto incerto, 1 = molto sicuro. Più alto è il valore, più probabile è l'approvazione automatica.",
                "score_scale_hint_green_sum": "Guida: 0 = nessun segnale positivo significativo, 1 = segnali positivi molto forti. Più alto è il valore, più probabile è l'approvazione automatica.",
                "decision_reasons_trusted": "Fattori decisivi anche: {ai_validation_reason_value}.",
                "decision_reasons_not_trusted": "Fattori decisivi: {ai_validation_reason_value}.",
                "decision_reasons_insufficient_positive": "I segnali positivi non sono stati sufficienti: {ai_validation_reason_value}.",
                "show_calculation": "Mostra calcolo",
                "formula_linear": "Rischio = RedSum − GreenSum = {red_sum} − {green_sum} = {final_score}",
                "formula_multiplicative_risk": "Rischio = (RedSum × Boost) × (1 − GreenSum) = ({red_sum} × {boost}) × (1 − {green_sum}) = {final_score}",
                "formula_multiplicative_green": "GreenSum = {green_sum}",
                "formula_confidence": "Confidenza = GreenSum − RedPenalty = {green_sum} − {red_sum} = {final_score}",
                "decision_passed": "{score_label} {final_score} {comparison} {threshold} → affidabile",
                "decision_failed": "{score_label} {final_score} {comparison} {threshold} → non affidabile",
                "finding": "Risultato",
                "detected": "Rilevato / Sì",
                "not_detected": "Non rilevato / No",
                "certainty_label": "Sicurezza",
                "tokens_used": "Token IA utilizzati (In: {tokens_in}, Out: {tokens_out})",
                "tokens_not_used": "Nessun token IA utilizzato",
                "ai_checked_flags": "Controllato da IA",
                "local_checked_flags": "Controllato localmente prima della IA",
                "parse_error": "La risposta IA non può essere interpretata come JSON.",
                "flag_descriptions": {
                    "GREEN_01": "I campi obbligatori sono completi (numero fattura, data, fornitore, importi, dati fiscali).",
                    "GREEN_02": "Plausibilità storica per il fornitore (importi, struttura, descrizioni e intervalli simili).",
                    "GREEN_03": "L'indirizzo email del mittente è noto (corrisponde ai dati anagrafici o alle email storiche del fornitore).",
                    "GREEN_04": "Gli importi sono plausibili rispetto alla prestazione (il livello di prezzo stimato coincide con l'importo).",
                    "GREEN_05": "La fattura si riferisce a un periodo di servizio chiaro (periodo indicato e non sovrapposto).",
                    "GREEN_06": "Le coordinate bancarie corrispondono ai dati anagrafici (IBAN/beneficiario corrispondono esattamente).",
                    "RED_01": "L'indirizzo email del mittente è diverso (dominio nuovo o leggermente modificato).",
                    "RED_02": "Il periodo si sovrappone a fatture esistenti (periodo già coperto).",
                    "RED_03": "Importo elevato o rischio intrinseco elevato (sopra soglia o categoria ad alto rischio).",
                    "RED_04": "Aumento improvviso dell'importo per lo stesso fornitore (crescita significativa senza motivo chiaro).",
                    "RED_05": "Ordine/contratto mancante o divergente (storicamente previsto ma assente, oppure forte scostamento dall'ordine collegato).",
                    "RED_06": "Coordinate bancarie diverse dai dati anagrafici (IBAN nuovo/modificato rispetto ai dati master)."
                }
            },
            "upload": {
                "title": "Caricare nuove fatture",
                "info": "Trascini e rilasci o clicchi qui per caricare una o più fatture (*.pdf fino a 30MB).",
                "info_attachments": "Trascina e rilascia o clicca qui per caricare uno o più allegati (fino a 30 MB per file).",
                "create_btn": "Avviare il riconoscimento delle fatture",
                "file_invalid": "La preghiamo di caricare solo file PDF o XML fino a 30 MB.",
                "no_preview_available": "Nessuna anteprima disponibile per questo tipo di file. <br>Scarica il file e aprilo sul tuo computer.",
                "settings": "Impostazioni",
                "group_by_tax": "Raggruppa per aliquota durante il riconoscimento",
                "group_by_tax_hint": "Se abilitato, le righe riconosciute verranno raggruppate per aliquota al caricamento (es.: Somma 19% imposta).",
                "ai_validation": "Abilita validazione IA",
                "ai_validation_hint": "Se abilitata, la fattura verrà spostata direttamente nello stato 'Pronto per l'esportazione' dopo il riconoscimento dell'IA, a condizione che non siano necessari passaggi di approvazione.",
                "ai_validation_mode": "Validazione IA",
                "ai_validation_mode_none": "Nessuna validazione IA",
                "ai_validation_auto_forward": "Attiva e sposta in Pronto per l'esportazione",
                "ai_validation_auto_forward_hint": "Se abilitata, la fattura verrà spostata direttamente nello stato 'Pronto per l'esportazione' dopo il riconoscimento dell'IA, a condizione che non siano necessari passaggi di approvazione.",
                "ai_validation_advisory": "Attiva e mantieni invariato lo stato",
                "ai_validation_advisory_forced": "Già attiva, lo stato rimane invariato",
                "ai_validation_advisory_hint": "Se abilitata, l'IA valida la fattura, scrive il risultato nella timeline e mostra i dettagli del punteggio senza saltare il normale workflow.",
                "tour": {
                    "before_attach": "Qui può caricare una o più fatture trascinando e rilasciando o cliccando all'interno di quest'area.",
                    "after_attach_title": "Avviare il riconoscimento delle fatture",
                    "after_attach": "Qui può avviare il riconoscimento automatico di tutte le fatture caricate. Verrà quindi reindirizzato alla panoramica della prima fattura. Le altre fatture saranno disponibili nell'elenco delle attività."
                }
            },
            "tabs": {
                "lines": "Posizioni",
                "discount": "Sconto",
                "payment": "Dati di pagamento",
                "transactions": "Transazioni",
                "notes": "Note",
                "recognition": "Dati grezzi riconoscimento documento"
            },
            "linked_transactions": {
                "title": "Transazioni collegate",
                "empty": "Nessuna transazione collegata trovata.",
                "load_error": "Impossibile caricare le transazioni collegate.",
                "statement": "Estratto",
                "match_type": "Tipo di collegamento",
                "allocated_amount": "Importo assegnato",
                "match_type_direct": "Diretto",
                "match_type_manual": "Suddiviso"
            },
            "new": "Nuova fattura",
            "select_contract_or_procurement": "Contratto / Richiesta d'acquisto",
            "payment_conditions": "Condizioni di pagamento",
            "discount1": "Sconto 1",
            "discount2": "Sconto 2",
            "discount_percentage": "Percentuale",
            "discount_amount": "Importo",
            "discount_days": "Giorni",
            "discount_payment_date": "Data",
            "invoice_discount_data": "Dati di sconto sul documento",
            "supplier_discount_data": "Dati di sconto nei dati anagrafici",
            "business_partner_discount_data": "Dati di sconto nei dati anagrafici del partner commerciale",
            "copy_discount_data_to_supplier": "Trasferisci dal documento ai dati anagrafici",
            "copy_discount_data_to_supplier_tooltip": "Facendo clic, i dati di sconto inseriti nel modulo verranno copiati nei dati anagrafici del fornitore.",
            "copy_discount_data_to_business_partner_tooltip": "Facendo clic, i dati di sconto inseriti nel modulo verranno copiati nei dati anagrafici del partner commerciale.",
            "download_pdf": "Scarica PDF",
            "download_pdf_info": "Se il PDF non viene visualizzato, controlla le impostazioni del browser e assicurati che l'opzione \"Scarica sempre i file PDF\" sia disattivata.",
            "download_xml": "Scarica XML",
            "download_xml_info": "Scarica il file XML FatturaPA originale.",
            "visualization_generated_hint": "Questo PDF è stato generato dall'XML della fattura elettronica. L'XML resta l'originale giuridicamente vincolante.",
            "visualization_compare_hint": "Il PDF XML mostra il contenuto dell'XML; il PDF originale può differire. L'XML resta giuridicamente vincolante.",
            "visualization_version_hint": "Versione della visualizzazione: {version}.",
            "visualization_history": "Versioni PDF",
            "visualization_history_title": "Versioni PDF",
            "visualization_version_label": "Versione PDF {version}",
            "visualization_current_version": "Attuale",
            "visualization_version_created_at": "Creata il: {date}",
            "visualization_version_renderer": "Versione di rendering: {renderer}",
            "visualization_version_view": "Visualizza",
            "visualization_version_download": "Scarica",
            "visualization_version_loading": "Caricamento del PDF ...",
            "visualization_version_load_error": "Non è stato possibile caricare la versione PDF.",
            "regenerate_visualization": "Rigenera PDF",
            "regenerate_visualization_title": "Rigenera PDF",
            "regenerate_visualization_confirm": "Il PDF verrà rigenerato utilizzando la versione di rendering attuale. La versione precedente verrà conservata. Vuoi continuare?",
            "regenerate_visualization_confirm_button": "Rigenera",
            "regenerate_visualization_success": "La versione PDF {version} è stata generata correttamente.",
            "regenerate_visualization_error": "Non è stato possibile rigenerare il PDF.",
            "document_tabs": {
                "xml": "XML",
                "preview": "Anteprima",
                "pdf": "PDF",
                "original_pdf": "PDF originale",
                "visualization": "KoSIT-PDF",
                "fatturapa": "FatturaPA",
                "fatturapa_pdf": "FatturaPA-PDF"
            },
            "fatturapa_preview": {
                "eyebrow": "FatturaPA",
                "invoice": "Fattura",
                "number": "Numero",
                "date": "Data",
                "profile": "Formato",
                "order_data": "Dati ordine acquisto",
                "order_number": "Numero",
                "purchase_order_number": "Numero ordine",
                "line_reference": "Rif. linea",
                "order_reference": "Rif. ordine",
                "item_number": "Numero articolo",
                "convention_code": "Codice commessa/convenzione",
                "cup": "CUP",
                "cig": "CIG",
                "supplier": "Cedente/prestatore",
                "customer": "Cessionario/committente",
                "vat_id": "Partita IVA",
                "fiscal_code": "Codice fiscale",
                "lines": "Righe",
                "description": "Descrizione",
                "qty": "Qtà",
                "unit_price": "Prezzo unitario",
                "discount": "Sconto",
                "document_discount": "Sconto documento",
                "line_total": "Totale riga",
                "vat": "IVA",
                "taxable": "Imponibile",
                "tax": "Imposta",
                "total": "Totale documento",
                "payment": "Pagamento",
                "payment_method": "Modalità",
                "show_xml": "Mostra XML",
                "hide_xml": "Nascondi XML",
                "footnote": "Anteprima locale FatturaPA — il file XML resta l'originale giuridicamente vincolante. Non è un esito SDI."
            },
            "notes_datev_hint": "Questa nota viene trasmessa al consulente fiscale tramite DATEV Unternehmen Online.",
            "recognition_data_title": "Dati grezzi di riconoscimento",
            "no_recognition_data": "Nessun dato riconosciuto.",
            "repeat_recognition_btn": "Ripeti riconoscimento documento",
            "magic_suggestions_btn_tooltip": "Suggerimenti di compilazione basati su fatture precedenti dello stesso fornitore",
            "magic_suggestions_btn_tooltip_business_partner": "Suggerimenti di compilazione basati su fatture precedenti dello stesso partner commerciale",
            "magic_suggestions_dialog": {
                "title": "Suggerimenti per questa fattura",
                "message": "Seleziona i campi che desideri compilare in base ad altre fatture di questo fornitore.",
                "info_based_on_invoices": "Suggerimenti basati sulle seguenti RE:",
                "select_supplier_msg": "Seleziona un fornitore nel modulo per cercare i suggerimenti.",
                "no_data": "Nessun suggerimento trovato per questo fornitore.",
                "error_load": "Errore durante il caricamento dei suggerimenti.",
                "applied_success": "Suggerimenti applicati."
            },
            "magic_suggestions_dialog_business_partner": {
                "message": "Seleziona i campi che desideri compilare in base ad altre fatture di questo partner commerciale.",
                "select_supplier_msg": "Seleziona un partner commerciale nel modulo per cercare i suggerimenti.",
                "no_data": "Nessun suggerimento trovato per questo partner commerciale."
            },
            "procurement_summary": {
                "dialog_title": "Contenuto della richiesta d'acquisto",
                "open_dialog": "Mostra dettagli",
                "line_count": "{count} righe in sintesi",
                "empty": "Non sono presenti righe per questa richiesta d'acquisto.",
                "empty_filtered": "Non sono state trovate righe nella richiesta d'acquisto per il fornitore selezionato \"{supplier_name}\".",
                "filtered_by_supplier": "Vengono mostrate solo le righe del fornitore \"{supplier_name}\".",
                "item": "Riga"
            },
            "repeat_recognition_confirm_btn": "Conferma",
            "repeat_recognition_confirm_msg": "I dati esistenti nel modulo verranno sovrascritti. Sei sicuro di voler procedere?",
            "repeat_recognition_confirm_title": "Ripeti riconoscimento documento",
            "repeat_recognition_feedback_msg": "Il riconoscimento del documento viene elaborato in background e potrebbe richiedere alcuni secondi.",
            "select_columns_btn": "Seleziona colonne",
            "export_to_datev_btn": "Invia al DATEV",
            "export_to_datev_csv_btn": "Esporta DATEV CSV",
            "export_to_ms365_btn": "Invia al D365",
            "export_btn_incomplete_form_tooltip": "Si prega di completare i dati della fattura.",
            "export_btn_send_to_clearing_tooltip": "Per ritrasmettere a D365, si prega di rinviare alla contabilità tramite il passaggio 'Risoluzione'.",
            "export_error": "<b>La fattura non può essere inviata</b>.<br>",
            "no_export_config_datev_tooltip": "Nessuna connessione a <b>{export_name}</b> è stata configurata. <br>Nel file di configurazione per l'azienda selezionata <b>{client_name}</b> non è stato assegnato alcun cliente DATEV. <br>Se necessario, contattare una persona con diritti amministrativi <br>per configurare la connessione nell'area amministrativa.",
            "no_export_config_tooltip": "Non è stata impostata alcuna connessione a {export_name}. <br>Contatti una persona con diritti amministrativi per impostare la connessione nell'area amministrativa.",
            "confirm_before_leave_msg": "La sua fattura non è stata salvata. È sicuro di voler lasciare la pagina?",
            "can_not_edit": "Non ha il permesso di modificare i dati. Per farlo, la preghiamo di inviare la fattura in chiarimento utilizzando le Azioni.",
            "recognized_client_id": "L'azienda è stata identificata correttamente sulla base del <b>ID IVA</b> e del <b>nome</b>.<br> <b>Azienda:</b> {client_name}",
            "user_client_id": "L'azienda è stata assegnata in base al <b>profilo utente</b> dell'uploader.<br><b>Azienda:</b> {client_name}",
            "field_origin": {
                "title": "Origine della preselezione",
                "source_label": "Origine",
                "history_title": "Storico del riconoscimento",
                "run_title": "{date} · {count} campo/i{status}{model}",
                "unknown_run": "Riconoscimento sconosciuto",
                "field_column": "Campo",
                "before_column": "Prima",
                "after_column": "Dopo",
                "reason_column": "Motivo",
                "empty_value": "Vuoto",
                "ai_history_title": "Storico elaborazione IA",
                "ai_request_label": "Prompt della richiesta",
                "ai_response_label": "Risposta IA",
                "ai_system_prompt_label": "Prompt di sistema",
                "ai_user_prompt_label": "Prompt utente",
                "ai_sources_label": "Fonti dei prompt personalizzati",
                "ai_tenant_prompt_label": "Prompt del tenant",
                "ai_client_prompt_label": "Prompt del cliente",
                "ai_supplier_prompt_label": "Prompt del fornitore",
                "ai_recognition": "Riconoscimento fattura",
                "ai_custom_prompt": "Post-elaborazione con prompt personalizzato",
                "ai_supplier_identification": "Identificazione del fornitore",
                "ai_validation": "Validazione fattura",
                "ai_succeeded": "Completato",
                "ai_failed": "Non riuscito",
                "source_types": {
                    "recognition": "Riconoscimento documento",
                    "procurement": "Ordine",
                    "supplier_master_data": "Dati anagrafici fornitore",
                    "business_partner_master_data": "Dati anagrafici business partner",
                    "creator_default": "Profilo dell'uploader"
                },
                "reasons": {
                    "invoice_number_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "total_netto_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "total_brutto_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "invoice_date_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "due_date_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "delivery_date_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "document_discount_amount_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "document_discount_base_amount_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "document_discount_percentage_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "document_discount_tax_percentage_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "client_matched_by_receiver_name_or_vat": "Selezionato perché il destinatario riconosciuto della fattura corrispondeva a un'azienda per nome o ID IVA.",
                    "client_matched_by_supplier_name_or_vat": "Selezionato perché l'emittente riconosciuto della fattura corrispondeva a un'azienda per nome o ID IVA.",
                    "client_from_creator_profile": "Preso dall'azienda assegnata all'uploader.",
                    "client_from_procurement": "Copiato dall'ordine assegnato.",
                    "supplier_matched_by_name_vat_or_iban": "Selezionato perché i dati fornitore riconosciuti corrispondevano a un fornitore per nome, ID IVA o IBAN.",
                    "business_partner_matched_by_name_vat_or_iban": "Selezionato perché i dati della controparte riconosciuti corrispondevano a un business partner per nome, ID IVA o IBAN.",
                    "business_partner_matched_by_receiver_name_or_vat": "Selezionato perché il destinatario riconosciuto della fattura corrispondeva a un partner commerciale per nome o ID IVA.",
                    "supplier_from_single_procurement_supplier": "Selezionato perché l'ordine assegnato ha esattamente un fornitore.",
                    "procurement_matched_by_recognized_reference": "Selezionato perché un riferimento ordine riconosciuto corrisponde a questo ordine.",
                    "procurement_matched_by_invoice_similarity": "Selezionato perché importo, data e righe corrispondono alla fattura.",
                    "procurement_matched_by_invoice_similarity_without_supplier": "Selezionato perché importo, data e righe corrispondevano alla fattura prima della selezione del fornitore.",
                    "ledger_account_from_procurement": "Copiato dall'ordine assegnato.",
                    "cost_center_from_procurement": "Copiato dall'ordine assegnato.",
                    "cost_type_from_procurement": "Copiato dall'ordine assegnato.",
                    "profit_center_from_supplier_master_data": "Copiato dai dati anagrafici del fornitore.",
                    "profit_center_from_business_partner_master_data": "Copiato dai dati anagrafici del business partner.",
                    "department_from_procurement": "Copiato dall'ordine assegnato.",
                    "branch_from_procurement": "Copiato dall'ordine assegnato.",
                    "employee_from_procurement": "Copiato dall'ordine assegnato.",
                    "financial_dimension_from_procurement": "Copiato dall'ordine assegnato.",
                    "ledger_account_from_supplier_master_data": "Copiato dai dati anagrafici del fornitore.",
                    "cost_center_from_supplier_master_data": "Copiato dai dati anagrafici del fornitore.",
                    "ledger_account_from_business_partner_master_data": "Copiato dai dati anagrafici del business partner.",
                    "cost_center_from_business_partner_master_data": "Copiato dai dati anagrafici del business partner.",
                    "posting_key_from_recognized_tax": "Derivato dall'aliquota fiscale riconosciuta.",
                    "supplier_iban_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "supplier_bic_extracted_from_document": "Estratto direttamente dal documento fattura riconosciuto.",
                    "payment_bank_data_extracted_from_document": "L'origine dei dati bancari è stata impostata dai dati riconosciuti nel documento."
                }
            },
            "client_address_check": {
                "match": "È stato effettuato un controllo ai sensi del § 14 comma 4 UStG e non sono state riscontrate differenze.",
                "unrecognized": "Non è stato possibile verificare l'indirizzo perché non è stato riconosciuto sulla fattura.",
                "mismatch_intro": "È stato effettuato un controllo ai sensi del § 14 comma 4 UStG ed è stata riscontrata una differenza:",
                "invoice_label": "Dati sulla fattura",
                "master_data_label": "Dati nei dati anagrafici",
                "supplier_message_button": "Richiedi correzione",
                "supplier_message_greeting": "Gentili Signore e Signori,",
                "supplier_message_intro": "grazie per l'invio della fattura.",
                "supplier_message_invoice_number_label": "Numero fattura",
                "supplier_message_body": "Purtroppo l'indirizzo/nome della nostra azienda indicato nella fattura non è corretto. Ai sensi del § 14 comma 4 UStG, una fattura deve contenere l'indirizzo corretto e il nome del destinatario della prestazione per soddisfare i requisiti di legge.",
                "supplier_message_outro": "Pertanto non possiamo accettare la fattura nella sua forma attuale e vi chiediamo di inviarci una fattura corretta con l'indirizzo corretto.",
                "supplier_message_questions": "Restiamo volentieri a disposizione per eventuali domande.",
                "address_normalization": {
                    "street_aliases": ["via", "v.", "viale", "piazza", "p.zza", "corso", "strada", "s.da", "largo", "vicolo"],
                    "number_aliases": ["nr", "nr.", "no", "no.", "numero", "n.", "n°", "nº", "civico"]
                }
            },
            "no_client_recognized": "Non è stata trovata nessuna azienda sulla base del <b>ID IVA</b> o del <b>nome</b>.<br> Si prega di verificare se i dati dell'azienda in liftbase corrispondono ai dati della fattura.",
            "recognized_supplier_id": "In base a <b>IBAN</b>, <b>Partita IVA</b> e <b>Nome</b>, il fornitore è stato identificato con successo.<br> <b>Fornitore:</b> {supplier_name} <br> <b>Partita IVA:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_custom_prompt_title": "Prompt personalizzato del fornitore",
            "supplier_custom_prompt_applied": "Durante il riconoscimento della fattura è stato applicato un prompt personalizzato del fornitore.",
            "supplier_custom_prompt_supplier_label": "Fornitore",
            "supplier_custom_prompt_source_label": "Origine",
            "supplier_custom_prompt_confidence_label": "Confidenza",
            "supplier_custom_prompt_text_label": "Prompt",
            "supplier_custom_prompt_text_empty": "Per questo fornitore non è attualmente memorizzato alcun prompt personalizzato.",
            "supplier_custom_prompt_source": {
                "sender_domain": "Dominio mittente",
                "recognized_supplier_vat_iban": "Partita IVA/IBAN",
                "recognized_supplier_name": "Nome fornitore",
                "first_page_ai": "IA (1ª pagina PDF, testo)",
                "first_page_ai_file": "IA (1ª pagina PDF, scansione)"
            },
            "recognized_business_partner_id": "In base a <b>IBAN</b>, <b>Partita IVA</b> e <b>Nome</b>, il partner commerciale è stato identificato con successo.<br> <b>Partner commerciale:</b> {supplier_name} <br> <b>Partita IVA:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "no_supplier_recognized": "Non è stato trovato alcun fornitore sulla base del <b>ID IVA</b> o del <b>nome</b>.<br> Si prega di verificare se i dati del fornitore in liftbase corrispondono ai dati della fattura.",
            "payment_details_not_equal": "I dati di pagamento del fornitore non corrispondono ai dati riconosciuti o a quelli del modulo.<br> <b>Fornitore:</b> {supplier_name} <br> <b>Partita IVA:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "payment_details_not_equal_business_partner": "I dati di pagamento del partner commerciale non corrispondono ai dati riconosciuti o a quelli del modulo.<br> <b>Partner commerciale:</b> {supplier_name} <br> <b>Partita IVA:</b> {supplier_vat_number} <br> <b>IBAN:</b> {supplier_iban} <br> <b>BIC:</b> {supplier_bic}",
            "supplier_dialog_info": "\n<div style=\"text-align: justify\">\n    <style>\n        .modal-header {\n            margin-bottom: 0;\n        }\n\n        .modal-p {\n            margin-bottom: 10px !important;\n        }\n    </style>\n\n    <p class=\"modal-p\">\n        Abbiamo notato che il fornitore assegnato è cambiato.\n    </p>\n\n    <p class=\"modal-p\">\n        <strong>Possibile motivo:</strong><br>\n        Il riconoscimento del documento non è riuscito ad assegnare un fornitore o ne ha assegnato uno errato.\n    </p>\n\n    <b class=\"modal-header\">Ottimizzare l'assegnazione automatica</b>\n    <p class=\"modal-p\">\n        Sapevi che in <strong>liftbase</strong> puoi migliorare facilmente l'assegnazione automatica per i documenti futuri?\n        È sufficiente salvare nei dati anagrafici del fornitore le coordinate bancarie (IBAN, BIC) o la partita IVA.\n        <strong>liftbase</strong> utilizzerà queste informazioni per assegnare automaticamente il fornitore corretto la prossima volta.\n    </p>\n    <p class=\"modal-p\">\n        Nella sezione <strong>“Dati di pagamento”</strong> puoi adottare i dati riconosciuti dal sistema oppure inserirne di tuoi.\n    </p>\n\n    <img src=\"images/example-payment-data.png\" alt=\"Vista di esempio\"\n         style=\"border: 1px solid #9c9c9c; border-radius: 5px; max-width: 100%; margin-bottom: 10px;text-align: center\"><br>\n\n    <b class=\"modal-header\">Verifica automatica delle coordinate bancarie</b>\n    <p class=\"modal-p\">\n        Le coordinate bancarie salvate in <strong>liftbase</strong> vengono controllate automaticamente per ogni documento.\n        Se un documento contiene coordinate bancarie diverse, verrai avvisato.\n    </p>\n\n    <p class=\"modal-p\"><strong>I tuoi vantaggi:</strong></p>\n    <ul>\n        <li>Rilevare in modo affidabile fatture fraudolente con coordinate bancarie false</li>\n        <li>Identificare rapidamente quando il fornitore ha cambiato banca</li>\n    </ul>\n</div>",
            "supplier_dialog_title": "Riconoscimento automatico del fornitore",
            "total_brutto_missing": "Inserisca il totale lordo.",
            "total_brutto_zero": "Non deve avere un importo di 0 {currency}.",
            "total_brutto_does_not_match_with_positions": "L'importo totale deve corrispondere alla somma delle posizioni.",
            "total_brutto_difference": "Differenza importo to\u00ADta\u00ADle vs po\u00ADsi\u00ADzio\u00ADni: {value}",
            "combination_invalid": "La combinazione di conto contabile, centro di costo e centro di profitto non è consentita in D365.",
            "possible_combinations": "Combinazioni possibili",
            "current_combination": "Combinazione attuale",
            "combination": "Combinazione",
            "total_invoiced": "Importo totale fatturato",
            "total_expected_procurement": "Valore totale dell'ordine",
            "total_expected_contract": "Valore totale del contratto",
            "min_approval_one_person": "1 persona",
            "min_approval_qty": "{qty} persone diverse",
            "min_approval_error_msg": "L'approvazione non è sufficiente per questa fattura. Si prega di aggiungere un'altra persona per l'approvazione. Questa fattura deve essere approvata da <b>almeno {min_approval_msg}</b>.",
            "min_approval_error_title": "Approvazione insufficiente",
            "no_approval_limit_msg": "Il tuo limite di approvazione non è sufficiente per questa fattura. Si prega di aggiungere un'altra persona con il limite di approvazione necessario.",
            "no_approval_limit_title": "Limite di approvazione",
            "confirm_without_approval_limit_msg": "Nessuna delle persone selezionate ha il limite di approvazione necessario per l'importo di questa fattura. Le approvazioni necessarie possono essere aggiunte in seguito. Sei sicuro di voler procedere?",
            "confirm_without_approval_limit_title": "Limite di approvazione",
            "invoice_vat_number": "Partite IVA riconosciute",
            "supplier_vat_number": "Partita IVA nei dati anagrafici",
            "business_partner_vat_number": "Partita IVA nei dati anagrafici del partner commerciale",
            "copy_vat_number_to_supplier": "Trasferisci nei dati anagrafici",
            "supplier_payment_data": "Coordinate bancarie nei dati anagrafici",
            "business_partner_payment_data": "Coordinate bancarie nei dati anagrafici del partner commerciale",
            "invoice_payment_data": "Coordinate bancarie sul documento",
            "copy_payment_data_to_supplier": "Trasferisci dal documento ai dati anagrafici",
            "copy_payment_data_to_supplier_tooltip": "Facendo clic, i dati di pagamento inseriti nel modulo verranno copiati nei dati anagrafici del fornitore.",
            "copy_payment_data_to_business_partner_tooltip": "Facendo clic, i dati di pagamento inseriti nel modulo verranno copiati nei dati anagrafici del partner commerciale.",
            "lines": {
                "add_tooltip": "Aggiungere una linea di fatturazione",
                "get_from_recognition": "Prendi dal riconoscimento documento",
                "show_mismatch_panel_button": "Mostra deviazioni",
                "hide_mismatch_panel_button": "Nascondi deviazioni",
                "mismatch_warning_title": "Rilevate differenze tra lordo calcolato e lordo del documento",
                "match_suggestion": "Suggerimento",
                "match_confirmed": "Confermato",
                "match_automatic": "Automatico",
                "match_automatic_suggestion": "Suggerimento auto",
                "confirm_match": "Conferma match",
                "review_match": "Verifica",
                "match_confirm_dialog": {
                    "title": "Conferma assegnazione posizione",
                    "message": "Queste posizioni potrebbero corrispondere. Verifica i valori e scegli come salvare l'assegnazione.",
                    "copied_fields_title": "Altri dati che verranno acquisiti",
                    "copy_hint": "Solo assegnazione conferma il collegamento all'ordine. Acquisisci dati copia anche centro di costo, conto contabile e dimensioni finanziarie nella posizione fattura.",
                    "link_only_btn": "Conferma solo assegnazione",
                    "copy_data_btn": "Conferma e acquisisci dati"
                },
                "legend": {
                    "description": "Leggenda",
                    "no_order": "Articolo non incluso nell'ordine.",
                    "variance": "Varianza nelle colonne contrassegnate.",
                    "not_invoiced": "L'articolo ordinato non è presente nella fattura.",
                    "matched": "L'articolo nell'ordine e sulla fattura è identico."
                },
                "group_by_tax": "Raggruppa per aliquota",
                "group_by_tax_hint": "Aggrega le righe salvate per aliquota (es.: Somma 19% imposta).",
                "form": {
                    "item": "Articolo",
                    "new": "Nuova linea di fatturazione",
                    "validation": {
                        "description_required": "La preghiamo di inserire un nome.",
                        "item_number_required": "Inserisca un numero di articolo.",
                        "tax_percentage_required": "La preghiamo di selezionare una tassa valida.",
                        "unit_net_price_required": "Inserisca un numero valido.",
                        "quantity_required": "Inserisca un numero valido.",
                        "commercial_discount_invalid": "Lo sconto e la base devono avere lo stesso segno, le percentuali devono essere comprese tra 0% e 100% e lo sconto non può superare la base."
                    },
                    "tour": {
                        "name": "Fornisca un nome significativo per il prodotto.",
                        "number": "Qui può inserire il numero di articolo del prodotto.",
                        "price": "Inserisca un'aliquota fiscale e un prezzo netto unitario. Il prezzo lordo verrà calcolato utilizzando l'aliquota fiscale."
                    }
                },
                "table": {
                    "source": "Fonte",
                    "item_number": "Articolo No.",
                    "name": "Nome",
                    "quantity": "Quantità",
                    "tax": "Imposte (%)",
                    "netto_price": "Unità Netto",
                    "brutto_price": "Unità Lordo",
                    "line_discount_percentage": "Sconto (%)",
                    "show_discounts": "Inserisci sconto",
                    "show_discounts_tooltip": "Mostra i campi per gli sconti sul prezzo unitario e sulla riga. Si attiva automaticamente quando è presente uno sconto.",
                    "unit_price_base_amount": "Prezzo unitario prima dello sconto sul prezzo",
                    "unit_price_base_amount_tooltip": "Prezzo originale per unità prima della detrazione di uno sconto sul prezzo.",
                    "unit_price_discount_amount": "Sconto sul prezzo per unità",
                    "unit_price_discount_amount_tooltip": "Importo dello sconto per unità detratto dal prezzo unitario originale.",
                    "line_discount_amount": "Sconto totale sulla riga",
                    "line_discount_amount_tooltip": "Importo dello sconto per l'intera riga della fattura, non per unità.",
                    "line_discount_base_amount": "Base sconto riga",
                    "line_discount_base_amount_tooltip": "Importo totale della riga a cui viene applicato lo sconto.",
                    "line_discount_percentage_tooltip": "Percentuale applicata all'intera riga della fattura.",
                    "calc_brutto_from_net": "Calcola lordo da netto",
                    "calc_net_from_brutto": "Calcola netto da lordo",
                    "calc_brutto_from_net_tooltip": "Calcola solo il prezzo unitario lordo dal prezzo unitario netto e dall'aliquota IVA. Gli sconti sulla riga non vengono modificati.",
                    "calc_net_from_brutto_tooltip": "Calcola solo il prezzo unitario netto dal prezzo unitario lordo e dall'aliquota IVA. Gli sconti sulla riga non vengono modificati.",
                    "discount_validation_error": "Controlla i valori evidenziati in rosso.",
                    "total_netto_price": "Totale netto",
                    "tax_amount": "Imposta totale",
                    "total_brutto_price": "Totale lordo",
                    "cost_center": "Centro di costo",
                    "profit_center": "Centro di profitto",
                    "ledger_account": "Conto generale",
                    "tax_group": "Gruppo fiscale",
                    "tax_item_group": "Gruppo articoli fiscali",
                    "open_bcase": "Documento aperto",
                    "no_order_position": "Non sono state trovate posizioni d'ordine. Assegni un <b>ordine di acquisto (PO)</b> e un <b>fornitore</b> alla fattura.",
                    "no_contract_position": "Nessuna voce contrattuale trovata. Si prega di assegnare <b>un contratto e un fornitore</b> alla fattura.",
                    "copy_from_procurement": "Inserire tutti gli articoli dall'ordine d'acquisto",
                    "copy_from_contract": "Inserire tutti gli articoli dal contratto",
                    "no_order_tooltip": "Non è ancora stato collegato alcun ordine di acquisto.",
                    "no_supplier_tooltip": "Non c'è ancora nessun fornitore collegato.",
                    "validation_error": "La preghiamo di correggere gli errori nella tabella."
                }
            },
            "export_dialog": {
                "title": {
                    "D365": "Crea giornale",
                    "DATEV": "Invio a DATEV",
                    "DATEV CSV": "Esportazione CSV DATEV"
                },
                "description": "I seguenti documenti saranno inviati a {export_name}.",
                "description_csv": "I seguenti documenti verranno esportati per {export_name}.",
                "btn_confirm": "Invia",
                "btn_confirm_csv": "Esporta",
                "btn_finish": "Chiudi",
                "export_feedback_csv": "Esportato",
                "export_feedback": "Inviato",
                "exported_csv": "Esportato",
                "exported": "Inviato",
                "continue_background": "Continua in background",
                "exported_at": "Ultima esportazione",
                "is_loading": "Invio in corso",
                "is_loading_csv": "Esportazione in corso",
                "include_exported": "Includi le fatture già esportate",
                "export_selected_invoices_btn": "Invia selezione ({quantity}) a {export_name}",
                "export_cancelled_invoices_btn": "Invia annullate selezionate ({quantity}) a {export_name}",
                "export_all_cancelled_invoices_btn": "Invia tutte le annullate ({quantity}) a {export_name}",
                "export_all_invoices_btn": "Invia tutti i documenti ({quantity}) a {export_name}"
            },
            "export_menu": {
                "title": "Esporta",
                "group_ready": {
                    "title": "Esporta: Fatture completate"
                },
                "group_cancelled": {
                    "title": "Esporta: Fatture annullate"
                }
            },
            "bulk_cancel_dialog": {
                "selected_btn": {
                    "invoice": "Annulla le fatture selezionate ({quantity})",
                    "outgoing-invoice": "Annulla le fatture di vendita selezionate ({quantity})",
                    "procurement": "Annulla gli ordini selezionati ({quantity})",
                    "contract": "Annulla i contratti selezionati ({quantity})",
                    "mixed": "Annulla i documenti selezionati ({quantity})"
                },
                "confirm_title": {
                    "invoice": "Annulla fatture",
                    "outgoing-invoice": "Annulla fatture di vendita",
                    "procurement": "Annulla ordini",
                    "contract": "Annulla contratti",
                    "mixed": "Annulla documenti"
                },
                "confirm_message": {
                    "invoice": "Vuole davvero annullare tutte le fatture selezionate ({quantity})?",
                    "outgoing-invoice": "Vuole davvero annullare tutte le fatture di vendita selezionate ({quantity})?",
                    "procurement": "Vuole davvero annullare tutti gli ordini selezionati ({quantity})?",
                    "contract": "Vuole davvero annullare tutti i contratti selezionati ({quantity})?",
                    "mixed": "Vuole davvero annullare tutti i documenti selezionati ({quantity})?"
                },
                "confirm_btn": {
                    "invoice": "Annulla fatture",
                    "outgoing-invoice": "Annulla fatture di vendita",
                    "procurement": "Annulla ordini",
                    "contract": "Annulla contratti",
                    "mixed": "Annulla documenti"
                },
                "success": {
                    "invoice": "{quantity} fatture sono state annullate.",
                    "outgoing-invoice": "{quantity} fatture di vendita sono state annullate.",
                    "procurement": "{quantity} ordini sono stati annullati.",
                    "contract": "{quantity} contratti sono stati annullati.",
                    "mixed": "{quantity} documenti sono stati annullati."
                },
                "partial_success": {
                    "invoice": "{successCount} di {quantity} fatture sono state annullate.",
                    "outgoing-invoice": "{successCount} di {quantity} fatture di vendita sono state annullate.",
                    "procurement": "{successCount} di {quantity} ordini sono stati annullati.",
                    "contract": "{successCount} di {quantity} contratti sono stati annullati.",
                    "mixed": "{successCount} di {quantity} documenti sono stati annullati."
                },
                "error": {
                    "invoice": "Non è stato possibile annullare le fatture selezionate.",
                    "outgoing-invoice": "Non è stato possibile annullare le fatture di vendita selezionate.",
                    "procurement": "Non è stato possibile annullare gli ordini selezionati.",
                    "contract": "Non è stato possibile annullare i contratti selezionati.",
                    "mixed": "Non è stato possibile annullare i documenti selezionati."
                }
            },
            "bulk_repeat_recognition_dialog": {
                "bulk_repeat_recognition_selected_invoices_btn": "Ripeti riconoscimento documento ({quantity})",
                "confirm_title": "Ripeti riconoscimento documento",
                "confirm_message": "I dati esistenti nelle fatture selezionate ({quantity}) verranno sovrascritti. Sei sicuro di voler procedere?",
                "intro_message": "Il riconoscimento del documento verrà riavviato per le fatture selezionate ({quantity}). I dati esistenti nel modulo potrebbero essere sovrascritti.",
                "background_notice": "Puoi eseguirlo ora e attendere il feedback oppure avviare direttamente il processo in background.",
                "run_now_btn": "Esegui ora",
                "run_background_btn": "Avvia in background",
                "background_started": "Il riconoscimento del documento è stato avviato in background per {quantity} fatture.",
                "success": "Il riconoscimento del documento è stato riavviato per {quantity} fatture.",
                "partial_success": "Il riconoscimento del documento è stato riavviato per {successCount} di {quantity} fatture.",
                "error": "Non è stato possibile riavviare il riconoscimento del documento per le fatture selezionate."
            },
            "select_columns_dialog": {
                "title": "Seleziona colonne",
                "select_fields": "Le seguenti colonne verranno visualizzate sotto <i>Le mie attività</i> e <i>Tutti i documenti</i>.",
                "btn_confirm": "Applica",
                "btn_finish": "Chiudi"
            },
            "copy_procurement_dialog": {
                "title": "Copiare i dati dall'ordine d'acquisto",
                "message": "Desidera copiare alcuni dati dall'ordine di acquisto a questa fattura?",
                "message_contract": "Vuoi importare alcuni dati dal contratto in questa fattura?",
                "overwrite_checkbox": "Sovrascrive i dati esistenti nel modulo.",
                "select_supplier_msg": "Selezioni il fornitore da cui desidera copiare i dati:",
                "select_supplier_placeholder": "Selezionare il fornitore",
                "confirm_btn": "Confermare"
            },
            "copy_from_recognition_dialog": {
                "title": "Importa dati",
                "message": "Vuoi trasferire alcuni dati dal riconoscimento della fattura o dal modulo a questo fornitore?",
                "add_payment_method": "Vuoi anche aggiornare il metodo di pagamento?",
                "select_iban": "Seleziona tra gli IBAN trovati.",
                "select_vat_number": "Seleziona tra le Partite IVA trovate.",
                "select_bic": "Seleziona tra i BIC trovati.",
                "success_msg": "Fornitore aggiornato.",
                "confirm_btn": "Conferma"
            },
            "validation": {
                "invoice_date_required": "Inserisca la data della fattura.",
                "due_date_required": "Inserisca una data di scadenza.",
                "due_date_invalid1": "La data di scadenza deve essere superiore alla data del documento.",
                "delivery_date_required": "Inserisca una data di consegna.",
                "ledger_account_required": "Selezioni un conto contabile.",
                "branch_required": "Si prega di selezionare una filiale.",
                "posting_key_required": "Selezioni una chiave di distacco.",
                "document_discount_tax_required": "Seleziona un'aliquota IVA dello sconto documento usata da almeno una riga della fattura.",
                "supplier_required": "Selezioni un fornitore.",
                "business_partner_required": "Selezioni un partner commerciale.",
                "cost_center_required": "Selezioni un centro di costo.",
                "profit_center_required": "Si prega di selezionare un centro di profitto.",
                "employee_required": "Si prega di selezionare un dipendente.",
                "d365_branch_id_required": "Si prega di selezionare una filiale.",
                "d365_employee_id_required": "Si prega di selezionare un dipendente.",
                "d365_department_required": "Si prega di selezionare un dipartimento D365.",
                "financial_dimension_required": "Seleziona una dimensione finanziaria.",
                "client_required": "Selezioni un'azienda.",
                "number_required": "Inserisca il numero della fattura.",
                "prefix_required": "Inserisci il prefisso e il numero della fattura.",
                "number_invalid_d365": "Non deve contenere più di 20 caratteri.",
                "number_invalid": "Deve contenere fino a 36 caratteri alfanumerici, senza dieresi, e i caratteri $ % & * + - /.",
                "notes_length": "Non deve superare i 120 caratteri.",
                "discount_percentage_invalid1": "La percentuale di sconto deve essere maggiore di 0.",
                "discount_percentage_invalid2": "Lo sconto 1 deve essere maggiore dello sconto 2.",
                "discount_amount_invalid1": "Per gli importi delle fatture positive sono accettabili solo gli importi positivi.",
                "discount_amount_invalid2": "Per gli importi negativi delle fatture sono accettabili solo gli importi negativi.",
                "discount_amount_invalid3": "Lo sconto 1 deve essere maggiore dello sconto 2.",
                "discount_amount_invalid4": "Lo sconto deve essere inferiore all'importo totale.",
                "discount_amount_invalid5": "La somma degli importi degli sconti deve essere inferiore all'importo.",
                "discount_date_invalid1": "Le date di sconto 1 e 2 devono essere comprese tra la fattura e la data di scadenza.",
                "discount_date_invalid2": "La data di sconto 1 deve essere precedente alla data di sconto 2.",
                "missing_discount_field": "Tutti i campi dello sconto devono essere compilati.",
                "procurement_required": "Seleziona una richiesta di acquisto.",
                "contract_required": "Seleziona un contratto.",
                "iban_required": "Inserisci un IBAN.",
                "bank_country_required": "Inserisci il paese della banca.",
                "bank_country_invalid": "Inserisci un codice paese ISO di 2 lettere.",
                "bank_account_required": "Inserisci un numero di conto.",
                "bank_code_required": "Inserisci un codice bancario."
            }
        }
    },
    "outgoing_invoice": {
        "description": "Fattura in uscita",
        "page": {
            "upload": {
                "title": "Carica nuove fatture in uscita"
            }
        }
    },
    "invoice_line": {
        "item_number": "Numero di articolo",
        "quantity": "Quantità",
        "unit_net_price": "Unità Prezzo netto",
        "tax_percentage": "Imposta",
        "has_discount": "La posizione ha uno sconto",
        "unit_price_base_amount": "Prezzo unitario prima dello sconto (BT-148)",
        "unit_price_discount_amount": "Sconto sul prezzo (BT-147)",
        "line_discount_amount": "Sconto sulla riga (BT-136)",
        "line_discount_base_amount": "Base sconto riga (BT-137)",
        "line_discount_percentage": "Sconto riga % (BT-138)"
    },
    "location": {
        "name": "Nome",
        "number": "Numero",
        "address": "Indirizzo",
        "form_sequence": "name,number,address"
    },
    "spreadsheet": {
        "add_row": "Aggiungi linea",
        "download": "Scarica la Tabella",
        "save": "Salva la tabella"
    },
    "audit_log": {
        "description": "Modifiche",
        "history": "Modifiche",
        "table": "Tabella",
        "lb_user_id": "Utente",
        "data_before": "Prima",
        "data_after": "Dopo",
        "created_at": "Data",
        "type": {
            "insert": "Aggiunto",
            "update": "Modificato",
            "delete": "Rimosso"
        },
        "msg": {
            "deleted": "rimosso",
            "inserted": "aggiunto",
            "was_deleted": "È stato rimosso.",
            "was_inserted": "È stato aggiunto.",
            "created_by_historical_invoice_onboarding": "Creato durante l'onboarding storico delle fatture."
        },
        "none": "nessuno",
        "empty": "Non sono disponibili modifiche."
    },
    "txt_before_leave_page": "Le sue modifiche potrebbero non essere salvate. È sicuro di voler procedere?",
    "easybill_invoice": {
        "from_tenant": "Da parte dell'inquilino",
        "no_invoice": "Non è stata ancora creata alcuna fattura.",
        "number": "Numero",
        "service_date": "Periodo",
        "from": "Da",
        "until": "a",
        "total": "Totale",
        "due_date": "Data di scadenza",
        "status": "Stato",
        "paid_at": "Pagato su",
        "payment_missing": "In attesa",
        "sepa": "SEPA",
        "tour": {
            "invoice_table": "Qui può trovare una panoramica dettagliata di tutte le fatture di liftbase, compreso il loro stato. Le fatture possono essere scaricate tramite un pulsante."
        }
    },
    "configuration": {
        "description": "Impostazioni",
        "sepa_number": "Numero di identificazione del creditore",
        "sepa_mandate_reference": "Riferimento del mandato",
        "remove_sepa_msg": "È sicuro di voler revocare l'addebito diretto SEPA?",
        "remove_sepa_btn": "Revocare",
        "system-modules-procurement": "Modulo - Richieste di acquisto",
        "system-modules-invoice": "Modulo - Fatture",
        "system-modules-bank-statements": "Modulo - Abbinamento estratti conto",
        "system-modules-permissions": "Modulo - Gruppi di autorizzazione",
        "system-modules-multilingualism": "Modulo - Dati anagrafici multilingue",
        "system-modules-invoice-export": "Modulo - Esportazione fatture a",
        "purchaseorder-defaults-selectproduct": "Impostazioni di ruolo - Persona “Selezione prodotto”",
        "purchaseorder-defaults-sendorder": "Impostazioni di ruolo - Persona “Invio ordine”",
        "purchaseorder-defaults-clearing": "Impostazioni di ruolo - Persona “Chiarimenti acquisto”",
        "purchaseorder-defaults-consignee": "Impostazioni di ruolo - Persona “Ricevimento merci”",
        "invoice-defaults-manual_check": "Impostazioni di ruolo - Persona “Verifica manuale (fattura)”",
        "invoice-defaults-clearing": "Impostazioni di ruolo - Persona “Chiarimenti contabilità”",
        "purchaseorder-defaults-init_seq": "Richieste di acquisto - Numerazione ordini a partire da",
        "purchaseorder-product-require_product_group": "Richieste di acquisto - Tutti i prodotti devono essere assegnati a un gruppo di prodotti.",
        "purchaseorder-product-require_product_selection": "Richieste di acquisto - Processo di richiesta di acquisto",
        "email-send-order": "Ordini - Invio e-mail",
        "purchaseorder-pdf-free-text": "Ordini - PDF d'ordine",
        "type_email-send-order": "html-i18n",
        "type_purchaseorder-pdf-free-text": "html-i18n",
        "invoice-recognition-lines": "Fatture - Creazione automatica delle righe di fattura dal riconoscimento dei documenti.",
        "invoice-recognition-timeout": "Fatture - Timeout riconoscimento Azure",
        "invoice-form-procurement-required": "Fatture - Collegamento alla richiesta d'acquisto necessario.",
        "notifications-mail-interval": "Notifiche - Intervallo e-mail in minuti",
        "punchout-amazon-identity": "Integrazioni - Punch-out Amazon - Identità",
        "punchout-amazon-secret": "Integrazioni - Punch-out Amazon - Segreto",
        "punchout-amazon-url": "Integrazioni - Punch-out Amazon - URL Punch-out",
        "punchout-amazon-order-url": "Integrazioni - Punch-out Amazon - URL Ordine",
        "punchout-amazon-email": "Integrazioni - Punch-out Amazon - E-Mail",
        "punchout-amazon-supplier": "Integrazioni - Punch-out Amazon - Fornitore predefinito",
        "punchout-mercateo-identity": "Integrazioni - Punch-out Mercateo - Identità",
        "punchout-mercateo-secret": "Integrazioni - Punch-out Mercateo - Segreto",
        "punchout-mercateo-url": "Integrazioni - Punch-out Mercateo - URL Punch-out",
        "punchout-mercateo-order-url": "Integrazioni - Punch-out Mercateo - URL Ordine",
        "punchout-mercateo-email": "Integrazioni - Punch-out Mercateo - E-Mail",
        "punchout-mercateo-supplier": "Integrazioni - Punch-out Mercateo - Fornitore predefinito",
        "punchout-rajapack-identity": "Integrazioni - Punch-out RAJA - Identità",
        "punchout-rajapack-secret": "Integrazioni - Punch-out RAJA - Segreto",
        "punchout-rajapack-url": "Integrazioni - Punch-out RAJA - URL Punch-out",
        "punchout-rajapack-order-url": "Integrazioni - Punch-out RAJA - URL Ordine",
        "punchout-rajapack-email": "Integrazioni - Punch-out RAJA - E-Mail",
        "punchout-rajapack-supplier": "Integrazioni - Punch-out RAJA - Fornitore predefinito",
        "punchout-conrad-identity": "Integrazioni - Punch-out Conrad - Identità",
        "punchout-conrad-secret": "Integrazioni - Punch-out Conrad - Segreto",
        "punchout-conrad-url": "Integrazioni - Punch-out Conrad - URL Punch-out",
        "punchout-conrad-order-url": "Integrazioni - Punch-out Conrad - URL Ordine",
        "punchout-conrad-email": "Integrazioni - Punch-out Conrad - E-Mail",
        "punchout-conrad-supplier": "Integrazioni - Punch-out Conrad - Fornitore predefinito",
        "punchout-thgeyer-identity": "Integrazioni - Punch-out TH-GEYER - Identità",
        "punchout-thgeyer-secret": "Integrazioni - Punch-out TH-GEYER - Segreto",
        "punchout-thgeyer-url": "Integrazioni - Punch-out TH-GEYER - URL Punch-out",
        "punchout-thgeyer-supplier": "Integrazioni - Punch-out TH-GEYER - Fornitore predefinito",
        "punchout-reichelt-identity": "Integrazioni - Punch-out Reichelt - Identità",
        "punchout-reichelt-secret": "Integrazioni - Punch-out Reichelt - Segreto",
        "punchout-reichelt-url": "Integrazioni - Punch-out Reichelt - URL Punch-out",
        "punchout-reichelt-supplier": "Integrazioni - Punch-out Reichelt - Fornitore predefinito",
        "validation": {
            "bic_invalid": "Inserisca un BIC valido.",
            "iban_invalid": "Inserisca un numero IBAN valido.",
            "default_decimal_places_invalid": "Specificare da 2 a 4 cifre decimali."
        },
        "datev": {
            "description": "DATEV",
            "connection": "Collegamento con DATEV",
            "status_active": "Attivo",
            "status_inactive": "Inattivo",
            "from": "Da",
            "until": "Fino a quando",
            "load_clients": "Caricare i clienti DATEV",
            "remove_connection": "Rimuovere la connessione",
            "deactivate_connection": "Disattiva connessione",
            "add_connection": "Impostare la connessione",
            "connected_by": "Connessione stabilita da {name}.",
            "apps_manager": "Qui può gestire le <a href=\"https://apps.datev.de/tokrevui\" target=\"_blank\">applicazioni collegate a DATEV</a>.",
            "msg_no_clients": "Non sono state trovate voci o lei non dispone dei permessi necessari o la connessione deve essere configurata di nuovo.",
            "fiscal_year_start": "Inizio dell'anno fiscale",
            "account_length": "Lunghezza del conto",
            "is_accounts_payable_ledger_available": "Registro dei conti pagabili",
            "is_accounts_receivable_ledger_available": "Registro dei crediti",
            "client_number": "Numero cliente",
            "consultant_number": "Numero del consulente",
            "client_name": "Cliente",
            "liftbase_client": "Azienda liftbase",
            "save_client": "Salva l'azienda",
            "change_client": "Cambia azienda"
        },
        "ms365": {
            "description": "D365",
            "connection": "Connessione a D365",
            "status_active": "attivo",
            "status_inactive": "inattivo",
            "auth_type": "Autenticazione",
            "oauth": "OAuth (Consenso utente)",
            "client_secret_auth": "Client Credentials (App Client ID + Secret)",
            "app_client_id": "App Client ID (Applicazione Azure)",
            "app_tenant_id": "Azure Tenant ID",
            "client_secret": "Client Secret",
            "client_credentials_note": "Se vengono forniti App Client ID e Client Secret, per l'export delle fatture verrà usato il flusso Client Credentials. L'import via e‑mail resta invariato (OAuth).",
            "connect_and_load_data": "Stabilire una connessione e caricare i dati",
            "connect": "Stabilire una connessione",
            "load_data": "Carica tutti i dati",
            "remove_connection": "Rimuovi Connessione",
            "add_connection": "Configura Connessione",
            "no_client_found": "Nessun cliente D365 trovato.",
            "msg_no_clients": "Nessun elemento trovato o mancano le autorizzazioni necessarie o la connessione deve essere configurata nuovamente.",
            "client_number": "Numero Aziendale D365",
            "client_name": "Azienda D365",
            "liftbase_client": "Azienda liftbase",
            "save_client": "Salva Azienda",
            "change_client": "Modifica Azienda",
            "sync_running": "I dati stanno caricando. Potrebbe richiedere alcuni minuti.",
            "last_sync_at": "Ultimo caricamento: {last_sync_at}",
            "journal_name": "Nome del giornale",
            "org_url": "URL dell'organizzazione",
            "http_read_timeout": {
                "label": "Timeout di lettura HTTP per D365",
                "hint": "Definisce per quanto tempo liftbase attende una risposta da D365. Lasciare vuoto per usare la configurazione globale del backend. Esempi: <b>420s</b>, <b>5m</b>, <b>1h</b>.",
                "error": "Inserire un timeout positivo, ad es. 420s, 5m o 1h."
            },
        },
        "datev-csv": {
            "description": "DATEV CSV",
        },
        "template": {
            "module-procurement": {
                "group": "Moduli",
                "label": "Ordine di acquisto",
                "tour": [
                    {
                        "target": ".step-moduli",
                        "content": "<p>Selezioni i moduli liftbase che desidera attivare. Può trovare informazioni sui costi su <a href=\"liftbase.de/preise\" target=\"_blank\">liftbase.de/preise</a>.</p>"
                    }
                ]
            },
            "module-invoice": {
                "group": "Moduli",
                "label": "Fattura"
            },
            "module-outgoing-invoice": {
                "group": "Moduli",
                "label": "Fatture in uscita"
            },
            "module-bank-statements": {
                "group": "Moduli",
                "label": "Abbinamento estratti conto"
            },
            "module-contract": {
                "group": "Moduli",
                "label": "Contratti"
            },
            "module-permissions": {
                "group": "Moduli",
                "label": "Gruppo di autorizzazione"
            },
            "module-multilingualism": {
                "group": "Moduli",
                "label": "Dati principali multilingue"
            },
            "module-supplier-communication": {
                "group": "Moduli",
                "label": "Comunicazione con i fornitori"
            },
            "module-liquidity-planning": {
                "group": "Moduli",
                "label": "Pianificazione della liquidità"
            },
            "insolvency-law-fields": {
                "group": "Moduli",
                "label": "Mostra campi di diritto fallimentare"
            },
            "approval-limit-priority": {
                "group": "Moduli",
                "label": "Livello di priorità del limite di approvazione"
            },
            "custom-fields": {
                "group": "Moduli",
                "label": "Campi personalizzati"
            },
            "module-invoice-export": {
                "group": "Moduli",
                "label": "Esportazione fattura a",
                "options": [
                    {
                        "value": "datev",
                        "content": "DATEV"
                    },
                    {
                        "value": "ms365",
                        "content": "D365"
                    },
                    {
                        "value": "datev-csv",
                        "content": "DATEV CSV"
                    }
                ]
            },
            "procurement-select-product": {
                "group": "Ruolo predefinito",
                "label": "Persona \"Selezione del prodotto",
                "tour": [
                    {
                        "target": ".assegnazione dei passi",
                        "content": "<p>Qui può impostare i ruoli predefiniti globali. Se non sono stati definiti ruoli predefiniti per l'azienda o il reparto, le persone inserite qui saranno assegnate alle rispettive fasi del flusso di lavoro degli ordini di acquisto e delle fatture.</p>"
                    }
                ]
            },
            "procurement-send-order": {
                "group": "Ruolo predefinito",
                "label": "Persona \"Ordine\""
            },
            "procurement-clearing": {
                "group": "Ruolo predefinito",
                "label": "Persona \"Chiarimenti sull'acquisto\"",
                "hint": "Per chiarire i problemi nei processi di approvvigionamento."
            },
            "procurement-consignee": {
                "group": "Ruolo predefinito",
                "label": "Persona \"Ricevimento della merce\""
            },
            "invoice-manual-check": {
                "group": "Ruolo predefinito",
                "label": "Persona \"Controllo manuale (fattura)\"."
            },
            "invoice-clearing": {
                "group": "Ruolo predefinito",
                "label": "Persona \"Chiarimento contabile",
                "hint": "Per risolvere i problemi durante l'elaborazione delle fatture."
            },
            "contract-clearing": {
                "group": "Ruolo predefinito",
                "label": "Persona \"Chiarimenti contratto\"",
                "hint": "Per i chiarimenti nei flussi contrattuali."
            },
            "procurement-init-seq": {
                "group": "Ordini di acquisto",
                "label": "Numeri d'ordine iniziali",
                "hint": "Inserisca un numero da cui far partire i numeri d'ordine.",
                "validation": {
                    "interval": "Deve essere compreso tra 0 e 999999999.",
                    "type": "Deve contenere solo numeri interi."
                },
                "tour": [
                    {
                        "target": ".step-procurement",
                        "content": "Qui troverà le impostazioni relative agli ordini di acquisto. Configura il numero iniziale per gli ordini di acquisto e se tutti i prodotti negli ordini di acquisto devono essere assegnati ad un gruppo di prodotti."
                    }
                ]
            },
            "procurement-require-product-group": {
                "group": "Ordini di acquisto",
                "label": "Tutti i prodotti devono appartenere a un gruppo di prodotti."
            },
            "procurement-skip-place-order": {
                "group": "Purchase requisitions",
                "label": "Automatic transmission of the order to the online shop",
                "hint": "After the PunchOut, the online shop waits for approval in the ordering system. Without this option, the transmission must be started manually via the \"Transmit electronically\" button. With this option, the order is automatically transmitted electronically after approval. Works only for orders with a single supplier."
            },
            "procurement-require-product-selection": {
                "group": "Ordini di acquisto",
                "label": "Ordini di acquisto",
                "options": [
                    {
                        "value": "vero",
                        "content": "con la selezione del prodotto<br><ul><li>Crea l'ordine di acquisto</li><li>Selezione del prodotto</li><li>Approvazione</li><li>Ordine</li><li>Ricevimento della merce</li></ul>"
                    },
                    {
                        "value": "falso",
                        "content": "senza selezione del prodotto<br><ul><li>Creazione dell'ordine di acquisto</li><li>Approvazione</li><li>Ordine</li><li>Ricevimento della merce</li></ul>"
                    }
                ]
            },
            "email-send-order": {
                "group": "Ordini",
                "label": "Ordine via e-mail",
                "hint": "Messaggio e-mail generato durante la fase di inserimento dell'ordine, che include il PDF dell'ordine, e inviato al fornitore.",
                "default_value": "Gentile Signore/Signora,<br>Le invio il nostro ordine in allegato PDF. La prego di fornirci una conferma dell'ordine.",
                "tour": [
                    {
                        "target": ".step-email-order-free-text",
                        "content": "Componga qui un testo che sarà incluso nel messaggio e-mail generato durante la fase di inserimento dell'ordine, compreso il PDF dell'ordine, e inviato al fornitore."
                    },
                    {
                        "target": ".step-pdf-free-text",
                        "content": "Componga qui un testo che sarà visualizzato sul PDF dell'ordine generato durante la fase di inserimento dell'ordine, che sarà successivamente inviato al fornitore."
                    }
                ]
            },
            "procurement-pdf-free-text": {
                "group": "Ordini",
                "label": "Ordine di acquisto PDF",
                "hint": "Messaggio visualizzato sul PDF dell'ordine di acquisto generato durante la fase di inserimento dell'ordine, che sarà successivamente inviato al fornitore.",
                "default_value": "",
            },
            "procurement-pdf-show-department": {
                "group": "Ordini",
                "label": "Mostra reparto nel PDF dell'ordine"
            },
            "procurement-pdf-show-cost-center": {
                "group": "Ordini",
                "label": "Mostra centro di costo nel PDF dell'ordine"
            },
            "procurement-pdf-show-created-by": {
                "group": "Ordini",
                "label": "Mostra 'Creato da' nel PDF dell'ordine"
            },
            "procurement-pdf-show-approver": {
                "group": "Ordini",
                "label": "Mostra approvatore nel PDF dell'ordine"
            },
            "procurement-pdf-show-offer": {
                "group": "Ordini",
                "label": "Mostra offerta nell'elenco delle posizioni"
            },
            "procurement-pdf-show-vat-number": {
                "group": "Ordini",
                "label": "Mostra Partita IVA nel PDF dell'ordine"
            },
            "invoice-recognition-lines": {
                "group": "Fatture",
                "label": "Prendi automaticamente le voci che il riconoscimento documento ha identificato."
            },
            "invoice-recognition-group-by-tax": {
                "group": "Fatture",
                "label": "Raggruppa le righe di fattura riconosciute per aliquota",
                "hint": "Se abilitato, le righe riconosciute vengono raggruppate per aliquota (es.: Somma 19% imposta)."
            },
            "invoice-recognition-ai-validation-mode": {
                "group": "Fatture",
                "label": "Modalità predefinita di validazione AI per il caricamento delle fatture",
                "hint": "Questa modalità è preselezionata durante il caricamento e può essere modificata prima di creare la fattura.",
                "options": [
                    {
                        "value": "none",
                        "content": "Nessuna validazione AI"
                    },
                    {
                        "value": "advisory",
                        "content": "Attiva e lascia invariato lo stato"
                    },
                    {
                        "value": "ready-for-export",
                        "content": "Attiva e sposta in Pronto per l'esportazione"
                    }
                ]
            },
            "invoice-recognition-custom-fields": {
                "group": "Fatture",
                "label": "Estrarre i campi personalizzati durante il riconoscimento Azure",
                "hint": "Se abilitato, inviamo a Azure Document Intelligence i queryFields (basati sui tuoi campi personalizzati) per estrarre i valori. Questo può aumentare i costi di elaborazione."
            },
            "invoice-recognition-custom-prompt": {
                "group": "Fatture",
                "label": "Prompt personalizzato globale per il riconoscimento delle fatture",
                "hint": "Queste istruzioni vengono applicate al riconoscimento delle fatture del tenant e combinate con eventuali prompt specifici per azienda o fornitore."
            },
            "invoice-recognition-model": {
                "group": "Fatture",
                "label": "Riconoscimento documenti Azure – Modello",
                "options": [
                    {
                        "value": "document-intelligence",
                        "content": "Azure Document Intelligence (classico)"
                    },
                    {
                        "value": "content-understanding",
                        "content": "Azure Content Understanding (GenAI)"
                    },
                    {
                        "value": "azure-open-ai",
                        "content": "Azure OpenAI Responses API"
                    }
                ]
            },
            "invoice-recognition-timeout": {
                "group": "Fatture",
                "label": "Timeout riconoscimento Azure per regione",
                "hint": "Definisce per quanto tempo liftbase deve interrogare una regione Azure prima di passare alla regione configurata successiva. Valore predefinito: <b>150s</b>. Esempi: <b>150s</b>, <b>5m</b>, <b>1h</b>.",
                "validation": {
                    "format": "Inserisci una durata come 150s, 5m o 1h."
                }
            },
            "invoice-procurement-required": {
                "group": "Fatture",
                "label": "È necessario collegare la richiesta di acquisto o il contratto."
            },
            "invoice-approval": {
                "group": "Fatture",
                "label": "Quando deve essere approvata una fattura?",
                "options": [
                    {
                        "value": "always",
                        "content": "<b>Sempre</b><br>Le fatture devono sempre essere approvate."
                    },
                    {
                        "value": "if-no-order",
                        "content": "<b>Solo se non è assegnata né una PO né un CT</b><br>L'approvazione è richiesta solo se non è presente né una Richiesta di Acquisto (PO) né un Contratto (CT)."

                    },
                    {
                        "value": "never",
                        "content": "<b>Mai</b><br>Le fatture non richiedono un'approvazione separata."
                    }
                ]
            },
            "notifications-mail-interval": {
                "group": "Notifiche",
                "label": "Intervallo e-mail in minuti",
                "tour": [
                    {
                        "target": ".step-notification",
                        "content": "Imposta una frequenza globale per le notifiche via e-mail sui nuovi compiti. Le notifiche via e-mail vengono inviate solo quando una persona riceve un nuovo compito."
                    }
                ]
            },
            "product-default-tax": {
                "group": "Articolo",
                "label": "Aliquota fiscale standard (%)"
            },
            "product-default-currency": {
                "group": "Articolo",
                "label": "Valuta predefinita"
            },
            "product-default-unit": {
                "group": "Articolo",
                "label": "Unità predefinita"
            },
            "punchout-amazon-identity": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Amazon",
                "label": "Identità",
                "tour": [
                    {
                        "target": ".step-punchout-amazon",
                        "content": "Qui può impostare il suo accesso ai marketplace integrati come Amazon e Mercateo. Le istruzioni si trovano <a href=\"https://liftbase.de/handbuch/einrichtung/punch-out\" target=\"_blank\">nel nostro manuale</a>."
                    }
                ]
            },
            "punchout-amazon-secret": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Amazon",
                "label": "Segreto"
            },
            "punchout-amazon-url": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Amazon",
                "label": "URL del sistema integrato"
            },
            "punchout-amazon-order-url": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Amazon",
                "label": "URL dell'ordine"
            },
            "punchout-amazon-email": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Amazon",
                "label": "Email",
                "hint": "L'indirizzo e-mail dell'account Amazon principale. <br>Lasciare vuoto per trasmettere l'indirizzo e-mail della persona collegata. <br>Può richiedere un account Amazon per persona."
            },
            "punchout-amazon-supplier": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Amazon",
                "label": "Fornitore",
                "hint": "A quale fornitore devono essere assegnati gli ordini di questo fornitore di Punch-out (ad esempio, nei rapporti)?"
            },
            "punchout-mercateo-identity": {
                "group": "Integrazioni",
                "subgroup": "Punch-out Mercateo",
                "label": "Identità"
            },
            "punchout-mercateo-secret": {
                "group": "Integrazioni",
                "subgroup": "Punch-out Mercateo",
                "label": "Segreto"
            },
            "punchout-mercateo-url": {
                "group": "Integrazioni",
                "subgroup": "Punch-out Mercateo",
                "label": "URL del sistema integrato"
            },
            "punchout-mercateo-order-url": {
                "group": "Integrazioni",
                "subgroup": "Punch-out Mercateo",
                "label": "URL dell'ordine"
            },
            "punchout-mercateo-email": {
                "group": "Integrazioni",
                "subgroup": "Punch-out Mercateo",
                "label": "Email",
                "hint": "L'indirizzo e-mail dell'account Mercateo principale. <br>Lasciare vuoto per trasmettere l'indirizzo e-mail della persona collegata. <br>Può richiedere un account Mercateo per persona."
            },
            "punchout-mercateo-supplier": {
                "group": "Integrazioni",
                "subgroup": "Punch-out Mercateo",
                "label": "Fornitore",
                "hint": "A quale fornitore devono essere assegnati gli ordini di questo fornitore di Punch-out (ad esempio, nei rapporti)?"
            },
            "punchout-rajapack-identity": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura RAJA",
                "label": "Identità"
            },
            "punchout-rajapack-secret": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura RAJA",
                "label": "Segreto"
            },
            "punchout-rajapack-url": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura RAJA",
                "label": "URL del sistema integrato"
            },
            "punchout-rajapack-order-url": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura RAJA",
                "label": "URL dell'ordine"
            },
            "punchout-rajapack-email": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura RAJA",
                "label": "Email"
            },
            "punchout-rajapack-supplier": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura RAJA",
                "label": "Fornitore",
                "hint": "A quale fornitore devono essere assegnati gli ordini di questo fornitore di Punch-out (ad esempio, nei rapporti)?"
            },
            "punchout-conrad-identity": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Conrad",
                "label": "Identità"
            },
            "punchout-conrad-secret": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Conrad",
                "label": "Segreto"
            },
            "punchout-conrad-url": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Conrad",
                "label": "URL del sistema integrato"
            },
            "punchout-conrad-order-url": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Conrad",
                "label": "URL dell'ordine"
            },
            "punchout-conrad-email": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Conrad",
                "label": "Email"
            },
            "punchout-conrad-supplier": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Conrad",
                "label": "Fornitore",
                "hint": "A quale fornitore devono essere assegnati gli ordini di questo fornitore di Punch-out (ad esempio, nei rapporti)?"
            },
            "punchout-thgeyer-identity": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura TH.GEYER",
                "label": "Identità"
            },
            "punchout-thgeyer-secret": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura TH.GEYER",
                "label": "Segreto"
            },
            "punchout-thgeyer-url": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura TH.GEYER",
                "label": "URL del sistema integrato"
            },
            "punchout-thgeyer-supplier": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura TH.GEYERTH.GEYER",
                "label": "Azienda fornitrice predefinita",
                "hint": "A quale fornitore devono essere assegnati gli ordini di questo fornitore di Punch-out (ad esempio, nei rapporti)?"
            },

            "punchout-reichelt-identity": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Reichelt",
                "label": "Identità"
            },
            "punchout-reichelt-secret": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Reichelt",
                "label": "Segreto"
            },
            "punchout-reichelt-url": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Reichelt",
                "label": "URL del sistema integrato"
            },
            "punchout-reichelt-supplier": {
                "group": "Integrazioni",
                "subgroup": "Punzonatura Reichelt",
                "label": "Azienda fornitrice predefinita",
                "hint": "A quale fornitore devono essere assegnati gli ordini di questo fornitore di Punch-out (ad esempio, nei rapporti)?"
            },
            "tour": [
                {
                    "target": "",
                    "content": ""
                }
            ]
        },
        "tour": {
            "tab_general": "Qui può indicare il nome della sua azienda per l'ambiente liftbase.",
            "tab_contact": "Inserisca qui le informazioni di contatto della sua azienda. Questi dati saranno utilizzati per l'invio e la consegna delle fatture per l'utilizzo di liftbase.",
            "tab_bank": "Qui può impostare un addebito diretto SEPA per la fatturazione di liftbase o revocarlo.",
            "tab_datev": "Qui può impostare l'integrazione con DATEV. Innanzitutto, deve accedere a DATEV per caricare tutti i clienti disponibili. Poi, può collegare questi clienti con le aziende registrate qui in liftbase. Successivamente, deve collegare individualmente ogni cliente con DATEV per trasmettere le esportazioni per loro. Questa connessione ha un periodo di validità di 2 anni e si estende ogni volta che viene utilizzata per un'esportazione.",
            "tab_marketplaces": "Qui puoi configurare il tuo accesso ai marketplace integrati come Amazon e Mercateo. Puoi trovare una guida <a href=\"https://liftbase.de/handbuch/einrichtung/punch-out\" target=\"_blank\">nel nostro manuale</a>."
        }
    },
    "error_title": "Errore",
    "request_error": "Errore nell'esecuzione della richiesta. Controlli la sua connessione internet o riprovi più tardi.",
    "saved_success": "Il documento è stato salvato con successo.",
    "duplicate_exists_check_records": "Esiste già un record identico. L'elemento non è stato creato. Controlla i tuoi archivi.",
    "save_error": "Errore nel salvataggio del documento.",
    "help_page": {
        "title": "Aiuto",
        "popup_feedback_msg": "Il suo browser è impostato correttamente. Ora può chiudere questa finestra.",
        "punchout_error_msg": "Si è verificato un errore. Controlli le impostazioni di Punch-out o contatti una persona con diritti di amministrazione.",
        "popup_did_not_open": "Se non si apre una nuova finestra, i pop-up sono bloccati nel suo browser. Pertanto, potrebbero verificarsi delle limitazioni durante l'utilizzo.",
        "test_email_msg": "Dovrebbe essersi aperto un programma di posta elettronica o un elenco di programmi di posta elettronica. Se necessario, imposti un programma e-mail dall'elenco.",
        "tour_restart": "Il tour è stato riavviato.",
        "manual_title": "Manuale",
        "manual_msg": "<p>Nel manuale, troverà diversi articoli e guide sull'utilizzo e la configurazione di liftbase.</p>",
        "manual_open_btn": "Manuale aperto",
        "function_title": "Funzioni di test",
        "popup_msg": "<p>Qui può verificare se nel suo browser sono consentite le finestre pop-up, che sono necessarie per la selezione dei prodotti sui marketplace esterni come Amazon e Mercateo.</p>",
        "popup_test_btn": "Prova il blocco dei pop-up",
        "email_msg": "<p>Qui può verificare se è in grado di aprire le e-mail con un programma di posta elettronica. La funzione e-mail viene utilizzata, ad esempio, per inviare gli ordini alle aziende di consegna.</p>",
        "email_test_btn": "Prova la funzione e-mail",
        "tour_title": "Tour",
        "tour_msg": "<p>Per avere una reintroduzione a liftbase, può ricominciare il tour da qui.</p>",
        "tour_btn": "Tour di riavvio"
    },
    "dashboard_page": {
        "title": "Dashboard",
        "no_option": "Nessuna",
        "date_picker": {
            "start_placeholder": "Data di inizio",
            "end_placeholder": "Data di inizio",
            "separator": "a"
        },
        "ai": {
            "title": "Statistiche AI",
            "menu_title": "Statistiche AI",
            "add_widget": "[+] Aggiungi nuovo widget",
            "prompt_placeholder": "Descrivi il grafico che desideri (es. Mostrami gli ordini totali per giorno)",
            "empty_state": "Nessun widget ancora. Aggiungine uno usando un prompt.",
            "remove": "Rimuovi",
            "limits_info": "Puoi chiedere solo totali di bcase (procurement, invoice, contract) come CONTEGGIO o come VALORE, aggregati per unità di tempo (giorno, mese, ecc.). L'AI restituirà campi generici (time e value) e metadati per poter rendere il grafico in modo generico.",
            "edit_label_title": "Modifica etichetta widget",
            "edit_label_message": "Questo modifica solo l'etichetta/il titolo visualizzato sulla scheda. Non cambia la query o il grafico.",
            "chart_type": {
                "bar": "barra",
                "line": "linea",
                "pie": "torta"
            },
            "date_picker": {
                "required": "L'intervallo di date è obbligatorio"
            },
            "loading": {
                "adding_widget": "Aggiunta del widget…",
                "refresh_widget": "Aggiornamento…",
                "refresh_all": "Aggiornamento di tutti i widget…"
            },
            "errors": {
                "create_failed": "Non è stato possibile creare il widget.",
                "render_failed": "Non è stato possibile visualizzare il grafico."
            }
        },
        "hub": {
            "title": "All dashboards in one place",
            "subtitle": "Use this overview as the central entry point for procurement, incoming invoices, outgoing invoices, e-invoice and AI.",
            "procurement_title": "Procurement Dashboard",
            "procurement_description": "Current purchasing charts, budgets and spending analysis.",
            "einvoice_title": "E-invoice Dashboard",
            "einvoice_description": "Supplier adoption, risk and e-invoice format analysis.",
            "invoice_title": "Incoming Invoice Dashboard",
            "invoice_description": "Analytics for real incoming invoice data based on your current filters.",
            "outgoing_invoice_title": "Outgoing Invoice Dashboard",
            "outgoing_invoice_description": "Analytics for real outgoing invoice data based on your current filters.",
            "supplier_title": "Supplier Dashboard",
            "supplier_description": "Bird's-eye view of suppliers, spending, orders, invoices and communication.",
            "ai_description": "Dynamic AI-generated charts based on prompt-driven widgets.",
            "demo_badge": "Test version"
        },
        "supplier": {
            "menu_title": "Dashboard fornitori",
            "eyebrow": "Assistente acquisti",
            "title": "Dashboard fornitori",
            "subtitle": "Seleziona un fornitore per vedere spese, ordini, fatture, e-mail SupplierConnect e importate e un riepilogo AI automatico.",
            "selected_supplier": "Fornitore selezionato",
            "change_supplier": "Cambia fornitore",
            "top_suppliers_title": "Top 10 fornitori",
            "top_suppliers_subtitle": "I fornitori più utilizzati nel periodo selezionato e nell'ambito di permessi visibile.",
            "top_supplier_spend": "{amount} netto",
            "empty_top_suppliers": "Nessun fornitore trovato nel periodo selezionato.",
            "orders": "ordini",
            "invoices": "Fatture",
            "total_spend": "Spese",
            "total_spend_hint": "Somma delle fatture in entrata visibili nel periodo",
            "procurement_value": "Valore ordini",
            "procurement_value_hint": "Somma degli ordini visibili nel periodo",
            "order_count": "Ordini",
            "order_count_hint": "Ordini visibili nel periodo",
            "invoice_count": "Fatture",
            "invoice_count_hint": "Fatture in entrata visibili nel periodo",
            "email_count": "E-mail",
            "email_count_hint": "Comunicazioni SupplierConnect ed e-mail importate dai documenti visibili",
            "ai_summary_title": "Riepilogo AI",
            "ai_summary_subtitle": "Generato automaticamente da ordini, fatture ed e-mail visibili.",
            "ai_summary_loading": "AI in analisi",
            "ai_summary_empty": "Nessun riepilogo AI affidabile disponibile.",
            "ai_section_titles": {
                "highlights": "Aspetti principali",
                "disputes": "Contestazioni e rischi",
                "agreements": "Accordi speciali",
                "next_steps": "Prossimi passi",
                "general": "Riepilogo"
            },
            "ai_summary_disabled": "L'AI è disattivata per il tuo tenant. Attiva l'AI nelle impostazioni del tenant per ricevere riepiloghi automatici.",
            "refresh_ai_summary": "Aggiorna riepilogo",
            "charts_title": "Spese e documenti",
            "charts_subtitle": "Andamento mensile di spese, ordini e fatture nel periodo corrente.",
            "spend_chart_title": "Spese per mese",
            "document_chart_title": "Ordini e fatture per mese",
            "spend_mix_chart_title": "Spese per tipo di documento",
            "status_chart_title": "Documenti per stato",
            "invoice_spend_chart_title": "Spese per fattura al mese",
            "procurement_spend_chart_title": "Valore ordini per mese",
            "invoice_count_chart_title": "Fatture per mese",
            "procurement_count_chart_title": "Ordini per mese",
            "invoice_status_chart_title": "Fatture per stato",
            "procurement_status_chart_title": "Ordini per stato",
            "procurements_title": "Ordini",
            "procurements_subtitle": "Ordini visibili per questo fornitore.",
            "invoices_title": "Fatture",
            "invoices_subtitle": "Fatture in entrata visibili per questo fornitore.",
            "contracts_title": "Contratti",
            "contracts_subtitle": "Contratti visibili e segnalazioni informative per questo fornitore.",
            "contract_term": "Durata",
            "contract_renewal": "Rinnovo",
            "contract_notice": "Preavviso",
            "contract_findings": "Segnalazioni del contratto",
            "empty_contracts": "Nessun contratto trovato.",
            "contracts_disclaimer": "Le informazioni e le segnalazioni contrattuali mostrate sono solo informative e non costituiscono consulenza legale.",
            "contract_finding_severity": {
                "high": "Alta",
                "medium": "Media",
                "low": "Bassa",
                "info": "Informazione"
            },
            "unknown": "Sconosciuto",
            "emails_title": "E-mail",
            "emails_subtitle": "Comunicazioni SupplierConnect ed e-mail di fatture importate dai documenti visibili.",
            "email_type_filter": "Tipo di e-mail",
            "email_type_all": "Tutte",
            "email_type_communication": "Comunicazione",
            "email_type_imported_invoice": "Fattura importata",
            "expand_email": "Espandi e-mail",
            "collapse_email": "Comprimi e-mail",
            "email_source_supplier_connect": "SupplierConnect",
            "email_source_imported": "E-mail importata",
            "email_direction_outgoing": "In uscita",
            "email_direction_incoming": "In entrata",
            "imported_email_hint": "Fattura in entrata da e-mail importata.",
            "loading_original_email": "Caricamento dell'e-mail originale…",
            "open_document": "Apri documento",
            "show_more": "Mostra di più",
            "show_less": "Mostra meno",
            "empty_procurements": "Nessun ordine trovato.",
            "empty_invoices": "Nessuna fattura trovata.",
            "empty_emails": "Nessuna e-mail trovata.",
            "empty_filtered_emails": "Nessuna e-mail trovata per questo filtro.",
            "net_value": "Netto",
            "no_subject": "Senza oggetto",
            "last_three_months": "Ultimi 3 mesi",
            "last_six_months": "Ultimi 6 mesi",
            "nav": {
                "summary": "Panoramica",
                "charts": "Grafici",
                "emails": "E-mail",
                "procurements": "Ordini",
                "invoices": "Fatture",
                "contracts": "Contratti"
            }
        },
        "invoice": {
            "title": "Incoming Invoice Dashboard",
            "incoming_subtitle": "This dashboard uses real incoming invoice data and shows status and distributions based on your current filters.",
            "outgoing_subtitle": "This dashboard uses real outgoing invoice data and shows status and distributions based on your current filters.",
            "sample_data": "Sample data",
            "accordions": {
                "summary": "Summary",
                "status": "Status"
            },
            "hero": {
                "data_label": "Data source",
                "live_value": "Real invoice data",
                "period_label": "Period",
                "documents_label": "Documents in view",
                "filters_label": "Active filters"
            },
            "filters": {
                "title": "Filter context",
                "subtitle": "Choose period, organization and supplier details to sharpen every section of the dashboard at once.",
                "active_filters_label": "Active filters",
                "active_filters_suffix": "active filters",
                "period_label": "Period"
            },
            "summary": {
                "incoming_count_label": "Invoices",
                "outgoing_count_label": "Outgoing invoices",
                "gross_total_label": "Gross volume",
                "gross_total_hint": "Gross total in the selected period",
                "suppliers_label": "Suppliers in filter",
                "suppliers_kicker": "Suppliers",
                "business_partners_label": "Business partners in filter",
                "business_partners_kicker": "Partners",
                "value_kicker": "Value",
                "departments_kicker": "Departments",
                "departments_label": "Departments in filter",
                "clients_kicker": "Clients",
                "clients_label": "Clients in filter",
                "incoming_count_hint": "Document count in the selected period",
                "outgoing_count_hint": "Document count in the selected period",
                "incoming_suppliers_hint": "Unique suppliers in the filtered invoice set",
                "outgoing_business_partners_hint": "Unique business partners in the filtered outgoing invoice set",
                "outgoing_suppliers_hint": "Unique suppliers in the filtered outgoing invoice set",
                "incoming_departments_hint": "Unique departments in the filtered invoice set",
                "outgoing_clients_hint": "Unique clients in the filtered outgoing invoice set"
            },
            "status_sections": {
                "incoming_title": "Invoices by status",
                "incoming_subtitle": "Status cards based on the same filters as the procurement dashboard.",
                "outgoing_title": "Outgoing invoices by status",
                "outgoing_subtitle": "Status cards for outgoing invoices in the same compact overview."
            },
            "datasets": {
                "incoming": "Invoices",
                "outgoing": "Outgoing invoices"
            },
            "sections": {
                "incoming_subtitle": "Charts for incoming invoices using the same core filters as the procurement dashboard.",
                "outgoing_subtitle": "Charts for outgoing invoices with focus on clients, suppliers, status and organization data."
            },
            "empty_state": "No invoice data found for the current filter combination.",
            "presets": {
                "this_month": "This month",
                "last_3_months": "Last 3 months",
                "year_to_date": "Year to date"
            },
            "status": {
                "approved": "Approved",
                "pending": "Pending review",
                "blocked": "Blocked"
            },
            "kpis": {
                "total_invoices": "Total invoices",
                "approved_rate": "Approved rate",
                "pending_review": "Pending review",
                "avg_gross": "Average gross value"
            },
            "charts": {
                "status_distribution": "Invoice status distribution",
                "status_distribution_subtitle": "Quick overview of how invoices are currently moving through the process.",
                "volume_trend": "Invoice volume trend",
                "volume_trend_subtitle": "Approved versus pending documents across the selected test period.",
                "count_by_status_subtitle": "Document count by status.",
                "value_by_status_subtitle": "Gross total by status.",
                "department_count_subtitle": "Distribution by department.",
                "department_value_subtitle": "Gross total by department.",
                "cost_center_count_subtitle": "Document count by cost center.",
                "cost_center_value_subtitle": "Gross total by cost center.",
                "ledger_count_subtitle": "Top ledger accounts by document count.",
                "incoming_status_count_title": "Invoices by status",
                "incoming_status_value_title": "Invoice value by status",
                "incoming_supplier_count_title": "Invoices by supplier",
                "incoming_supplier_count_subtitle": "Top suppliers by document count.",
                "incoming_supplier_value_title": "Invoice value by supplier",
                "incoming_supplier_value_subtitle": "Top suppliers by gross total.",
                "incoming_department_count_title": "Invoices by department",
                "incoming_department_value_title": "Invoice value by department",
                "incoming_cost_center_count_title": "Invoices by cost center",
                "incoming_cost_center_value_title": "Invoice value by cost center",
                "incoming_ledger_count_title": "Invoices by ledger account",
                "incoming_monthly_title": "Invoice trend by month",
                "incoming_monthly_subtitle": "Time series for incoming invoices.",
                "outgoing_status_count_title": "Outgoing invoices by status",
                "outgoing_status_value_title": "Outgoing invoice value by status",
                "outgoing_client_count_title": "Outgoing invoices by client",
                "outgoing_client_count_subtitle": "Top clients by document count.",
                "outgoing_client_value_title": "Outgoing invoice value by client",
                "outgoing_client_value_subtitle": "Top clients by gross total.",
                "outgoing_business_partner_count_title": "Outgoing invoices by business partner",
                "outgoing_business_partner_count_subtitle": "Top business partners by document count.",
                "outgoing_business_partner_value_title": "Outgoing invoice value by business partner",
                "outgoing_business_partner_value_subtitle": "Gross total by business partner.",
                "outgoing_department_count_title": "Outgoing invoices by department",
                "outgoing_cost_center_value_title": "Outgoing invoice value by cost center",
                "outgoing_ledger_count_title": "Outgoing invoices by ledger account",
                "outgoing_monthly_title": "Outgoing invoice trend by month",
                "outgoing_monthly_subtitle": "Time series for outgoing invoices."
            },
            "table": {
                "title": "Period breakdown",
                "subtitle": "Supporting sample table for the charts above.",
                "period": "Period",
                "total": "Total",
                "approved": "Approved",
                "pending": "Pending",
                "gross_value": "Gross value"
            }
        },
        "ordered_by": "Ordinato da",
        "count_by_status": "Conteggio per stato",
        "diagrams": {
            "title": "Grafici",
            "count_by_status": "Conteggio per stato",
            "value_by_status": "Valori per stato (netti in euro)",
            "count_by_department": "Conteggio per reparto",
            "value_by_department": "Valori per reparto (netti in euro)",
            "count_by_cost_center": "Conteggio per centro di costo",
            "value_by_cost_center": "Valori per centro di costo (netto in EUR)",
            "count_by_ledger_account": "Numero per conto contabile",
            "value_by_ledger_account": "Importi per conto contabile (netto in EUR)"
        },
        "budgets": {
            "title": "Bilanci e spese",
            "approved_status": "Approvato",
            "in_approval_status": "In Approvazione",
            "open_status": "Aperto",
            "no_budget": "Senza budget",
            "from": "Da",
            "no_name": "Senza nome"
        },
        "products": {
            "title": "Prodotti",
            "approved_status": "Approvato",
            "in_approval_status": "In Approvazione"
        },
        "no_data": "Non sono stati trovati ordini di acquisto.",
        "no_permission": "Non ha l'autorizzazione per il dashboard.",
        "from_budget": "dal budget",
        "data": "Spese",
        "shortcuts": {
            "this_week": "Questa settimana",
            "last_week": "La scorsa settimana",
            "this_month": "Questo mese",
            "last_month": "Il mese scorso",
            "last_30_days": "Last 30 days",
            "last_3_months": "Ultimi 3 mesi",
            "last_6_months": "Ultimi 6 mesi",
            "this_year": "Quest'anno",
            "last_year": "L'anno scorso"
        },
        "tour": {
            "title": "Il dashboard le offre statistiche e funzioni di valutazione degli ordini di acquisto.",
            "filters_title": "Filtri",
            "filters": "Per prima cosa, selezioni il periodo desiderato e poi filtri gli ordini di acquisto per azienda, ordine per, centro di costo o reparto.",
            "count_by_status_title": "Conteggio per stato",
            "count_by_status": "Questo mostra quanti ordini di acquisto pre-filtrati si trovano attualmente nei rispettivi stati.",
            "graphic_title": "Grafici",
            "graphic": "Si tratta di una rappresentazione grafica del numero o degli importi degli ordini di acquisto, raggruppati per stato, reparti o centri di costo.",
            "budget_title": "Bilanci e spese",
            "budget": "Quest'area le offre una panoramica dei budget e delle spese dei suoi centri di costo. Le barre colorate mostrano l'utilizzo dei budget e quante spese sono ancora in fase di approvazione.",
            "progress_bar_cost_center_title": "Barre di avanzamento per centro di costo",
            "progress_bar_cost_center": "Qui può aprire una panoramica più dettagliata dei diversi budget di un centro di costo. Gli ordini effettuati possono essere elencati anche per i singoli budget. Le spese senza budget sono elencate in una barra separata."
        },
        "einvoice": {
            "title": "E‑Invoice Dashboard",
            "filters": {
                "date_range": "Intervallo di date",
                "client": "Azienda",
                "supplier": "Fornitore"
            },
            "placeholders": {
                "all": "Tutti"
            },
            "kpis": {
                "percent_einvoices": "% di e‑fatture",
                "total_tax_eur": "Imposta totale (Rimborsabile)",
                "potential_loss": "Rischio di non rimborso"
            },
            "hint": "Attenzione: Il governo interromperà presto i rimborsi fiscali per le fatture non elettroniche. Contatti i fornitori il prima possibile per assicurarsi di ricevere correttamente le e‑fatture e non perdere denaro.",
            "action_button": "Contattare destinatario",
            "email_dialog": {
                "title": "Contatta destinatario",
                "to": "Email del destinatario",
                "to_placeholder": "email1@azienda.it; email2@azienda.it",
                "subject": "Oggetto",
                "message": "Messaggio",
                "download_eml": "Scarica .eml",
                "send_email": "Invia email",
                "recipient_type": "Tipo destinatario",
                "recipient_type_supplier": "Fornitore",
                "recipient_type_client": "Azienda",
                "invalid_recipients": "Inserire almeno un indirizzo email valido.",
                "send_success": "Email inviata con successo ({count}).",
                "send_error": "Impossibile inviare l'email.",
                "select_supplier_warning": "Selezionare prima un fornitore.",
                "default_subject": "Importante: transizione alle fatture elettroniche - {supplier}",
                "default_message": "Gentili signori di {supplier},\n\nstiamo rivedendo i nostri processi di rimborso fiscale. Nel periodo dal {startDate} al {endDate}, abbiamo identificato un totale di {amount} di tasse nelle vostre fatture che non sono state inviate come fatture elettroniche (ZUGFeRD o XRechnung).\n\nVi informiamo che il governo interromperà presto i rimborsi fiscali per le fatture non elettroniche. Per garantire la nostra continua collaborazione ed evitare perdite finanziarie, vi preghiamo cortesemente di passare all'invio di fatture elettroniche il prima possibile.\n\nGrazie per la vostra collaborazione.\n\nCordiali saluti,\n{userName}\n{tenantName}\nIl vostro team di contabilità",
                "client_default_subject": "Stato e-fatture e azioni richieste - {client}",
                "client_default_message": "Gentile team di {client},\n\nnel periodo dal {startDate} al {endDate} è stato identificato un potenziale rischio formale pari a {amount} nei vostri documenti.\nVi invitiamo a valutare il passaggio ai formati strutturati di fattura elettronica per ridurre i rischi di compliance.\n\nCordiali saluti,\n{userName}\n{tenantName}"
            }
        }
    },
    "exceptions_center": {
        "menu_title": "Elementi pendenti",
        "title": "Elementi pendenti ed eccezioni",
        "subtitle": "Questa vista riunisce le fatture, gli ordini e i contratti più urgenti che richiedono un'azione manuale immediata.",
        "total_items": "Elementi aperti",
        "total_items_hint": "Elementi filtrati attualmente visibili nella coda centrale.",
        "filters_title": "Filtra la coda",
        "filters_subtitle": "Concentri l'elenco per tipo di documento, gravità o ricerca libera.",
        "clear_filters": "Cancella filtri",
        "search_placeholder": "Cerchi per riferimento, cliente, fornitore o motivo",
        "type_filter": "Tipi di documento",
        "severity_filter": "Gravità",
        "quick_filters_title": "Filtri rapidi",
        "focus_areas_title": "Aree di attenzione",
        "analysis_title": "Analisi",
        "document_mix_title": "Mix documentale",
        "amount_at_risk": "Valore a rischio",
        "active_filters_title": "Filtri attivi",
        "filtered_total_hint": "{filtered} di {total} elementi visibili",
        "total_reference": "su {count} totali",
        "active_state": "Filtro attivo",
        "list_title": "Coda operativa",
        "list_subtitle": "{count} elementi corrispondono attualmente ai filtri selezionati.",
        "empty_state": "Nessun elemento pendente trovato per la combinazione di filtri corrente.",
        "open_case": "Apri caso",
        "updated_label": "Ultimo aggiornamento",
        "reasons_count": "{count} segnali",
        "filter_groups": {
            "severity": "Gravità",
            "type": "Tipo",
            "focus": "Focus",
            "search": "Ricerca"
        },
        "summary": {
            "severity_kicker": "Gravità",
            "document_kicker": "Tipo documento",
            "severity_title": "Per gravità",
            "document_title": "Per tipo documento"
        },
        "signals": {
            "critical": "Critici ora",
            "unassigned": "Senza responsabile",
            "stale": "Elementi fermi"
        },
        "focus_areas": {
            "payments": "Pagamenti",
            "approvals": "Approvazioni",
            "master-data": "Dati anagrafici",
            "ownership": "Responsabilità",
            "export": "Esportazione",
            "deadlines": "Scadenze"
        },
        "severity": {
            "critical": "Critico",
            "high": "Alta",
            "medium": "Media"
        },
        "document_types": {
            "invoice": "Fattura",
            "outgoing_invoice": "Fattura in uscita",
            "procurement": "Ordine",
            "contract": "Contratto",
            "bank_statement": "Estratto conto"
        },
        "reasons": {
            "invoice_duplicate": "Rilevata una possibile fattura duplicata.",
            "invoice_ai_validation_failed": "La validazione IA non ha ritenuto affidabile questa fattura e l'ha inviata al controllo manuale.",
            "invoice_overdue": "La scadenza della fattura è superata di {days} giorno/i.",
            "invoice_missing_due_date": "La fattura non ha una data di scadenza.",
            "invoice_waiting_approval": "La fattura è in attesa in uno step di approvazione.",
            "invoice_missing_link": "La fattura non è collegata né a un ordine né a un contratto.",
            "invoice_missing_supplier": "Alla fattura non è associato alcun fornitore.",
            "invoice_missing_accounting_data": "Alla fattura mancano dimensioni contabili come centro di costo o conto contabile.",
            "invoice_ready_for_export": "La fattura è pronta per l'esportazione ma non è ancora stata esportata.",
            "outgoing_invoice_duplicate": "Rilevata una possibile fattura in uscita duplicata.",
            "outgoing_invoice_overdue": "La scadenza della fattura in uscita è superata di {days} giorno/i.",
            "outgoing_invoice_missing_due_date": "La fattura in uscita non ha una data di scadenza.",
            "outgoing_invoice_waiting_processing": "La fattura in uscita è in attesa di approvazione o contabilizzazione.",
            "outgoing_invoice_missing_client": "Alla fattura in uscita non è associato alcun cliente.",
            "outgoing_invoice_missing_accounting_data": "Alla fattura in uscita mancano dimensioni contabili come centro di costo o conto contabile.",
            "outgoing_invoice_not_exported": "La fattura in uscita è completata ma non è ancora stata esportata.",
            "procurement_waiting_approval": "L'ordine è in attesa di approvazione.",
            "procurement_ordered_without_invoice": "L'ordine effettuato non ha ancora una fattura dopo la data di consegna.",
            "procurement_approved_without_invoice": "L'ordine approvato non ha ancora una fattura dopo una settimana.",
            "procurement_missing_delivery_date": "L'ordine non ha una data di consegna pianificata.",
            "procurement_not_allocated": "L'ordine non è completamente allocato.",
            "procurement_open_value_remaining": "L'ordine ha ancora un valore aperto dopo l'inizio della fatturazione.",
            "procurement_missing_supplier": "All'ordine non è associato alcun fornitore.",
            "procurement_missing_accounting_data": "All'ordine mancano dimensioni contabili come centro di costo o conto contabile.",
            "contract_termination_deadline_passed": "La scadenza di recesso è già trascorsa.",
            "contract_termination_deadline_soon": "La scadenza di recesso è entro i prossimi {days} giorno/i.",
            "contract_termination_deadline_near": "La scadenza di recesso è entro i prossimi 30 giorni.",
            "contract_end_date_passed": "La data di fine del contratto è già trascorsa.",
            "contract_end_date_soon": "La data di fine del contratto è entro i prossimi {days} giorno/i.",
            "contract_end_date_near": "La data di fine del contratto è entro i prossimi 30 giorni.",
            "contract_missing_owner": "Al contratto non è assegnato alcun responsabile.",
            "contract_missing_supplier": "Al contratto non è associato alcun fornitore.",
            "bank_statement_failed": "L'elaborazione dell'estratto conto è fallita.",
            "bank_statement_partial": "L'elaborazione dell'estratto conto è stata completata solo parzialmente.",
            "bank_statement_unmatched_entries": "Nell'estratto conto ci sono ancora {count} movimento/i non abbinato/i.",
            "bank_statement_processing_too_long": "L'estratto conto è in elaborazione da più di un giorno.",
            "bank_statement_empty": "L'estratto conto è stato elaborato senza movimenti.",
            "bank_statement_missing_owner": "Nell'estratto conto non è indicato alcun intestatario del conto.",
            "item_unassigned": "Lo step corrente del workflow non ha un utente responsabile assegnato.",
            "item_stale": "L'elemento non riceve aggiornamenti rilevanti da {days} giorno/i."
        }
    },
    "overview_page": {
        "title": "Panoramica",
        "procurement_abbr": "PO",
        "invoice_abbr": "IN",
        "outgoing_invoice_abbr": "FA",
        "draft_abbr": "DR",
        "contract_abbr": "CO",
        "delivery_note_abbr": "DN",
        "all_docs": "Tutti i documenti",
        "all_docs_tree": "Tutti i documenti (Vista ad albero)",
        "all_docs_list": "Tutti i documenti (Vista elenco)",
        "search_all_documents": "Cerca in tutti i documenti",
        "export_ready_docs": "Pronti per l'esportazione",
        "my_tasks": "I miei compiti",
        "my_orders": "I miei ordini",
        "my_bank_statements": "I miei estratti conto",
        "previous_document": "Documento precedente",
        "next_document": "Documento successivo",
        "collapse_sidebar": "Comprimi barra laterale",
        "expand_sidebar": "Espandi barra laterale",
        "collapse_properties_sidebar": "Comprimi pannello azioni",
        "expand_properties_sidebar": "Espandi pannello azioni",
        "properties_sidebar": {
            "no_step": "Nessun passaggio attivo",
            "completed": "Completato"
        },
        "saved_searches": "Ricerche salvate",
        "my_orders_no_invoices": "Nessuna fattura collegata a questo ordine.",
        "my_orders_goods_receipt": "Ricevimento merci",
        "procurements": "Ordini di acquisto",
        "invoices": "Fatture",
        "outgoing_invoices": "Fatture in uscita",
        "list_column_incoming_invoice": "In entrata",
        "list_column_outgoing_invoice": "In uscita",
        "drafts": "Bozze",
        "contracts": "Contratti",
        "no_selection": "Non è stato selezionato alcun documento.",
        "common_fields": "Campi comuni",
        "comment_box_placeholder": "Il suo commento...",
        "comment_box_btn": "Come",
        "comment_box_mentions_loading": "Caricamento utenti...",
        "comment_box_mentions_empty": "Nessun utente trovato.",
        "communication": {
            "tooltip": "Contatta il fornitore",
            "tooltip_business_partner": "Contatta il partner commerciale",
            "disabled_hint": "Configura nelle impostazioni una casella attiva con comunicazione fornitore abilitata per questo tipo di documento.",
            "dialog_title": "Contatta il fornitore",
            "dialog_title_business_partner": "Contatta il partner commerciale",
            "send_order_dialog_title": "Invia ordine via SupplierConnect",
            "from_mailbox": "Casella mittente",
            "from_mailbox_placeholder": "Seleziona casella",
            "supplier": "Fornitore",
            "to": "A",
            "visibility": "Visibilità",
            "internal_note": "Nota interna",
            "internal_tag": "Interno",
            "external_tag": "Esterno",
            "external_hint": "Esterno: il fornitore e tutti i destinatari selezionati ricevono questo messaggio.",
            "internal_hint": "Interno: solo gli utenti liftbase menzionati ricevono una notifica. Il fornitore non viene contattato.",
            "cc_mentions": "Cc utenti (@mention)",
            "cc_mentions_placeholder": "Usa @ per menzionare utenti del sistema",
            "internal_recipients": "Destinatari interni",
            "cc_emails": "Cc e-mail",
            "cc_emails_placeholder": "Aggiungi e-mail e premi Invio",
            "subject": "Oggetto",
            "body": "Messaggio",
            "body_placeholder": "Scrivi il tuo messaggio...",
            "attach_order_pdf": "Allega PDF ordine",
            "attach_invoice_document": "Allega documento fattura",
            "attach_order_pdf_mode_plain": "Senza offerta",
            "attach_order_pdf_mode_with_line_attachments": "Con offerta",
            "reply_info": "Le risposte vengono inviate solo alla casella postale di comunicazione configurata. L'utente che ha avviato la comunicazione viene poi notificato.",
            "internal_reply_info": "Le note interne vengono inviate solo agli utenti liftbase menzionati.",
            "send": "Invia e-mail",
            "dialog_options_action": "Altre opzioni e-mail",
            "validation": "Compila tutti i campi obbligatori.",
            "sent_success": "Comunicazione inviata con successo.",
            "sent_error": "Impossibile inviare la comunicazione.",
            "sent_error_mailbox_reconnect": "Impossibile inviare la comunicazione perché la casella Microsoft {mailbox} non è più collegata.\nRicollega la casella nelle impostazioni e riprova.",
            "sent_error_mailbox_incomplete": "Impossibile inviare la comunicazione perché nella casella {mailbox} mancano host SMTP, nome utente o password.\nCompleta la configurazione della casella nelle impostazioni.",
            "history_title": "Comunicazioni fornitore",
            "history_title_business_partner": "Comunicazioni con il partner commerciale",
            "history_empty": "Nessuna comunicazione avviata per questo documento.",
            "recipients": "Destinatari",
            "cc": "Cc",
            "attachments": "Allegati",
            "attachments_available": "Con allegati",
            "statuses": {
                "pending": "In attesa",
                "sent": "Inviato",
                "failed": "Non riuscito",
                "received": "Ricevuto"
            },
            "reply_action": "Rispondi",
            "forward_action": "Inoltra",
            "forward_dialog_title": "Inoltra e-mail",
            "forward_subject_prefix": "Fwd:",
            "forwarded_message_title": "Messaggio inoltrato",
            "forward_attachments_hint": "Questi allegati verranno inviati con l'e-mail inoltrata.",
            "history_quote_title": "Cronologia della conversazione",
            "history_date_label": "Data",
            "history_from_label": "Da",
            "history_to_label": "A",
            "history_subject_label": "Oggetto",
            "show_less": "Mostra meno",
            "involved_button": "Coinvolti",
            "involved_title": "Persone ed e-mail coinvolte",
            "involved_search_placeholder": "Cerca per nome o e-mail",
            "involved_copy_email": "Copia e-mail",
            "involved_copied": "E-mail copiata",
            "involved_empty": "Nessun partecipante trovato",
            "involved_sections": {
                "suppliers": "Fornitori",
                "users": "Utenti interni",
                "manual": "E-mail manuali",
                "mailbox": "Mailbox"
            },
            "address_book_source_supplier": "Indirizzo fornitore",
            "address_book_source_saved": "Gia usato",
            "address_book_delete": "Rimuovi suggerimento salvato",
            "address_book_delete_success": "Suggerimento salvato rimosso.",
            "address_book_delete_error": "Impossibile rimuovere il suggerimento salvato."
        },
        "edit_filename_title": "Modifica nome file",
        "edit_filename_msg": "Si prega di inserire il nuovo nome del file. <br> Nome precedente: {filename}",
        "duplicate_invoice": {
            "message": "Duplicato - È stata trovata almeno una fattura con lo stesso numero di fattura:",
            "invoice_number": "Numero di fattura",
            "invoice_date": "Data"
        },
        "task_list": {
            "name": "Nome",
            "status": "Stato",
            "date": "Data",
            "draft": "Bozza"
        },
        "searchbar": {
            "search": "Trova",
            "filter_by": "Filtrare per",
            "created_at": "Data di creazione",
            "timeline": "Timeline",
            "last_used": "Ultimo utilizzo",
            "no_search": "Nessuno",
            "save_search": "Salva ricerca",
            "save_search_prompt": "Vuoi salvare questa ricerca? Inserisci un'etichetta.",
            "label_placeholder": "Etichetta",
            "label_required": "Inserisci un'etichetta.",
            "label_exists": "Questa etichetta esiste gia.",
            "saved_success": "Ricerca salvata.",
            "edit_saved_search": "Rinomina ricerca salvata",
            "edit_saved_search_title": "Rinomina ricerca salvata",
            "edit_saved_search_prompt": "Come vuoi chiamare questa ricerca salvata?",
            "edited_success": "Ricerca salvata rinominata.",
            "delete_saved_search": "Elimina ricerca salvata",
            "delete_saved_search_title": "Elimina ricerca salvata",
            "delete_saved_search_prompt": "Vuoi davvero eliminare la ricerca salvata \"{label}\"?",
            "deleted_success": "Ricerca salvata eliminata.",
            "timeline_props": {
                "editor_name": "Editor",
                "entry_type": "Fase della cronologia",
                "current_editor_name": "Editor attuale",
                "current_entry_type": "Fase attuale"
            },
            "common_props": {
                "client_name": "Nome dell'azienda",
                "client_number": "Numero dell'azienda",
                "department_name": "Nome del dipartimento",
                "department_number": "Numero del dipartimento",
                "cost_center_name": "Nome del centro di costo",
                "cost_center_number": "Numero del centro di costo",
                "ledger_account_name": "Nome del conto contabile",
                "ledger_account_number": "Numero del conto contabile",
                "cost_type_name": "Tipo di costo",
                "product_names": "Prodotto",
                "product_numbers": "Codice prodotto",
                "status": "Stato",
                "supplier_display_name": "Fornitore",
                "payment_in_advance": "Pagamento anticipato",
            },
            "procurement_props": {
                "order_number_formatted": "Numero ordine",
                "name": "Descrizione",
                "creator_name": "Creato da",
                "consignee_name": "Ricevimento merci",
                "supplier_names": "Fornitore",
                "delivery_date_overdue": "Data di consegna scaduta"
            },
            "invoice_props": {
                "invoice_number": "Numero fattura",
                "invoice_prefix": "Prefisso della fattura",
                "invoice_number_formatted": "Numero interno fattura",
                "procurement_number": "Numero ordine",
                "creator_name": "Caricato da",
                "supplier_name": "Nome fornitore",
                "supplier_number": "Numero fornitore",
                "invoice_date": "Data fattura",
                "due_date": "Data di scadenza"
            },
            "time_ranges": {
                "today": "oggi",
                "yesterday": "ieri",
                "past_7_days": "ultimi 7 giorni",
                "past_30_days": "ultimi 30 giorni",
                "this_week": "questa settimana",
                "last_week": "la scorsa settimana",
                "this_month": "questo mese",
                "last_month": "il mese scorso",
                "this_year": "quest'anno",
                "last_year": "l'anno scorso"
            }
        },
        "export": {
            "all_information": "Tutte le informazioni",
            "export_procurement": "Esportazione di ordini di acquisto",
            "export_documents": "Esportazione di documenti",
            "registers": "voci",
            "export": "Esportazione",
            "to_export": "Esporta",
            "export_with_products": "Esportazione con prodotti",
            "custom_export": "Esportazione configurata",
            "select_fields": "Seleziona i campi che devono essere esportati.",
            "select_all": "Seleziona tutti",
            "deselect_all": "Rimuovi tutto",
            "general": "Generale",
            "products": "Prodotti",
            "include_product": "Prodotti inclusi",
            "filter": " filtro",
            "no_filter": "no filter",
            "format": "Formato file",
            "csv": "CSV",
            "xlsx": "XLSX",
            "loading": "caricamento in corso",
            "error": "Esportazione non riuscita. Riprova.",
            "labels": {
                "procurement": {
                    "order_number_formatted": "Numero LB",
                    "name": "Nome",
                    "creator_name": "Creato da",
                    "status": "Stato",
                    "total_price_brutto": "Totale grande",
                    "total_price_netto": "Totale-Netto",
                    "type_total_price_brutto": "currency",
                    "type_total_price_netto": "currency",
                    "created_at": "Data di creazione",
                    "client_number": "Numero dell'azienda",
                    "client_name": "Nome dell'azienda",
                    "department_name": "Reparto",
                    "cost_center_number": "Numero del centro di costo",
                    "cost_center_name": "Nome del centro di costo",
                    "consignee_name": "Ricevimento della merce",
                    "shipping_date": "Data di consegna",
                    "shipping_name": "Nome dell'indirizzo di consegna",
                    "shipping_consignee": "Indirizzo di consegna nome del destinatario",
                    "shipping_dropoff_location": "Indirizzo di consegna Nome del luogo di consegna",
                    "shipping_address": "Indirizzo di consegna via e numero civico.",
                    "shipping_complement": "Indirizzo di consegna via 2",
                    "shipping_country": "Indirizzo di consegna paese",
                    "shipping_zipcode": "Indirizzo di consegna codice postale",
                    "shipping_city": "Indirizzo di consegna città",
                    "shipping_phone_country_code": "Indirizzo di consegna prefisso telefonico del paese",
                    "shipping_phone_number": "Indirizzo di consegna numero di telefono",
                    "billing_name": "Nome dell'Indirizzo di fatturazione",
                    "billing_consignee": "Indirizzo di fatturazione nome del destinatario",
                    "billing_dropoff_location": "Indirizzo di fatturazione nome del luogo di consegna",
                    "billing_address": "Indirizzo di fatturazione via e n.",
                    "billing_complement": "Indirizzo di fatturazione via 2",
                    "billing_country": "Indirizzo di fatturazione Paese",
                    "billing_zipcode": "Indirizzo di fatturazione codice postale",
                    "billing_city": "Indirizzo di fatturazione città",
                    "billing_phone_country_code": "Indirizzo di fatturazione prefisso telefonico del paese",
                    "billing_phone_number": "Indirizzo di fatturazione numero di telefono"
                },
                "product": {
                    "product_name": "Nome del prodotto",
                    "product_number": "Numero dell'articolo",
                    "product_supplier_name": "Nome del fornitore",
                    "product_supplier_email": "Email del fornitore",
                    "product_cost_center_name": "Nome del centro di costo (prodotto)",
                    "product_cost_center_number": "Numero del centro di costo (prodotto)",
                    "product_tax": "Imposta",
                    "product_quantity": "Quantità (prodotto)",
                    "product_total_netto": "Totale-netto (prodotto)",
                    "product_total_brutto": "Totale-lordo (prodotto)",
                    "product_netto": "Single price net",
                    "product_brutto": "Prezzo unico lordo",
                    "product_unit_price_base_amount": "Prezzo unitario prima dello sconto (prodotto)",
                    "product_unit_price_discount_amount": "Sconto sul prezzo unitario (prodotto)",
                    "product_line_discount_amount": "Sconto sulla riga (prodotto)",
                    "product_line_discount_base_amount": "Base sconto riga (prodotto)",
                    "product_line_discount_percentage": "Sconto riga % (prodotto)",
                    "product_unit": "Unità",
                    "product_img_url": "URL immagine",
                    "product_shop_url": "URL del negozio",
                    "product_shipping_name": "Nome dell'indirizzo di consegna (prodotto)",
                    "product_shipping_consignee": "Indirizzo di consegna nome del destinatario (prodotto)",
                    "product_shipping_dropoff_location": "Indirizzo di consegna Nome del luogo di consegna (pProdotto)",
                    "product_shipping_address": "Indirizzo di consegna via e n. (prodotto)",
                    "product_shipping_complement": "Indirizzo di consegna via 2 (prodotto)",
                    "product_shipping_country": "Indirizzo di consegna Paese (prodotto)",
                    "product_shipping_zipcode": "Indirizzo di consegna codice postale (prodotto)",
                    "product_shipping_city": "Indirizzo di consegna città (prodotto)",
                    "product_shipping_phone_country_code": "Indirizzo di consegna prefisso telefonico del paese (prodotto)",
                    "product_shipping_phone_number": "Indirizzo di consegna numero di telefono (prodotto)",
                    "product_received_at": "Ultimo ricevimento merci (data)",
                    "product_received_by": "Ultimo ricevimento merci (persona)"
                },
                "invoice": {
                    "invoice_number_formatted": "Numero di fattura interna",
                    "number": "Numero di fattura",
                    "invoice_prefix": "Prefisso della fattura",
                    "creator_name": "Caricato da",
                    "status": "Stato",
                    "procurement_name": "Ordine di acquisto",
                    "procurement_number": "Numero d'ordine",
                    "cost_center_name": "Nome del centro di costo",
                    "cost_center_number": "Numero del centro di costo",
                    "total_price_netto": "Totale netto",
                    "total_price_brutto": "Totale lordo",
                    "document_discount_amount": "Importo sconto documento",
                    "document_discount_base_amount": "Base sconto documento",
                    "document_discount_percentage": "Sconto documento %",
                    "document_discount_tax_percentage": "IVA dello sconto documento %",
                    "type_total_price_brutto": "currency",
                    "type_total_price_netto": "currency",
                    "created_at": "Data caricamento",
                    "client_name": "Azienda",
                    "client_number": "Numero dell'azienda",
                    "invoice_date": "Data fattura",
                    "due_date": "Scadenza",
                    "delivery_date": "Data di consegna",
                    "currency": "Valuta",
                    "ledger_account_name": "Nome del conto contabile",
                    "ledger_account_number": "Numero di conto contabile",
                    "posting_key_number": "Numero posting key",
                    "posting_key_tax": "Aliquota fiscale posting key",
                    "supplier_name": "Fornitore",
                    "paid": "Pagato"
                },
                "contract": {
                    "name": "Nome",
                    "contract_date": "Data del contratto",
                    "contract_number_formatted": "Numero CT",
                    "contract_number": "Numero del contratto",
                    "category": "Categoria",
                    "status": "Stato",
                    "term_type": "Tipo di durata",
                    "payment_method": "Metodo di pagamento",
                    "external_contract_number": "Numero di contratto esterno",
                    "creator_name": "Creato da",
                    "created_at": "Data di creazione",
                    "client_number": "Numero azienda",
                    "client_name": "Nome azienda",
                    "department_name": "Nome reparto",
                    "department_number": "Numero reparto",
                    "cost_center_name": "Nome centro di costo",
                    "cost_center_number": "Numero centro di costo",
                    "supplier_name": "Nome fornitore",
                    "supplier_number": "Numero fornitore",
                    "responsible_name": "Responsabile",
                    "notes": "Nota",
                    "payment_direction": "Rapporto",
                    "recurring_invoice": "Fattura ricorrente",
                    "start_date": "Data di inizio",
                    "end_date": "Data di fine",
                    "duration": "Durata del contratto",
                    "duration_unit_type": "Unità di durata del contratto",
                    "renewal_type": "Tipo di rinnovo",
                    "renewal_duration": "Durata del rinnovo",
                    "renewal_duration_unit_type": "Unità di durata del rinnovo",
                    "notice_period": "Periodo di preavviso",
                    "notice_period_unit_type": "Unità del periodo di preavviso",
                    "termination_special_right": "Diritto speciale di recesso",
                    "termination_deadline": "Scadenza di recesso",
                    "next_possible_contract_end": "Prossima possibile fine del contratto",
                    "terminated_on": "Terminato il",
                    "termination_to": "Recesso a",
                    "payment_timing": "Tipo di pagamento",
                    "usage_type": "Frequenza"
                }
            }
        },
        "actions": {
            "tour": {
                "procurement_reassignment_title": "Assegnazione/Chiarimento dell'ordine di acquisto",
                "procurement_reassignment_msg": "Questo compito è attualmente affidato ad un'altra persona. Utilizzi questo pulsante per inviare l'attività per chiarimenti o per assegnarla a una terza persona o a se stesso. In fase di chiarimento, gli ordini di acquisto possono anche essere cancellati.",
                "invoice_reassignment_title": "Assegnazione/Chiarimento della fattura",
                "invoice_reassignment_msg": "Questo compito è attualmente affidato ad un'altra persona. Utilizzi questo pulsante per inviare l'attività per chiarimenti o per assegnarla a una terza persona o a se stesso. In fase di chiarimento, è possibile cancellare anche le fatture."
            },
            "skip_confirm_dialog_title": "Annulla il riconoscimento dei documenti",
            "skip_confirm_dialog_msg": "Per verificare se esiste già un risultato del riconoscimento del documento, aggiorna la pagina nel browser. <br>Sei sicuro di voler annullare il riconoscimento dei dati della fattura e inserire manualmente i dati della fattura?",
            "button_hint": {
                "to_approval": "All'approvazione",
                "to_send_order": "Per ordinare",
                "to_accounting": "Alla contabilità",
                "approve": "Approvare",
                "self_assign": "Accettare",
                "finish_order": "Ordine completo",
                "finish_delivery": "Finitura",
                "skip_recognition": "Annulla il riconoscimento dei documenti",
                "to_export": "Per esportare",
                "default": "Continua",
                "cancel_or_assign_procurement": "Assegnazione/Annullamento",
                "cancel_or_assign_invoice": "Assegnazione/Annullamento",
                "clearing_or_assign": "Assegnazione/Chiarimento"
            },
            "assignment_tooltip": "Chiarimento o assegnazione",
            "restart_approval_tooltip": "Riavviare la timeline",
            "restart_or_clearing_tooltip": "Riavviare la timeline o assegnare per chiarimento",
            "restart_approval_error": "Non è stato possibile riavviare il processo di approvazione.",
            "assignment_dialog": {
                "title_procurement_assign_or_cancel": "Assegnazione o cancellazione",
                "title_invoice_assign_or_cancel": "Assegnazione o cancellazione",
                "title_assign": "Assegnazione",
                "title_clearing_or_assign": "Chiarimento o assegnazione",
                "assign_title": "Assegna il compito corrente a un'altra persona",
                "assign_msg": "La persona attualmente assegnata non è disponibile o non è responsabile di questo compito, quindi un'altra persona deve assumerlo.",
                "clearing_title": "Assegnare per chiarimenti",
                "clearing_msg": "La persona attualmente assegnata è disponibile e responsabile per questo compito, ma il processo non può essere continuato per altri motivi. Pertanto, desidera avviare un processo di chiarimento.",
                "cancel_procurement_title": "Cancellazione",
                "cancel_procurement_msg": "L'ordine è irrevocabilmente annullato e non può essere elaborato ulteriormente. Gli ordini annullati si trovano nella panoramica con lo stato 'Declinato'.",
                "cancel_invoice_title": "Annullamento",
                "cancel_invoice_msg": "La fattura viene cancellata irrevocabilmente e non può essere elaborata ulteriormente. Le fatture cancellate si trovano nella panoramica di tutti i documenti con lo stato 'Cancellato'.",
                "assign_to": "Assegnare a",
                "reason": "Motivo",
                "declined_invoice_alert_title": "Una fattura rifiutata non può essere riaperta",
                "declined_invoice_alert_message": "Questa fattura è già stata rifiutata. Può essere inviata solo al chiarimento per correggere i dati, se necessario. Successivamente non può essere riaperta e deve essere inviata di nuovo.",
                "clearing_footer_info": "Il compito corrente viene annullato. La persona selezionata riceve un nuovo compito da chiarire.",
                "reassignment_footer_info": "Viene modificata solo la persona assegnata dell'attività corrente.",
                "restart_approval_title": "Riavviare il processo di approvazione",
                "restart_approval_dialog_title": "Riavviare la timeline",
                "restart_or_clearing_dialog_title": "Riavviare la timeline o assegnare per chiarimento",
                "restart_approval_msg": "La fattura viene reimpostata al controllo manuale e passa attraverso un nuovo ciclo di approvazione. La cronologia precedente rimane invariata.",
                "restart_approval_footer_info": "La fattura viene reimpostata al controllo manuale. La cronologia precedente rimane invariata.",
                "cancel_invoice_btn": "Annulla la fattura",
                "cancel_procurement_btn": "Annulla l'ordine",
                "assign_btn": "Assegnazione",
                "restart_approval_btn": "Riavvia",
                "prevent_approve_group_msg": "Si prega di assegnare questo passaggio a una persona prima di approvarlo.",
                "clearing_dialog": {
                    "title": "Persona di chiarimento",
                    "procurement_message": "La persona nella fase di 'chiarimento' risulta da vari default di persone responsabili per reparto, azienda, un default di ruolo globale e la persona che ha creato l'ordine. La persona che si trova in cima all'elenco è preassegnata per il compito.",
                    "invoice_message": "La persona nella fase di 'chiarimento' risulta da varie impostazioni predefinite di persone responsabili per reparto, azienda, un ruolo globale predefinito e la persona che ha caricato la fattura. La persona che si trova in cima all'elenco è preassegnata al compito.",
                    "department_form": "Reparto in forma",
                    "department_creator": "Reparto della persona ordinata",
                    "client_form": "Azienda in forma",
                    "client_creator": "Azienda della persona ordinata",
                    "no_selection": "non ancora selezionato",
                    "no_action": "non applicabile"
                },
                "cancellation_dialog": {
                    "title_procurement": "Cancellazione",
                    "btn_procurement": "Annulla l'ordine",
                    "message_procurement": "Vuole davvero cancellare questo ordine?",
                    "title_invoice": "Annullamento",
                    "btn_invoice": "Annulla la fattura",
                    "message_invoice": "Vuole davvero cancellare questa fattura?"
                }
            }
        },
        "tour": {
            "overview": {
                "search_box": "Con la ricerca, può filtrare gli ordini di acquisto sotto \"I miei compiti\" e \"Tutti i documenti\" e cercare varie informazioni per trovare più velocemente ordini di acquisto specifici.",
                "tab_tasks": "Qui può vedere gli ordini di acquisto di cui è attualmente responsabile. Nella colonna di destra, può vedere lo stato dei suoi compiti.",
                "tab_all_procurements": "In questa struttura ad albero, può trovare tutti gli ordini di acquisto, ordinati in base allo stato attuale.",
                "refresh_btn": "Qui può aggiornare la panoramica degli ordini di acquisto.",
                "type_filter": "Qui può filtrare in base al tipo di compito."
            },
            "procurement": {
                "form_title": "Forma dell'ordine di acquisto",
                "form": "Qui può vedere le informazioni sull'ordine di acquisto.",
                "approve_btn_title": "Inoltrare l'ordine di acquisto",
                "approve_btn": "Quando ha completato un compito e desidera inoltrare l'ordine d'acquisto alla persona responsabile successiva o alla fase successiva, prema il segno di spunta blu.",
                "reassign_btn": "Se non vuole completare il compito, perché, ad esempio, ci sono ancora delle incertezze o un'altra persona deve continuare ad elaborare il compito, può premere il pulsante rosso. A questo punto può consegnare il compito o assegnarlo a qualcuno perché lo chiarisca. Durante il processo di chiarimento, gli ordini di acquisto possono anche essere cancellati.",
                "add_comment": "Può aggiungere un commento all'ordine di acquisto tramite il campo commenti. Questo viene poi visualizzato nella timeline.",
                "timeline_title": "Timeline",
                "timeline": "La timeline mostra l'andamento passato e futuro dell'ordine di acquisto, nonché lo stato attuale (in blu) e i commenti sull'ordine di acquisto. L'ordine può essere invertito utilizzando l'icona dell'ingranaggio.",
                "timeline_preferences": "Tramite questo pulsante, è possibile effettuare le impostazioni di visualizzazione della timeline. Ad esempio, si può impostare se gli eventi devono essere ordinati in ordine crescente o decrescente e se le modifiche all'ordine di acquisto devono essere nascoste o visualizzate."
            },
            "invoice": {
                "form_title": "Modulo per la fattura",
                "form": "Qui può inserire o modificare le informazioni della fattura.",
                "add_line": "Qui può aggiungere una voce di fattura.",
                "edit_lines": "Qui può regolare le informazioni sulle voci della fattura.",
                "approve_btn_title": "Inoltrare la fattura",
                "approve_btn": "Quando ha completato un compito e desidera inoltrare la fattura alla persona responsabile successiva o alla fase successiva, può premere il segno di spunta blu.",
                "reassign_btn": "Se non vuole terminare il compito, ad esempio perché c'è un problema da risolvere o se un'altra persona deve continuare a lavorare sul compito, può premere il pulsante rosso. Quindi può assegnare il compito a qualcun altro o assegnarlo a qualcuno per chiarimenti. Durante il processo di chiarimento, le fatture possono anche essere modificate.",
                "add_comment": "Può aggiungere un commento alla fattura tramite il campo commenti. Questo verrà poi visualizzato nella timeline.",
                "timeline_title": "Timeline",
                "timeline": "La timeline mostra l'andamento passato e futuro della fattura, nonché lo stato attuale (in blu) e i commenti sulla fattura. L'ordine può essere invertito utilizzando l'icona dell'ingranaggio.",
                "timeline_preferences": "Tramite questo pulsante, è possibile effettuare le impostazioni di visualizzazione della timeline. Qui si può impostare se gli eventi devono essere ordinati in ordine crescente o decrescente e se le modifiche alla fattura devono essere nascoste o visualizzate."
            },
            "welcome": {
                "logo_title": "Benvenuto su liftbase!",
                "logo": "<p>Per facilitarle l'inizio, le spiegheremo le cose più importanti con un tour attraverso liftbase.</p> <p>Utilizzi i pulsanti qui sotto o i tasti freccia per navigare nel tour.</p>",
                "menu": "Nell'angolo superiore destro si trova il menu principale, attraverso il quale può trovare tutte le aree importanti di liftbase.",
                "menu_help": "Può terminare le singole sezioni del tour in qualsiasi momento e riavviarle in un secondo momento nel menu di aiuto.",
                "menu_admin": "Qui può trovare la prossima sezione del tour."
            }
        }
    },
    "liquidity_planning": {
        "subtitle": "Riveda il cash flow corrente per azienda, pianifichi le prossime settimane e confronti scenari alternativi.",
        "horizon_hint": "Vista predefinita: settimana corrente, 12 settimane successive e poi 6 blocchi mensili. Le righe manuali vengono sempre mantenute per settimana calendario.",
        "scenario_placeholder": "Selezionare scenario",
        "scenario": "Scenario",
        "start_date": "Data di inizio",
        "start_date_required": "Inserire una data di inizio.",
        "start_date_min_today": "La data di inizio deve essere oggi o successiva.",
        "active_filters": "Filtri attivi",
        "default_scenario_name": "Scenario principale",
        "no_scenarios_found": "Nessuno scenario trovato.",
        "opening_balance": "Saldo iniziale",
        "ending_balance": "Saldo finale",
        "inflow": "Entrate",
        "outflow": "Uscite",
        "total_in_period": "Totale nell'orizzonte visibile",
        "last_visible_period": "Saldo alla fine dell'ultima colonna visibile",
        "empty_client_description": "Selezioni prima un'azienda per caricare la pianificazione della liquidità.",
        "empty_scenario_description": "Per questa azienda non esiste ancora alcuno scenario. Crei ora il primo scenario.",
        "table_row_label": "Posizione",
        "manual_row_label": "Nome riga",
        "manual_row_label_required": "Inserisca un nome riga.",
        "add_manual_row": "Aggiungi riga manuale",
        "add_manual_row_individual": "Inserimento singolo",
        "add_manual_row_spreadsheet": "Foglio di calcolo (Excel)",
        "manual_spreadsheet_hint": "La prima riga viene mostrata nel piano. L'intero foglio di calcolo viene salvato.",
        "manual_spreadsheet_unavailable": "Il foglio di calcolo non è disponibile. Chiudi e riapri l'editor.",
        "manual_spreadsheet_values_required": "Inserisci almeno un valore o una formula nella prima riga.",
        "manual_edit": "Modifica manuale",
        "manual_entries": "Voci manuali",
        "manual_entries_hint": "Mantenga qui etichetta e importo per settimana calendario. La vista mensile aggrega automaticamente le settimane.",
        "manual_week": "Settimana calendario",
        "manual_entry_label": "Etichetta",
        "manual_entry_amount": "Importo",
        "manual_entries_count": "{count} voci manuali",
        "documents_count": "{count} record",
        "pending": "In sospeso",
        "open_outgoing_invoices": "Fatture attive emesse",
        "open_incoming_invoices": "Fatture passive aperte",
        "open_procurements": "Ordini aperti",
        "view_records": "Mostra record",
        "records_number": "Numero",
        "records_name": "Nome",
        "records_date": "Data",
        "records_amount": "Importo",
        "unassigned_cost_type": "Senza tipo di costo",
        "unassigned_revenue_type": "Senza tipo di ricavo",
        "select_cost_type": "Selezioni il tipo di costo",
        "select_revenue_type": "Selezioni il tipo di ricavo",
        "manual_row_type_save_error": "La riga manuale non è stata collegata al tipo di costo o ricavo selezionato. Applichi i metadati Hasura (metadata apply) e salvi di nuovo.",
        "balance_source_statement": "Ancorato all'estratto conto fino al {date}",
        "balance_source_manual": "Attiva solo la rettifica manuale dello scenario",
        "balance_source_none": "Nessun saldo bancario storico disponibile",
        "load_error": "Impossibile caricare la pianificazione della liquidità.",
        "save_error": "Impossibile salvare lo scenario.",
        "create_scenario": "Crea scenario",
        "copy_scenario": "Copia scenario",
        "delete_scenario": "Elimina scenario",
        "delete_scenario_confirm": "Vuole davvero eliminare questo scenario? Questo passaggio è irreversibile.",
        "create_scenario_prompt": "Inserisca il nome del nuovo scenario.",
        "edit_scenario_prompt": "Inserisca il nuovo nome per questo scenario.",
        "copy_scenario_prompt": "Inserisca il nome della copia.",
        "copy_suffix": "Copia",
        "name_required": "Inserisca un nome.",
        "delete_manual_row_confirm": "Vuole davvero eliminare questa riga manuale?",
        "table_width": "Larghezza colonne",
        "show_chart": "Mostra grafico",
        "view_standard": "Standard (13 sett. + 6 mesi)",
        "view_all_weeks": "Tutte le settimane",
        "view_all_months": "Tutti i mesi",
        "add_manual_row_inflow": "Riga manuale entrate",
        "add_manual_row_outflow": "Riga manuale uscite",
        "discard_unsaved_title": "Modifiche non salvate",
        "discard_unsaved_confirm": "Ha modifiche non salvate. Se cambia vista, le modifiche andranno perse. Vuole continuare?",
        "discard_unsaved_confirm_button": "Scarta modifiche"
    },
    "operator_area": {
        "title": "Operator",
        "tenant_menu": "Inquilini",
        "feature_billing_menu": "Feature Monetization",
        "feature_usage_menu": "Feature Usage",
        "mcp_usage_menu": "MCP Usage",
        "invoice_recognition_menu": "Invoice Recognition",
        "ai_llm_menu": "AI/LLM Monitor",
        "holiday_settings_menu": "Festivita",
        "einvoice_acceptance_menu": "Regole di accettazione e-fattura",
        "bank_statement_fixtures_menu": "Fixture Estratti Conto",
        "procurement_menu": "Ordini di acquisto",
        "invoice_menu": "Fatture",
        "invoice_export_log_menu": "Export Log",
        "no_permission": "Non è autorizzato a vedere quest'area.",
        "invoice_export_log": {
            "title": "Export Log",
            "filters": {
                "tenant": "Filter tenant",
                "invoice_id": "Invoice ID",
                "export_group": "Export group",
                "module": "Module",
                "source": "Source",
                "include_exported": "Included exported",
                "clear": "Reset filters"
            },
            "sources": {
                "bulk": "Bulk selection",
                "individual": "Individual export"
            },
            "statuses": {
                "success": "Success",
                "partial": "Partial",
                "failed": "Failed",
                "empty": "No export"
            },
            "columns": {
                "id": "ID",
                "status": "Status",
                "created_at": "Created at",
                "tenant": "Tenant",
                "module": "Module",
                "source": "Source",
                "include_exported": "Included exported",
                "requested_by": "Requested by",
                "export_group": "Export group",
                "requested": "Requested",
                "exported": "Exported",
                "skipped": "Skipped",
                "failed": "Failed",
                "requested_invoice_ids": "Requested invoices",
                "actually_exported_invoice_ids": "Actually exported invoices",
                "skipped_already_exported_invoice_ids": "Skipped already exported",
                "failed_invoice_ids": "Failed invoices",
                "error_details": "Registered error"
            },
            "copy_success": "Export log copied.",
            "copy_failed": "The export log could not be copied.",
            "errors": {
                "load_failed": "The export log could not be loaded."
            }
        },
        "holiday_settings": {
            "title": "Calendario festivita",
            "subtitle": "Maintain holidays by country and state/region. Leave the state list empty to make a holiday apply nationwide.",
            "add": "Add holiday",
            "create_title": "Create holiday",
            "edit_title": "Edit holiday",
            "year_filter": "Filter by year",
            "state_filter": "Filter by state",
            "country_filter": "Filter by country",
            "regions_placeholder": "Select or enter states/regions",
            "nationwide": "Nationwide",
            "empty_regions_hint": "If no state/region is stored, the holiday applies to the entire country.",
            "delete_confirm": "Do you really want to delete this holiday?"
        },
        "einvoice_acceptance": {
            "title": "Regole di accettazione e-fattura",
            "subtitle": "Configuri le istruzioni per le eccezioni IA e la criticità delle regole per la validazione locale delle e-fatture.",
            "add": "Aggiungi regola",
            "create_title": "Crea regola di accettazione",
            "edit_title": "Modifica regola di accettazione",
            "error_code": "Regola / codice errore",
            "error_code_placeholder": "Cercare una regola, es. BR-CL-23 o codice unità",
            "error_code_description": "Descrizione breve",
            "instruction": "Istruzione per l'IA",
            "instruction_placeholder": "Regola: BR-CL-23\nRiscontro: Codice unità non standardizzato\nDecisione: ACCEPT se quantità, prestazione, totali e calcolo fiscale restano chiari\nMotivazione: Lo scostamento riguarda il codice unità tecnico e non rende automaticamente inutilizzabile la fattura.",
            "enabled": "Attiva",
            "delete_confirm": "Eliminare davvero questa regola di accettazione?",
            "with_ai": "Con IA",
            "without_ai": "Senza IA",
            "edit_lists": "Modifica elenchi regole",
            "edit_lists_title": "Modifica elenchi regole senza IA",
            "edit_lists_hint": "Sposta ogni regola di controllo locale nell'elenco appropriato. Le modifiche vengono applicate solo dopo il salvataggio.",
            "manual_rule": "Regola manuale",
            "manual_rule_placeholder": "Inserire qualsiasi codice regola o errore",
            "add_manual_rule": "Aggiungi regola",
            "critical": "Critiche",
            "critical_hint": "Un riscontro in questo elenco mantiene bloccata la e-fattura.",
            "non_critical": "Non critiche",
            "non_critical_hint": "Una e-fattura con soli riscontri di questo elenco può superare la validazione locale.",
            "comment": "Commento",
            "comment_placeholder": "Commento opzionale per questa regola",
            "edit_comment_title": "Modifica commento regola",
            "no_comment": "Nessun commento"
        },
        "bank_statement_fixtures": {
            "title": "Fixture Estratti Conto",
            "subtitle": "Scarica file di test per estratti conto generati automaticamente in base alle fatture aperte del tenant corrente.",
            "access_notice": "Solo per operator. Il file ZIP contiene casi di test specifici del tenant incluso manifest.json.",
            "format_label": "Formato di output",
            "format_placeholder": "Selezioni un formato di estratto conto",
            "format_hint": "Scelga un formato di destinazione. Tutte le varianti scaricate verranno generate in quel formato.",
            "format_required": "Selezioni prima un formato di estratto conto.",
            "client_hint": "Scelga l'azienda le cui fatture aperte devono essere usate per generare i fixture degli estratti conto.",
            "client_required": "Selezioni prima un'azienda.",
            "client_placeholder": "Selezioni un'azienda con fatture aperte",
            "load_clients_error": "Non è stato possibile caricare le aziende disponibili.",
            "setup_title": "Configurazione",
            "setup_hint": "Selezioni prima il formato di destinazione e l'azienda prima di scaricare uno o più scenari di fixture.",
            "selection_ready": "Pronto per generare i fixture",
            "selection_incomplete": "Completi la selezione per abilitare i download",
            "selection_hint": "L'azienda selezionata viene usata per individuare le fatture aperte e inserire dati master realistici in ogni variante.",
            "selection_format": "Formato",
            "selection_company": "Azienda",
            "variants_title": "Scenari disponibili",
            "variants_hint": "Scelga sotto uno scenario mirato oppure scarichi il file ZIP completo quando la configurazione è pronta.",
            "technical_details": "Anteprima tecnica",
            "missing_value": "Non selezionato",
            "download_all": "Scarica tutte le varianti",
            "download_variant": "Scarica variante",
            "download_ready": "Il download è stato avviato.",
            "download_error": "Non è stato possibile scaricare i file di test.",
            "endpoint_label": "Endpoint",
            "auto_match_title": "Auto-Match",
            "auto_match_description": "Scarica casi di test mirati in cui i movimenti dovrebbero essere abbinati automaticamente alle fatture aperte.",
            "mixed_title": "Scenario misto",
            "mixed_description": "Contiene un match automatico, un addebito non assegnabile e un accredito ignorato.",
            "random_title": "Random Multi-Match",
            "random_description": "Contiene più movimenti realistici con diversi match, ulteriori voci unmatched e un accredito ignorato.",
            "supplier_iban_mismatch_title": "Divergenza IBAN fornitore",
            "supplier_iban_mismatch_description": "Scarica un caso di test mirato in cui il fornitore viene riconosciuto ma l'IBAN nell'estratto conto differisce dal master data del fornitore."
        },
        "tenant": {
            "description": "Inquilino",
            "new": "Nuovo inquilino",
            "edit": "Modifica",
            "archive": "Archivio",
            "delete": "Cancellare",
            "activate": "Restore",
            "procurement_count": "PO",
            "user_count": "Utente",
            "automatic_billing": "Fatturazione automatica",
            "automatic_billing_via": "Sì (tramite {id})",
            "automatic_billing_missing_easybill_id": "Sì (nessun ID collegato)",
            "storage_usage": "Spazio",
            "tabs": {
                "general": "Generale",
                "invoice_config": "Fatturazione",
                "ai": "IA"
            },
            "standard_package": "Pacchetto standard",
            "invoice": {
                "items": {
                    "label": "Voci aggiuntive",
                    "description": "Descrizione",
                    "price": "Importo netto",
                    "start_date": "Data di inizio",
                    "end_date": "Data di fine"
                },
                "tiered_price": {
                    "label": "Prezzi a scaglioni",
                    "unit_price": "Prezzo unitario",
                    "base_price": "Prezzo base",
                    "doc_amount": "Quantità"
                }
            },
            "contact_email_tooltip": "L'inquilino può inizialmente accedere con questa e-mail.",
            "no_bank_info": "I dati non sono ancora disponibili e possono essere creati solo dall'inquilino.",
            "no_connection_with_easybill": "Questo inquilino non è ancora collegato a Easybill. La preghiamo di registrare l'ID dell'inquilino nel sistema Easybill.",
            "sync_with_easybill": "Recuperare tutti i dati da Easybill",
            "update_from_easybill_btn": "Recupera da Easybill",
            "update_from_easybill_tooltip": "Recuperare l'inquilino da Easybill",
            "send_to_easybill_btn": "Creare in Easybill",
            "send_to_easybill_tooltip": "Creare un inquilino in Easybill",
            "link_existing_easybill_btn": "Collega a ID Easybill esistente",
            "link_existing_easybill_tooltip": "Impostare manualmente un ID cliente Easybill esistente",
            "link_easybill_replace_title": "Sostituire l'ID Easybill?",
            "link_easybill_replace_message": "Questo tenant è già collegato all'ID Easybill {current}. Vuole modificare il collegamento a {next}?",
            "link_easybill_title": "Collega ID Easybill",
            "link_easybill_prompt": "Inserisca l'ID cliente Easybill esistente.",
            "link_easybill_invalid": "Inserisca un ID numerico.",
            "create_and_send_invoice_tooltip": "Crei la fattura in Easybill e la invii al cliente.",
            "create_and_send_invoice_btn": "Creare/inviare la fattura",
            "open_invoices": "Visualizza le fatture",
            "delete_procurements": "Cancellare l'ordine di acquisto",
            "delete_invoices": "Cancellare le fatture",
            "confirm_before_delete_msg": "<p>È sicuro di voler eliminare definitivamente questo inquilino e tutti i suoi dati dal database? </p><p> <i>Questa azione non può essere annullata.</i></p><p><b>Inserisca il nome dell'inquilino:</b></p>",
            "confirm_before_delete_error_msg": "L'inquilino non è stato cancellato perché il nome è stato inserito in modo errato.",
            "deleted_msg": "L'inquilino è stato eliminato in modo permanente.",
            "updated_msg": "È stato aggiornato.",
            "created_msg": "È stato creato.",
            "sync_msg_error": "Questo inquilino non è ancora collegato a Easybill. La preghiamo di registrare l'ID dell'inquilino nel sistema Easybill.",
            "create_invoice_dialog": {
                "title": "Creare la fatturazione",
                "message": "Scelga il periodo di fatturazione.",
                "date_placeholder": "Selezioni un mese.",
                "create_btn": "Creare"
            },
            "validation": {
                "name_required": "La preghiamo di inserire un nome.",
                "name_exists": "Il nome esiste già.",
                "email_required": "Inserisca un'e-mail di contatto.",
                "email_invalid": "Inserisca un'e-mail valida."
            },
            "ai": {
                "enabled": "Abilita funzionalità IA",
                "model_name": "Nome del modello IA",
                "max_tokens": "Token massimi per richiesta (per 1.000 token)",
                "price_input_tokens": "Prezzo per 1.000 token di input (centesimi)",
                "price_output_tokens": "Prezzo per 1.000 token di output (centesimi)"
            }
        },
        "procurement": {
            "title": "Ordini di acquisto da parte dell'affittuario",
            "delete_title": "Cancellare l'ordine di acquisto",
            "result_found": "Colpi",
            "delete_result_found": "Cancella i risultati",
            "start_date": "Data di inizio",
            "end_date": "Data di fine",
            "range_separator": "a",
            "confirm_delete_msg": "È sicuro di voler eliminare definitivamente gli ordini di acquisto selezionati dal database?",
            "confirm_delete_title": "Cancellare l'ordine di acquisto",
            "confirm_delete_btn": "Cancellare"
        },
        "invoice": {
            "title": "Fatture dell'inquilino",
            "delete_title": "Cancellare le fatture",
            "result_found": "Colpi",
            "delete_result_found": "Cancella i risultati",
            "start_date": "Data di inizio",
            "end_date": "Data di fine",
            "range_separator": "a",
            "confirm_delete_msg": "È sicuro di voler eliminare definitivamente le fatture selezionate dal database?",
            "confirm_delete_title": "Cancellare la fattura",
            "confirm_delete_btn": "Cancellare"
        },
        "feature_usage": {
            "title": "Feature usage by tenant",
            "empty_state": "No tracked feature usage was found for the selected period.",
            "not_available": "n/a",
            "unknown_tenant": "Unknown tenant",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "summary": {
                "total_usage": "Tracked usage",
                "active_tenants": "Active tenants",
                "used_features": "Used features",
                "avg_usage_per_tenant": "Avg. usage per tenant",
                "top_feature": "Top feature",
                "of_active_base": "of active base",
                "top_feature_hint": "{usage} tracked uses across {tenants} tenants"
            },
            "charts": {
                "top_features": "Top features",
                "top_features_subtitle": "Most demanded features in the selected period.",
                "daily_trend": "Daily trend",
                "daily_trend_subtitle": "Tracked usage volume per day.",
                "procurement_sources": "Procurement sourcing",
                "procurement_sources_subtitle": "How products enter procurement lines in the selected period.",
                "punchout_providers": "Punchout providers",
                "punchout_providers_subtitle": "Marketplace usage by imported Punchout products.",
                "daily_usage_label": "Usage"
            },
            "procurement_sources": {
                "punchout": "Punchout",
                "catalog": "Product catalog",
                "on_the_fly": "On-the-fly",
                "unknown_punchout": "Unknown punchout"
            },
            "errors": {
                "schema_missing": "Feature usage tracking is not available in this environment yet. Apply the Hasura migration and metadata for tenant_feature_usage and reload the page.",
                "load_failed": "Feature usage could not be loaded."
            },
            "tables": {
                "features": "Feature ranking",
                "features_subtitle": "Demand by feature across the active tenant base.",
                "tenants": "Tenant ranking",
                "tenants_subtitle": "Most active tenants and their dominant features.",
                "modules": "Module overview",
                "modules_subtitle": "Consolidated demand by catalog module."
            },
            "columns": {
                "feature": "Feature",
                "module": "Module",
                "total_usage": "Usage",
                "active_tenants": "Tenants",
                "avg_per_tenant": "Avg./tenant",
                "event_breakdown": "Events",
                "top_tenant": "Top tenant",
                "last_used": "Last usage",
                "tenant": "Tenant",
                "used_features": "Features",
                "top_feature": "Top feature"
            }
        },
        "mcp_usage": {
            "title": "MCP usage",
            "empty_state": "No MCP usage was found for the selected period.",
            "no_errors": "No MCP errors were found for the selected period.",
            "not_available": "n/a",
            "units": {
                "ms": "ms",
                "seconds": "s"
            },
            "unknown_tenant": "Unknown tenant",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "summary": {
                "total_calls": "MCP calls",
                "active_tenants": "Active tenants",
                "active_users": "Active users",
                "success_rate": "Success rate",
                "error_calls_suffix": "calls with errors",
                "quality_score": "Quality score",
                "quality_score_hint": "Inferred from tool outcomes, warnings and result quality.",
                "answer_completion": "Inferred completion",
                "empty_results_suffix": "empty results",
                "avg_duration": "Avg. duration",
                "paginated_calls": "Paginated calls",
                "quality_signals_suffix": "quality signals",
                "session_feedback": "Session feedback",
                "session_feedback_hint": "Anonymized product insights from MCP conversations."
            },
            "charts": {
                "daily_trend": "Daily trend",
                "daily_trend_subtitle": "MCP calls per day in the selected period.",
                "top_tools": "Top tools",
                "top_tools_subtitle": "Most used MCP tools.",
                "outcomes": "Outcomes",
                "outcomes_subtitle": "Successful, blocked and failed calls.",
                "answer_quality": "Answer quality",
                "answer_quality_subtitle": "Inferred completeness of responses without storing prompts or answers.",
                "entities": "Entities",
                "entities_subtitle": "Business objects touched through MCP.",
                "calls_label": "Calls"
            },
            "tables": {
                "tools": "Tool ranking",
                "tools_subtitle": "Usage, success rate and average duration by tool.",
                "tenants": "Tenant ranking",
                "tenants_subtitle": "Tenants with the highest MCP activity.",
                "quality": "Quality focus",
                "quality_subtitle": "Tools with empty results, warnings, ignored filters or low inferred quality.",
                "answer_reasons": "Answer reasons",
                "answer_reasons_subtitle": "Why answers were complete, partial, blocked or unknown.",
                "errors": "Error focus",
                "errors_subtitle": "Sanitized error categories without prompts or payloads.",
                "session_feedback": "Session feedback",
                "session_feedback_subtitle": "Short anonymized AI notes about routing issues, gaps and suspected bugs."
            },
            "columns": {
                "tool": "Tool",
                "category": "Category",
                "answer_outcome": "Answer",
                "reason": "Reason",
                "calls": "Calls",
                "success_rate": "Success",
                "quality_score": "Quality",
                "empty_results": "Empty",
                "warnings": "Warnings",
                "ignored_filters": "Ignored filters",
                "avg_duration": "Avg. duration",
                "tenant": "Tenant",
                "users": "Users",
                "top_tool": "Top tool",
                "last_used": "Last usage",
                "error": "Error",
                "when": "Quando",
                "feedback_category": "Categoria",
                "severity": "Gravità",
                "summary": "Note",
                "related_tools": "Tool",
                "related_entities": "Entità"
            },
            "outcomes": {
                "success": "Success",
                "error": "Error",
                "permission_denied": "Permission denied",
                "rate_limited": "Rate limited",
                "validation_error": "Validation error",
                "timeout": "Timeout",
                "authentication_error": "Authentication error",
                "unknown": "Unknown"
            },
            "answer_outcomes": {
                "complete": "Complete",
                "partial": "Partial",
                "blocked": "Blocked",
                "empty_result": "Empty result",
                "low_confidence": "Low confidence",
                "unknown": "Unknown"
            },
            "feedback_reasons": {
                "success": "Successful",
                "no_data": "No data",
                "authentication_error": "Authentication",
                "permission_denied": "Permission denied",
                "rate_limited": "Rate limited",
                "timeout": "Timeout",
                "validation_error": "Validation error",
                "ambiguous_master_data": "Ambiguous master data",
                "paginated_result": "Paginated results",
                "tool_error": "Tool error",
                "low_confidence": "Low confidence",
                "not_supported": "Not supported",
                "filters_ignored": "Ignored filters",
                "warnings": "Warnings",
                "unknown": "Not specified"
            },
            "entities": {
                "none": "General",
                "bcase": "Workflow",
                "invoice": "Incoming invoices",
                "outgoing_invoice": "Outgoing invoices",
                "procurement": "Purchase orders",
                "contract": "Contracts",
                "bank_statement_entry": "Bank statement entries"
            },
            "no_session_feedback": "No session feedback was found for the selected period.",
            "session_feedback_categories": {
                "bug_suspicion": "Bug suspicion",
                "missing_capability": "Missing capability",
                "wrong_routing": "Wrong routing",
                "data_quality": "Data quality",
                "ux_friction": "UX friction",
                "feature_request": "Feature request",
                "positive_signal": "Positive signal",
                "unknown": "Unknown"
            },
            "session_feedback_severities": {
                "low": "Low",
                "medium": "Medium",
                "high": "High",
                "unknown": "Unknown"
            },
            "no_quality_issues": "No MCP quality signals were found for the selected period.",
            "errors": {
                "schema_missing": "MCP usage analytics is not available in this environment yet. Apply the Hasura migration and metadata for mcp_usage_event and reload the page.",
                "load_failed": "MCP usage could not be loaded."
            }
        },
        "ai_llm": {
            "title": "AI/LLM Monitor",
            "empty_state": "No LLM calls available for the selected period.",
            "no_errors": "No LLM failures in the selected period.",
            "unknown_tenant": "Unknown tenant",
            "unknown_region": "Unknown Azure endpoint",
            "unknown_operation": "Unknown operation",
            "unknown_model": "Unknown model",
            "filters": {
                "tenant_placeholder": "Filter by tenant",
                "operation_placeholder": "Filter by operation",
                "model_placeholder": "Filter by model",
                "status_placeholder": "Filter by status"
            },
            "shortcuts": {
                "this_month": "This month",
                "last_month": "Last month",
                "last_7_days": "Last 7 days",
                "last_30_days": "Last 30 days"
            },
            "summary": {
                "total_calls": "LLM calls",
                "total_calls_hint": "Central Azure OpenAI calls recorded by the backend.",
                "success_rate": "Success rate",
                "succeeded_suffix": "successful calls",
                "fallbacks": "Fallbacks used",
                "fallbacks_hint": "Successful calls that reached a secondary region.",
                "failures": "Failures",
                "rejected_suffix": "non-regional rejections",
                "system_status": "System status",
                "tokens": "Tokens",
                "tokens_hint": "{input} input / {output} output",
                "estimated_cost": "Estimated cost",
                "estimated_cost_hint": "Shown when token price configuration is available."
            },
            "health_states": {
                "unknown": "No data",
                "unknown_hint": "No calls were recorded for the selected filters.",
                "normal": "Normal",
                "normal_hint": "LLM calls are succeeding within the selected period.",
                "degraded": "Degraded",
                "degraded_hint": "Failures or fallback usage need attention.",
                "unavailable": "Unavailable",
                "unavailable_hint": "No successful LLM calls were recorded."
            },
            "alerts": {
                "unavailable_title": "LLM appears unavailable",
                "unavailable_description": "All recorded calls failed or were blocked for the selected period.",
                "failure_rate_high_title": "High LLM failure rate",
                "failure_rate_high_description": "The selected scope has a failure rate of {rate}.",
                "failure_rate_warning_title": "Elevated LLM failure rate",
                "failure_rate_warning_description": "The selected scope has a failure rate of {rate}.",
                "fallbacks_title": "Fallbacks were used",
                "fallbacks_description": "{count} successful call(s) required a secondary Azure endpoint."
            },
            "healthcheck": {
                "action": "Run healthcheck",
                "title": "Manual healthcheck",
                "subtitle": "Live Azure OpenAI endpoint test triggered by an operator.",
                "success": "At least one Azure endpoint responded successfully.",
                "warning": "No Azure endpoint responded successfully.",
                "error": "The LLM healthcheck could not be completed.",
                "no_endpoints_title": "No Azure endpoints were tested",
                "no_endpoints_description": "Check that endpoint, api-key and deployment are configured for Azure OpenAI.",
                "all_ok_title": "All Azure endpoints are reachable",
                "all_ok_description": "{count} Azure endpoint(s) responded successfully.",
                "partial_title": "Some Azure endpoints are reachable",
                "partial_description": "{succeeded} of {total} Azure endpoint(s) responded successfully. Check the per-endpoint error details.",
                "none_ok_title": "No Azure endpoint responded successfully",
                "none_ok_description": "The endpoint can be correct while the API key, deployment name or permissions do not match at least one Azure OpenAI resource."
            },
            "charts": {
                "region_health": "Azure endpoint health",
                "region_health_subtitle": "Successful and failed Azure OpenAI calls by endpoint and operation.",
                "daily_failures": "Failures over time",
                "daily_failures_subtitle": "Failed, rejected and circuit-open calls per day.",
                "failures_label": "Failures"
            },
            "tables": {
                "regions": "Azure endpoints and operations",
                "regions_subtitle": "Aggregated health by Azure OpenAI endpoint, operation and model.",
                "latest_errors": "Latest errors",
                "latest_errors_subtitle": "Recent failed or rejected LLM calls for operational triage."
            },
            "columns": {
                "created_at": "Time",
                "tenant": "Tenant",
                "region": "Region",
                "azure_endpoint": "Azure endpoint",
                "operation": "Operation",
                "model": "Model",
                "calls": "Calls",
                "successes": "Successes",
                "failures": "Failures",
                "failure_rate": "Failure rate",
                "avg_duration": "Avg. duration",
                "status": "Status",
                "http_status": "HTTP",
                "retries": "Retries",
                "duration": "Duration",
                "error": "Error"
            },
            "statuses": {
                "succeeded": "Succeeded",
                "failed": "Failed",
                "rejected": "Rejected",
                "circuit_open": "Region blocked"
            },
            "units": {
                "milliseconds": "{value} ms",
                "seconds": "{value} s"
            },
            "errors": {
                "schema_missing": "LLM call logging is not available in this environment yet. Apply the Hasura migration and metadata for ai_llm_call_log and reload the page.",
                "load_failed": "LLM dashboard data could not be loaded."
            }
        },
        "invoice_recognition": {
            "title": "Invoice Recognition – Monitor",
            "empty_state": "No data available for the selected period.",
            "no_switchovers": "No region switchovers were required in the selected period.",
            "no_in_flight": "No recognitions are currently in the queue.",
            "unknown_tenant": "Unknown tenant",
            "processing_active": "Processing",
            "processing_idle": "Waiting",
            "copy_success": "Copied to clipboard.",
            "copy_failed": "Could not copy.",
            "filters": {
                "tenant_placeholder": "Filter by tenant"
            },
            "shortcuts": {
                "this_month": "This month",
                "last_month": "Last month",
                "last_7_days": "Last 7 days",
                "last_30_days": "Last 30 days"
            },
            "summary": {
                "invoices_processed": "Invoices processed",
                "invoices_processed_hint": "{attempts} attempts in total",
                "successful": "Recognized successfully",
                "switchovers": "Region switchovers",
                "switchovers_hint": "Invoices that needed at least one region switch (relevant for MS refund).",
                "failed": "Finally failed",
                "failed_hint": "Invoices without a successful recognition (handed over to manual review).",
                "in_flight": "Currently in flight",
                "in_flight_hint": "Invoices currently waiting in the recognition queue."
            },
            "charts": {
                "region_status": "Attempts per region",
                "region_status_subtitle": "Distribution of recognition attempts by region and status.",
                "daily_failures": "Failures over time",
                "daily_failures_subtitle": "Failed attempts per day in the selected period.",
                "failures_label": "Failures"
            },
            "tables": {
                "switchovers": "Invoices with region switchover",
                "switchovers_subtitle": "Invoices that switched at least once to another region. Expand a row to see the full attempt trail incl. provider operation IDs (evidence for MS refund cases).",
                "region_health": "Region health",
                "region_health_subtitle": "Current health of each Azure AI region in the selected period.",
                "in_flight": "In-flight recognitions",
                "in_flight_subtitle": "Invoices currently waiting in the queue for a response."
            },
            "columns": {
                "tenant": "Tenant",
                "invoice_id": "Invoice ID",
                "region_path": "Region path",
                "attempt_count": "Attempts",
                "final_status": "Final status",
                "last_attempt": "Last attempt",
                "operation_id": "Operation ID",
                "region": "Region / model",
                "total_attempts": "Attempts",
                "successes": "Successes",
                "failures": "Failures",
                "failure_rate": "Failure rate",
                "last_failure": "Last failure",
                "poll_attempts": "Polls",
                "elapsed": "Elapsed",
                "processing": "Status"
            },
            "statuses": {
                "submitted": "Submitted",
                "succeeded": "Succeeded",
                "failed": "Failed",
                "timed_out": "Timed out",
                "submission_failed": "Submission failed",
                "circuit_open": "Region blocked"
            },
            "models": {
                "document_intelligence": "Document Intelligence",
                "content_understanding": "Content Understanding",
                "azure_open_ai": "Azure OpenAI"
            },
            "errors": {
                "load_failed": "Could not load data."
            },
            "tabs": {
                "operations": "Esercizio",
                "quality": "Qualità",
                "approval_quality": "Qualità approvazione"
            },
            "approval_quality": {
                "scope_manual": "Controllate manualmente",
                "scope_auto": "Inoltrate automaticamente",
                "scope_all": "Tutte le decisioni",
                "methodology": "Per impostazione predefinita vengono confrontate tutte le decisioni di approvazione IA — incluse quelle inoltrate automaticamente. Approvata = contabilità, esportazione o completata; annullata = rifiutata o annullamento esportato. Le decisioni in corso o tecnicamente non valutabili sono escluse dai tassi di qualità.",
                "invoices_evaluated": "Fatture valutate",
                "invoices_evaluated_hint": "{decided} decisioni, di cui {pending} in corso e {unavailable} tecnicamente non valutabili",
                "false_approval_rate": "Tasso di approvazioni errate",
                "false_approval_rate_hint": "{falseApprovals} di {aiApprovals} approvazioni proposte dall'IA sono state successivamente annullate.",
                "approval_precision": "Approvazioni IA corrette",
                "approval_precision_hint": "Quota delle approvazioni proposte dall'IA rimaste approvate nel risultato finale.",
                "missed_automation_rate": "Automazione mancata",
                "missed_automation_rate_hint": "{missed} di {approved} fatture infine approvate non sono state approvate dall'IA.",
                "agreement_rate": "Concordanza",
                "agreement_rate_hint": "Quota dei casi risolti in cui la decisione dell'IA coincide con il risultato finale.",
                "matrix_title": "Decisione IA rispetto al risultato finale",
                "matrix_subtitle": "Solo decisioni concluse e tecnicamente valutabili nel periodo selezionato.",
                "actual_approved": "Approvata definitivamente",
                "actual_cancelled": "Annullata definitivamente",
                "ai_approved": "L'IA approverebbe",
                "ai_rejected": "L'IA non approverebbe",
                "correct": "Corretto",
                "false_approval": "Approvazione errata",
                "missed_automation": "Automazione mancata",
                "false_approvals_title": "Dettaglio approvazioni errate",
                "false_approvals_subtitle": "Fino a 80 fatture che l'IA avrebbe approvato ma che sono state infine annullate.",
                "empty_state": "Nessuna approvazione errata trovata nel periodo selezionato.",
                "load_failed": "Impossibile caricare i dati sulla qualità delle approvazioni.",
                "number": "Numero fattura",
                "score": "Punteggio IA",
                "threshold": "Soglia",
                "reasons": "Segnali decisivi",
                "final_status": "Stato finale",
                "auto_forwarded": "Automatico",
                "decided_at": "Decisione IA",
                "yes": "Sì",
                "no": "No"
            },
            "quality": {
                "scope_all": "Tutte le fatture",
                "scope_manual": "Controllate manualmente",
                "scope_auto": "Inoltrate automaticamente dalla KI",
                "methodology": "Confronto: snapshot dopo il riconoscimento del documento e la validazione KI rispetto alla fattura attuale. Un campo modificato conta come riconoscimento errato.",
                "invoices_evaluated": "Fatture valutate",
                "invoices_evaluated_hint": "{manual} controllate manualmente, {auto} inoltrate automaticamente",
                "mean_field_rate": "Media aritmetica",
                "mean_field_rate_hint": "Tasso medio di riconoscimento su tutti i campi.",
                "median_field_rate": "Mediana",
                "median_field_rate_hint": "Tasso di riconoscimento del campo mediano, meno influenzato dagli outlier.",
                "mean_receipt_score": "Media per fattura",
                "median_receipt_score_hint": "Mediana per fattura: {median}",
                "field_chart_title": "Tasso di riconoscimento per campo",
                "field_chart_subtitle": "Quota di fatture in cui il campo è rimasto invariato dopo il riconoscimento.",
                "groups_title": "Gruppi di campi",
                "groups_subtitle": "Tasso ponderato per gruppo (solo campi valutati).",
                "fields_title": "Campi in dettaglio",
                "fields_subtitle": "Invariato = riconosciuto correttamente. I campi vuoti su entrambi i lati sono esclusi.",
                "invoices_title": "Fatture con i punteggi più bassi",
                "invoices_subtitle": "Le 80 fatture con la corrispondenza più debole nel periodo selezionato. Espandere la riga per i campi modificati.",
                "empty_state": "Nessuno snapshot per questo periodo. La misurazione inizia con le fatture riconosciute dopo questo rilascio.",
                "load_failed": "Impossibile caricare i dati di qualità.",
                "field": "Campo",
                "group": "Gruppo",
                "evaluated": "Valutati",
                "matched": "Invariati",
                "rate": "Tasso",
                "number": "Numero fattura",
                "receipt_score": "Punteggio fattura",
                "fields_short": "Campi",
                "auto_forwarded": "Auto-inoltro",
                "auto_yes": "Sì",
                "auto_no": "No",
                "baseline_at": "Snapshot",
                "baseline": "Dopo il riconoscimento",
                "final_value": "Attuale",
                "no_mismatches": "Nessun campo modificato.",
                "groups": {
                    "document": "Dati documento",
                    "bank": "Dati bancari",
                    "matching": "Associazione",
                    "organization": "Organizzazione",
                    "lines": "Righe"
                }
            }
        },
        "feature_billing": {
            "title": "Feature monetization",
            "sync": "Sync catalog",
            "new_package": "New package",
            "create_package": "Create package",
            "edit_package": "Edit package",
            "sync_success": "Feature catalog synchronized.",
            "catalog_hint": "This area monetizes existing modules, features and packages without changing the current runtime behavior of the system.",
            "overview_title": "Overview & metrics",
            "show_overview": "Show metrics",
            "hide_overview": "Hide metrics",
            "edit_feature": "Edit monetization",
            "manage_tenants": "Manage tenants",
            "assign_tenant": "Assign tenant",
            "manage_package_tenants": "Manage package tenants",
            "assign_package": "Assign package",
            "assignment_dialog_title": "Tenant feature assignment",
            "package_assignment_dialog_title": "Tenant package assignment",
            "custom_price_hint": "Leave empty to use the feature default price.",
            "not_configured": "Not configured",
            "no_assignments": "No tenant assignment found.",
            "unassigned_module": "Without module",
            "unassigned_module_description": "Features that are monetized independently from any specific module.",
            "package_features_label": "Included features",
            "package_feature_hint": "Select the features that belong to this package.",
            "package_code_placeholder": "stable-package-code",
            "package_code_hint": "Generated automatically from the package name.",
            "catalog_inactive": "Catalog inactive",
            "billing_enabled": "Monetization enabled",
            "billing_disabled": "Monetization disabled",
            "tabs": {
                "features": "Features",
                "packages": "Packages",
                "tenants": "Tenants",
                "ai_automation": "AI automation"
            },
            "summary": {
                "modules": "Modules",
                "features": "Features",
                "packages": "Packages",
                "direct_assignments": "Direct assignments",
                "package_assignments": "Package assignments",
                "active_assignments": "Active assignments",
                "trial_assignments": "Trial assignments"
            },
            "sections": {
                "package_assignments": "Package assignments",
                "direct_feature_assignments": "Direct feature assignments"
            },
            "columns": {
                "module": "Module",
                "feature": "Feature",
                "package": "Package",
                "code": "Code",
                "description": "Description",
                "catalog_status": "Catalog status",
                "billing_type": "Billing type",
                "default_price": "Default price",
                "default_demo_days": "Demo days",
                "pricing": "Pricing",
                "coverage": "Coverage",
                "composition": "Composition",
                "assignments": "Assignments",
                "direct_assignments": "Direct",
                "covered_tenants": "Covered tenants",
                "packages": "Packages",
                "included_features": "Included features",
                "references": "System reference",
                "tenant": "Tenant",
                "status": "Status",
                "effective_price": "Effective price",
                "custom_price": "Custom price",
                "demo_until": "Demo until",
                "active_features": "Active",
                "active_packages": "Packages",
                "trial_features": "Trial",
                "total_assignments": "Total"
            },
            "ai_automation": {
                "title": "AI automation by client and supplier",
                "description": "Evaluates AI-validated invoices by whether they reached export without relevant manual corrections.",
                "details_title": "Monthly evaluation",
                "empty_title": "No AI automation data yet",
                "empty_text": "After the migration is applied and AI-validated invoices have been exported, the evaluation will be filled.",
                "unknown_tenant": "Unknown tenant",
                "unknown_client": "Unknown client",
                "unknown_supplier": "Unknown supplier",
                "no_client": "No client",
                "no_supplier": "No supplier",
                "detail_title": "Invoice details",
                "actions": {
                    "details": "Details"
                },
                "summary": {
                    "total_invoices": "Invoices",
                    "ai_validated": "AI validated",
                    "one_click_export": "One-click export",
                    "best_case": "Best case",
                    "automation_value": "Automation value",
                    "manual_corrections": "Manual corrections"
                },
                "columns": {
                    "company": "Company",
                    "client_supplier": "Client / supplier",
                    "period": "Period",
                    "supplier": "Supplier",
                    "billing_tier": "Billing tier",
                    "ai_validated": "AI validated",
                    "email_imported": "Email",
                    "auto_export": "Auto export",
                    "exported": "Exported",
                    "one_click": "One-click",
                    "best_case": "Best case",
                    "manual_corrections": "Manual corrections"
                },
                "column_help": {
                    "tenant": "Tenant or customer account to which this monthly KPI row belongs.",
                    "client_supplier": "Combination of client and supplier for the invoices counted in this row.",
                    "period": "Calendar month and year covered by this evaluation row.",
                    "billing_tier": "Derived monetization tier based on the measured automation score for this row.",
                    "ai_validated": "How many invoices were AI-validated out of all invoices in the row. The note shows how many came from email import.",
                    "auto_export": "Invoices automatically forwarded toward export. The note shows how many were ultimately exported successfully.",
                    "one_click": "Invoices that reached export with a one-click confirmation after AI validation.",
                    "best_case": "Invoices with the highest automation level, typically email-imported and exported with one click and no relevant manual correction.",
                    "manual_corrections": "Invoices that still required relevant manual changes after AI processing. The note breaks down the correction types.",
                    "actions": "Opens the invoice-level detail view for the selected monthly row."
                },
                "detail_columns": {
                    "invoice": "Invoice",
                    "automation": "Automation",
                    "ki": "AI",
                    "export": "Export",
                    "corrections": "Corrections",
                    "result": "Result"
                },
                "boolean": {
                    "yes": "Yes",
                    "no": "No"
                },
                "labels": {
                    "email": "Email",
                    "validated": "Validated",
                    "auto_forwarded": "Auto export",
                    "one_click": "One-click",
                    "best_case": "Best case",
                    "not_exported": "Not exported"
                },
                "automation_levels": {
                    "unknown": "Unknown",
                    "no_ai": "No AI",
                    "ai_not_validated": "Not validated",
                    "manual_correction": "Manual correction",
                    "ki_validated_waiting": "AI validated",
                    "ki_autonomous_to_export_ready": "Prepared for export",
                    "one_click_export": "One-click export",
                    "email_import_one_click_export": "Email one-click export"
                },
                "billing_tiers": {
                    "premium": "Premium",
                    "advanced": "Advanced",
                    "automation": "Automation",
                    "assist": "Assist",
                    "base": "Base"
                },
                "billing_tier_legend": {
                    "title": "Billing tier guide",
                    "items": {
                        "base": "Little measurable automation value in this row.",
                        "assist": "AI assists the process, but manual work still dominates.",
                        "automation": "Meaningful automation gains; several invoices are export-ready with limited manual effort.",
                        "advanced": "High automation level with only occasional manual intervention.",
                        "premium": "Very high automation level; most invoices run nearly touchless."
                    }
                },
                "correction_types": {
                    "values": "Values",
                    "bank": "Bank",
                    "organization": "Organization",
                    "other": "Other",
                    "note_only": "Note only",
                    "none": "No relevant correction"
                }
            },
            "billing_types": {
                "monthly": "Monthly",
                "yearly": "Yearly",
                "one_time": "One-time",
                "usage": "Usage-based",
                "included": "Included"
            },
            "assignment_statuses": {
                "active": "Active",
                "trial": "Trial",
                "inactive": "Inactive"
            },
            "validation": {
                "package_name_required": "Please enter a package name.",
                "package_code_required": "Please enter a valid package code.",
                "package_features_required": "Please select at least one feature for the package."
            }
        }
    },
    "timeline": {
        "title": "Timeline",
        "preferences": {
            "order_asc": "Prima il più anziano",
            "order_desc": "Prima i più nuovi",
            "comment_notifications": "Notifiche e-mail per commenti",
            "comment_notifications_enabled": "Notifiche commenti attivate.",
            "comment_notifications_disabled": "Notifiche commenti disattivate."
        },
        "text": {
            "description_assignment": "Il compito è stato accettato.",
            "cancellation": {
                "name": "{name}",
                "description_past_successful_invoice": "La fattura è stata rimossa e archiviata.",
                "description_past_successful_outgoing-invoice": "La fattura di vendita è stata annullata e archiviata.",
                "description_past_successful_procurement": "L'ordine d'acquisto è stato annullato e archiviato.",
                "description_past_successful_contract": "Il contratto è stato annullato e archiviato.",
                "name_procurement": "Annullamento",
                "name_contract": "Annullamento",
                "name_outgoing-invoice": "Annullamento",
                "name_invoice": "Rimozione"
            },
            "start": {
                "name": "Nuovo ordine di acquisto",
                "description_past_successful": "È stato creato un nuovo ordine di acquisto."
            },
            "select-product": {
                "is_searchable": true,
                "simple_name": "Selezione del prodotto",
                "name": "Selezione del prodotto (Fase {index})",
                "description_past_unsuccessful": "La selezione del prodotto è stata annullata.",
                "description_past_successful": "I prodotti per questo ordine sono stati selezionati.",
                "description_present": "Selezioni i prodotti per questo ordine.",
                "description_future": "È necessario selezionare i prodotti per questo ordine."
            },
            "approval": {
                "is_searchable": true,
                "simple_name": "Approvazione",
                "name": "Approvazione (Fase {index})",
                "description_past_unsuccessful": "L'approvazione dell'ordine è stata annullata.",
                "description_past_successful": "L'ordine di acquisto è stato esaminato e approvato.",
                "description_present": "Si prega di rivedere e approvare l'ordine di acquisto.",
                "description_future": "L'ordine di acquisto deve essere rivisto e approvato."
            },
            "send-order": {
                "is_searchable": true,
                "name": "Ordinazione di ordini",
                "description_past_unsuccessful": "L'ordine è stato annullato.",
                "description_past_successful": "L'ordine è stato effettuato al fornitore.",
                "description_present": "La preghiamo di effettuare l'ordine al fornitore.",
                "description_future": "L'ordine deve essere effettuato al fornitore."
            },
            "delivery": {
                "is_searchable": true,
                "name": "Conferma di consegna",
                "description_past_unsuccessful": "La conferma di ricezione della merce è stata annullata.",
                "description_past_successful": "La merce è stata consegnata e il ricevimento è stato confermato.",
                "description_present": "La preghiamo di confermare la ricezione della merce.",
                "description_future": "Il ricevimento della merce deve essere confermato."
            },
            "reassignment": {
                "name": "Assegnazione",
                "description_past_unsuccessful": "",
                "description_past_successful": "ha assegnato il compito a {nome}.",
                "description_past_successful_from_group": "ha accettato il compito."
            },
            "clearing": {
                "is_searchable": true,
                "name": "Chiarimento",
                "description_past_unsuccessful": "Il chiarimento è stato annullato.",
                "description_past_successful": "Le incertezze sono state eliminate.",
                "description_present": "La preghiamo di chiarire le incertezze relative all'ordine.",
                "description_finished_unsuccessful": "L'ordine è stato cancellato e archiviato."
            },
            "order-sent-internal": {
                "name": "Messaggio del sistema",
                "description_past_successful": "L'ordine <b>({first_product_name})</b> con il fornitore <b>{supplier}</b> è stato effettuato e confermato."
            },
            "order-sent-punchout": {
                "name": "Messaggio del sistema",
                "description_past_successful": "L'ordine <b>({first_product_name})</b> è stato inviato elettronicamente al fornitore <b>{supplier}</b>."
            },
            "product-received": {
                "name": "Messaggio del sistema",
                "description_past_successful": "<b>{quantity} {unit}</b> ricevuta:<p>{product}</p><span style=\"color:#9a9898\">{supplier}</span>"
            },
            "invoice-upload": {
                "name": "Nuova fattura",
                "description_past_successful": "La fattura è stata caricata."
            },
            "invoice-recognition": {
                "is_searchable": true,
                "name": "Riconoscimento delle fatture",
                "description_past_unsuccessful": "Il riconoscimento dei dati della fattura è stato annullato.",
                "description_past_successful": "Il riconoscimento dei dati delle fatture è stato completato.",
                "description_present": "I dati della fattura vengono letti. Questo processo può richiedere fino a un minuto. Si prega di ricaricare la pagina dopo questo tempo per vedere i risultati."
            },
            "invoice-historical-import": {
                "name": "Importazione storica",
                "description_past_successful": "La fattura è stata salvata come fattura storica."
            },
            "procurement-recognition": { "name": "Dati ordine riconosciuti", "description_past_successful": "I dati dell'ordine sono stati estratti dall'e-mail storica." },
            "procurement-counterparty-recognition": { "name": "Controparti riconosciute", "description_past_successful": "Azienda e fornitore sono stati riconosciuti." },
            "procurement-master-data-adopted": { "name": "Dati anagrafici adottati", "description_past_successful": "I dati anagrafici riconosciuti sono stati adottati." },
            "procurement-historical-import": { "name": "Importazione storica", "description_past_successful": "L'ordine è stato salvato come contesto storico." },
            "invoice-counterparty-recognition": {
                "name": "Azienda e fornitore riconosciuti",
                "description_past_successful": "L'azienda e il fornitore sono stati riconosciuti dalla fattura.",
                "description_past_unsuccessful": "L'azienda e il fornitore non sono stati identificati in modo affidabile."
            },
            "invoice-master-data-adopted": {
                "name": "Dati anagrafici acquisiti",
                "description_past_successful": "I dati riconosciuti dell'azienda o del fornitore sono stati acquisiti nei dati anagrafici.",
                "description_past_unsuccessful": "Non sono stati acquisiti dati anagrafici affidabili."
            },
            "invoice-manual-check": {
                "is_searchable": true,
                "name": "Controllo manuale",
                "description_past_unsuccessful": "Il controllo manuale non è stato completato.",
                "description_past_successful": "La fattura è stata controllata manualmente.",
                "description_present": "La preghiamo di controllare i dati della fattura.",
                "description_future": "La fattura deve essere controllata manualmente."
            },
            "invoice-financial-approval": {
                "is_searchable": true,
                "simple_name": "Approvazione Fattura",
                "name": "Approvazione Fattura (Fase {index})",
                "description_past_unsuccessful": "L'approvazione della fattura è stata annullata.",
                "description_past_successful": "La fattura è stata verificata e approvata.",
                "description_present": "Si prega di verificare e approvare la fattura.",
                "description_future": "La fattura deve essere verificata e approvata."
            },
            "invoice-clearing": {
                "is_searchable": true,
                "name": "Chiarimento della contabilità",
                "description_past_unsuccessful": "Il chiarimento è stato annullato.",
                "description_past_successful": "Le incertezze sulla fattura sono state eliminate.",
                "description_present": "La preghiamo di chiarire le incertezze relative alla fattura.",
                "description_finished_unsuccessful": "La fattura è stata annullata e archiviata."
            },
            "invoice-export": {
                "is_searchable": true,
                "name": "Esportazione",
                "description_past_unsuccessful": "La fattura non è stata esportata.",
                "description_past_successful": "La fattura è stata presentata a {export_name}.",
                "description_present": "La fattura è pronta per l'esportazione.",
                "description_future": "La fattura è pronta per l'esportazione."
            },
            "invoice-accounting": {
                "is_searchable": true,
                "name": "Contabilità",
                "description_past_unsuccessful": "La contabilità è stata interrotta.",
                "description_past_successful": "La contabilità è stata verificata.",
                "description_present": "Si prega di controllare la contabilità.",
                "description_future": "La contabilità deve essere controllata."
            },
            "invoice-verified": {
                "is_searchable": true,
                "name": "Verificata",
                "description_past_unsuccessful": "La verifica è stata annullata.",
                "description_past_successful": "La fattura è stata verificata.",
                "description_present": "La fattura verrà verificata.",
                "description_future": "La fattura verrà verificata."
            },
            "skip": {
                "name": "Cancellazione",
                "description_past_successful": "ha annullato il passo."
            },
            "contract-start": {
                "name": "Nuovo contratto",
                "description_past_successful": "Il contratto è stato creato."
            },
            "contract-recognition": {
                "is_searchable": true,
                "name": "Riconoscimento contratto",
                "description_past_successful": "I dati del contratto sono stati riconosciuti.",
                "description_present": "I dati del contratto vengono riconosciuti."
            },
            "contract-check": {
                "is_searchable": true,
                "name": "Revisione del contratto",
                "description_past_unsuccessful": "La revisione non è stata completata.",
                "description_past_successful": "Il contratto è stato revisionato.",
                "description_present": "Si prega di verificare i dati del contratto."
            },
            "contract-signing": {
                "is_searchable": true,
                "name": "Firma del contratto",
                "description_past_unsuccessful": "Il contratto non è stato firmato.",
                "description_past_successful": "Il contratto è stato firmato.",
                "description_present": "Si prega di firmare il contratto.",
                "description_future": "Il contratto deve essere firmato."
            },
            "contract-clearing": {
                "is_searchable": true,
                "name": "Chiarimento contratto",
                "description_past_unsuccessful": "Il chiarimento è stato annullato.",
                "description_past_successful": "Le incertezze del contratto sono state chiarite.",
                "description_present": "Si prega di chiarire il contratto.",
                "description_finished_unsuccessful": "Il contratto è stato annullato e archiviato."
            }
        }
    },
    "jexcel": {
        "noRecordsFound": "Non sono state trovate voci.",
        "showingPage": "Pagina {0} di {1}",
        "show": "Mostra",
        "entries": " voci",
        "insertANewColumnBefore": "Inserisca la colonna prima",
        "insertANewColumnAfter": "Inserisca la colonna dopo",
        "deleteSelectedColumns": "Cancelli le colonne selezionate",
        "renameThisColumn": "Rinomini questa colonna",
        "orderAscending": "Ordinamento ascendente",
        "orderDescending": "Ordinamento discendente",
        "insertANewRowBefore": "Inserisca la riga prima di",
        "insertANewRowAfter": "Inserisca la riga dopo",
        "deleteSelectedRows": "Cancellare le righe selezionate",
        "copy": "Copia",
        "paste": "Incolla",
        "saveAs": "Salva con nome",
        "about": "A proposito di",
        "areYouSureToDeleteTheSelectedRows": "È sicuro di voler eliminare le righe selezionate?",
        "areYouSureToDeleteTheSelectedColumns": "È sicuro di voler eliminare le colonne selezionate?",
        "thisActionWillDestroyAnyExistingMergedCellsAreYouSure": "Questa azione distruggerà tutte le celle unite esistenti. È sicuro?",
        "thisActionWillClearYourSearchResultsAreYouSure": "Questa azione cancellerà i risultati della ricerca. È sicuro?",
        "thereIsAConflictWithAnotherMergedCell": "C'è un conflitto con un'altra cella unita",
        "invalidMergeProperties": "Proprietà unite non valide",
        "cellAlreadyMerged": "Cella già unita",
        "noCellsSelected": "Nessuna cella selezionata",
        "save_warning": "Copiare dati tra Excel e il web può portare a sequenze errate e alla perdita di relazioni ID. <br>Si prega di utilizzare solo la modifica online o di aggiungere i dati di Excel come supplemento."
    },
    "system_comment": {
        "name": {
            "allocation": "Assegnazione",
            "datev_export": "Esportazione DATEV",
            "export_error": "Errore di esportazione",
            "export_detail": "Protocollo di esportazione",
            "repeat_recognition": "Ripeti riconoscimento fattura",
            "bank_data_export_summary": "Modalità di pagamento",
            "payment": "Pagamento da estratto conto",
            "bank_statement_payment": "Pagamento da estratto conto",
            "contract-termination-email": "Promemoria disdetta contratto",
            "ai_validation": "Validazione IA"
        },
        "contract_termination_email_sent": "L'email di promemoria della disdetta è stata inviata a {recipient}.",
        "contract_termination_email_failed": "Impossibile inviare l'email di promemoria della disdetta a {recipient}. Errore: {error}.",
        "ai_validation_trusted": "La fattura è stata verificata dall'IA ed è stata considerata affidabile.",
        "ai_validation_not_trusted": "La fattura è stata verificata dall'IA ed è stata inoltrata al controllo manuale.",
        "invoice_approval_restart": "Il processo di approvazione della fattura è stato riavviato. Motivo: {reason}",
        "recognition_was_repeated": "{user_name} ha ripetuto il riconoscimento documento.",
        "attach_new_invoice_to_procurement": "La fattura <b>{link_to_invoice}</b> di <b>{supplier_name}</b> è stata assegnata a questo ordine d'acquisto da <b>{user_name}</b>.",
        "attach_new_invoice_to_bcase": "La fattura <b>{link_to_invoice}</b> di <b>{supplier_name}</b> è stata assegnata a questo documento da <b>{user_name}</b>.",
        "change_bcase_of_invoice": "L'assegnazione della fattura <b>{link_to_invoice}</b> di <b>{supplier_name}</b> è stata rimossa. <br>La fattura è stata riassegnata al documento {link_to_bcase}.",
        "detach_bcase_of_invoice": "L'assegnazione della fattura <b>{link_to_invoice}</b> di <b>{supplier_name}</b> è stata rimossa.",
        "attach_new_invoice_to_procurement_without_supplier": "La fattura <b>{link_to_invoice}</b> è stata assegnata a questo ordine d'acquisto da <b>{user_name}</b>.",
        "change_procurement_of_invoice": "L'assegnazione della fattura <b>{link_to_invoice}</b> da <b>{supplier_name}</b> è stata rimossa. <br>La fattura è stata assegnata all'ordine di acquisto {link_to_procurement}.",
        "change_procurement_of_invoice_without_supplier": "L'assegnazione della fattura <b>{link_to_invoice}</b> è stata rimossa. <br>La fattura è stata assegnata all'ordine di acquisto {link_to_procurement}.",
        "detach_procurement_of_invoice": "L'assegnazione della fattura <b>{link_to_invoice}</b> da <b>{supplier_name}</b> è stata rimossa.",
        "detach_procurement_of_invoice_without_supplier": "L'assegnazione della fattura <b>{link_to_invoice}</b> è stata rimossa.",
        "attach_external_invoice_to_procurement": "La fattura {invoice_number} di <b>{supplier_name}</b> è stata assegnata a questo ordine d'acquisto da <b>{invoice_by}</b>.",
        "insert_datev_note": "La fattura <b>{link_to_invoice}</b> di <b>{supplier_name}</b> è stata inviata a DATEV.",
        "insert_datev_note_without_supplier": "La fattura <b>{link_to_invoice}</b> è stata inviata a DATEV.",
        "on_ms365_export_error_generic": "Errore durante l'esportazione della fattura in D365. Contatti l'assistenza.",
        "on_ms365_export_validation_error": "Errore durante l'esportazione della fattura in D365. Contatti l'assistenza. Errore: {error}",
        "on_export_error": "Non è stato possibile inviare la fattura a DATEV. {error}",
        "on_export_error_generic": "Errore durante l'esportazione della fattura in DATEV. Contatti l'assistenza.",
        "on_export_error_validation": "{supplier_external_id_export_validation}{supplier_name_export_validation} Si rivolga a qualcuno con diritti di amministrazione per verificare le impostazioni.",
        "on_export_error_datev_access_is_not_active": "La connessione con DATEV deve essere stabilita. Si rivolga a qualcuno con diritti di amministratore.",
        "on_export_error_client_has_no_datev_access": "L'azienda {client_name} non ha memorizzato alcun dato di accesso DATEV. La preghiamo di contattare qualcuno con i diritti di amministratore.",
        "on_export_error_client_has_no_datev_permission": "Si è verificato un errore durante la trasmissione a DATEV. L'account DATEV impostato non ha i permessi per l'azienda {client_name}. La preghiamo di contattare una persona con diritti di amministratore per verificare l'accesso, i dati aziendali o le autorizzazioni all'interno di DATEV.",
        "on_export_error_datev_has_protocol_entries": "Errore durante l'esportazione della fattura su DATEV. Si prega di controllare il registro di esportazione o contattare l'assistenza.",
        "on_export_error_no_fiscal_year": "Si è verificato un errore durante la trasmissione a DATEV. La data della fattura non rientra nell'anno fiscale di DATEV. Si rivolga a qualcuno con diritti di amministratore per verificare l'anno fiscale in DATEV.",
        "on_export_error_invoice_not_active_for_fiscal_year": "Si è verificato un errore durante la trasmissione a DATEV. L'anno fiscale di DATEV non è stato rilasciato per la trasmissione delle fatture in entrata. Si rivolga a qualcuno con diritti di amministratore per verificare l'anno fiscale in DATEV.",
        "on_export_error_running": "Esportazione bloccata: Un'altra istanza sta già eseguendo questo processo.",
        "on_export_error_outgoing_invoice_not_supported": "Le fatture in uscita non possono essere esportate. Il flusso di lavoro termina con la verifica.",
        "on_export_error_document_discount_tax_required": "Lo sconto documento non può essere esportato perché l'aliquota IVA manca o non corrisponde a nessuna riga. Seleziona l'aliquota IVA dello sconto.",
        "on_export_error_document_discount_exceeds_base": "Lo sconto documento è superiore alla base netta delle righe con la stessa aliquota IVA e non può essere esportato.",
        "on_export_error_document_discount_invalid": "Lo sconto documento non può essere esportato. Controlla importo, base e aliquota IVA.",
        "insert_datev_protocol_note": "<b>Stato</b>: {status} <br><br> <b>Voci di protocollo</b>: <br> {protocol}",
        "labels": {
            "ai_validation_trusted_label": "La fattura è stata verificata dall'IA ed è stata considerata affidabile.",
            "ai_validation_not_trusted_label": "La fattura è stata verificata dall'IA ed è stata inoltrata al controllo manuale.",
            "ai_validation_trusted_score_only_label": "La fattura è stata classificata come affidabile dall'IA. {score_block}",
            "ai_validation_not_trusted_score_only_label": "La fattura è stata inoltrata al controllo manuale. {score_block}",
            "ai_validation_not_trusted_insufficient_positive_label": "La fattura è stata inoltrata al controllo manuale. {score_block} I segnali positivi non sono stati sufficienti: {ai_validation_reason_value}.",
            "ai_validation_trusted_reasons_label": "La fattura è stata classificata come affidabile dall'IA. {score_block} Fattori decisivi anche: {ai_validation_reason_value}.",
            "ai_validation_not_trusted_reasons_label": "La fattura è stata inoltrata al controllo manuale. {score_block} Fattori decisivi: {ai_validation_reason_value}.",
            "ai_validation_score_block_risk_passed": "Dai segnali positivi e negativi, l'IA ha calcolato un rischio complessivo di {score} — un livello di rischio {score_level}. Per l'approvazione automatica, questo rischio deve restare sotto {threshold}; questa soglia è rispettata.",
            "ai_validation_score_block_risk_failed": "Dai segnali positivi e negativi, l'IA ha calcolato un rischio complessivo di {score} — un livello di rischio {score_level}. Per l'approvazione automatica, questo rischio deve restare sotto {threshold}; questo valore è sopra la soglia.",
            "ai_validation_score_block_confidence_passed": "Dai segnali verificati, l'IA ha calcolato un valore di confidenza di {score} — un livello {score_level}. Per l'approvazione automatica, questo valore deve essere almeno {threshold}; questo requisito è soddisfatto.",
            "ai_validation_score_block_confidence_failed": "Dai segnali verificati, l'IA ha calcolato un valore di confidenza di {score} — un livello {score_level}. Per l'approvazione automatica, questo valore deve essere almeno {threshold}; il risultato non è sufficiente.",
            "ai_validation_score_block_green_sum_passed": "Dai segnali positivi, l'IA ha calcolato una somma di {score} — un livello {score_level}. Per l'approvazione automatica, questo valore deve essere almeno {threshold}; questo requisito è soddisfatto.",
            "ai_validation_score_block_green_sum_failed": "Dai segnali positivi, l'IA ha calcolato una somma di {score} — un livello {score_level}. Per l'approvazione automatica, questo valore deve essere almeno {threshold}; il risultato non è sufficiente.",
            "ai_validation_score_level_risk_very_low": "molto basso",
            "ai_validation_score_level_risk_low": "basso",
            "ai_validation_score_level_risk_acceptable": "accettabile",
            "ai_validation_score_level_risk_elevated": "elevato",
            "ai_validation_score_level_risk_high": "alto",
            "ai_validation_score_level_confidence_very_low": "molto basso",
            "ai_validation_score_level_confidence_low": "basso",
            "ai_validation_score_level_confidence_moderate": "moderato",
            "ai_validation_score_level_confidence_high": "alto",
            "ai_validation_score_level_confidence_very_high": "molto alto",
            "ai_validation_score_level_green_sum_very_low": "molto basso",
            "ai_validation_score_level_green_sum_low": "basso",
            "ai_validation_score_level_green_sum_moderate": "moderato",
            "ai_validation_score_level_green_sum_high": "alto",
            "ai_validation_score_level_green_sum_very_high": "molto alto",
            "ai_validation_risk_compensated_label": "I rischi rilevati ({ai_validation_secondary_reason_value}) sono stati compensati dai segnali positivi.",
            "ai_validation_positive_signals_label": "I segnali positivi ({ai_validation_secondary_reason_value}) non sono stati sufficienti a compensare i rischi.",
            "ai_validation_reason_and": "e",
            "ai_validation_reason_GREEN_01": "i campi obbligatori sono completi",
            "ai_validation_reason_GREEN_02": "la fattura corrisponde allo schema storico di questo fornitore",
            "ai_validation_reason_GREEN_03": "l'email del mittente è nota e corrisponde ai dati anagrafici",
            "ai_validation_reason_GREEN_04": "gli importi appaiono plausibili rispetto alla prestazione",
            "ai_validation_reason_GREEN_05": "il periodo di prestazione è chiaro e senza sovrapposizioni",
            "ai_validation_reason_GREEN_06": "le coordinate bancarie corrispondono ai dati anagrafici memorizzati",
            "ai_validation_reason_RED_01": "l'email del mittente differisce dagli indirizzi noti",
            "ai_validation_reason_RED_02": "il periodo di prestazione si sovrappone a fatture esistenti",
            "ai_validation_reason_RED_03": "l'importo o il rischio inerente è insolitamente alto",
            "ai_validation_reason_RED_04": "l'importo è aumentato notevolmente rispetto alle fatture precedenti",
            "ai_validation_reason_RED_05": "ordine/contratto mancante o sensibilmente divergente",
            "ai_validation_reason_RED_06": "le coordinate bancarie differiscono dai dati anagrafici",
            "ai_validation_failed": "La fattura non è stata convalidata.",
            "ai_validation_duplicate_invoice_label": "La validazione AI non è proseguita perché è stata trovata una fattura duplicata. La fattura è stata inoltrata al controllo manuale.",
            "ai_validation_mandatory_fields_missing_label": "Validazione AI fallita: Mancano i seguenti campi obbligatori",
            "ai_validation_client_address_mismatch_label": "La validazione AI non è proseguita perché l'indirizzo di fatturazione riconosciuto differisce dai dati anagrafici dell'azienda. La fattura è stata inoltrata al controllo manuale.",
            "ai_validation_client_address_unrecognized_label": "La validazione AI non è proseguita perché sulla fattura non è stato trovato un indirizzo di fatturazione sufficientemente riconoscibile. La fattura è stata inoltrata al controllo manuale.",
            "magic_suggestions_label": "Campi compilati automaticamente",
            "magic_suggestions_intro_label": "Ecco i campi che sono stati compilati automaticamente in base ai documenti precedenti di questo fornitore:",
            "ledger_account_label": "Conto contabile",
            "cost_center_label": "Centro di costo",
            "department_label": "Dipartimento",
            "cost_type_label": "Tipo di costo",
            "incoming_revenue_type_label": "Tipo di ricavo",
            "posting_key_label": "Chiave di registrazione",
            "tax_group_label": "Gruppo IVA",
            "tax_item_group_label": "Gruppo IVA articolo",
            "d365_branch_label": "Filiale",
            "d365_employee_label": "Dipendente",
            "d365_department_label": "Dipartimento D365",
            "d365_area_label": "Area D365",
            "d365_sales_channel_label": "Canale di vendita D365",
            "d365_vehicle_label": "Veicolo",
            "d365_project_label": "Progetto D365",
            "supplier_iban_label": "IBAN",
            "supplier_bic_label": "BIC",
            "supplier_bank_country_label": "Paese della banca",
            "supplier_bank_account_label": "Numero di conto",
            "supplier_bank_code_label": "Codice bancario",
            "supplier_payment_method_label": "Metodo di pagamento",
            "invoice_number_label": "Numero di fattura",
            "duplicate_invoice_reference_label": "Fattura duplicata",
            "procurement_number_label": "Numero d'ordine",
            "invoice_date_label": "Data della fattura",
            "invoice_due_date_label": "Scadenza",
            "supplier_label": "Fornitore",
            "client_label": "Azienda",
            "business_partner_label": "Partner commerciale",
            "total_netto_label": "Totale netto",
            "total_brutto_label": "Totale lordo",
            "tax_label": "Aliquota fiscale",
            "positions_count_label": "Posizione/i",
            "recognition_applied_data_label": "Applicato o derivato da liftbase",
            "contract_recognition_result_label": "Dati del contratto riconosciuti",
            "contract_name_label": "Descrizione del contratto",
            "contract_number_label": "Numero del contratto",
            "contract_external_number_label": "Numero contratto esterno",
            "contract_date_label": "Data del contratto",
            "contract_supplier_label": "Fornitore",
            "contract_client_label": "Azienda",
            "contract_category_label": "Categoria",
            "contract_payment_method_label": "Metodo di pagamento",
            "contract_payment_direction_label": "Direzione",
            "contract_payment_timing_label": "Momento del pagamento",
            "contract_term_type_label": "Tipo di durata",
            "contract_start_date_label": "Inizio del contratto",
            "contract_end_date_label": "Fine del contratto",
            "contract_duration_label": "Durata del contratto",
            "contract_renewal_type_label": "Tipo di rinnovo",
            "contract_renewal_duration_label": "Durata del rinnovo",
            "contract_notice_period_label": "Periodo di preavviso",
            "contract_termination_to_label": "Data di cessazione",
            "contract_total_net_label": "Totale netto",
            "contract_total_gross_label": "Totale lordo",
            "contract_currency_label": "Valuta",
            "contract_positions_label": "Posizioni",
            "origin_field_client_id": "Azienda",
            "origin_field_supplier_id": "Fornitore",
            "origin_field_business_partner_id": "Business partner",
            "origin_field_procurement_id": "Ordine",
            "origin_field_ledger_account_id": "Conto contabile",
            "origin_field_cost_center_id": "Centro di costo",
            "origin_field_profit_center_id": "Profit center",
            "origin_field_department_id": "Reparto",
            "origin_field_posting_key_id": "Chiave di contabilizzazione",
            "origin_field_branch_id": "Filiale",
            "origin_field_employee_id": "Dipendente",
            "origin_field_d365_area_id": "Area",
            "origin_field_d365_department_id": "Reparto D365",
            "origin_field_d365_labor_wert_id": "Valore lavoro",
            "origin_field_d365_project_id": "Progetto",
            "origin_field_d365_sales_channel_id": "Canale di vendita",
            "origin_field_d365_vehicle_id": "Veicolo",
            "origin_field_number": "Numero fattura",
            "origin_field_total_netto": "Totale netto",
            "origin_field_total_brutto": "Totale lordo",
            "origin_field_invoice_date": "Data fattura",
            "origin_field_due_date": "Scadenza",
            "origin_field_delivery_date": "Data consegna",
            "origin_field_currency": "Valuta",
            "origin_field_tax": "Aliquota IVA",
            "origin_field_contract_id": "Contratto",
            "origin_field_cost_type_id": "Tipo di costo",
            "origin_field_incoming_revenue_type_id": "Tipo di ricavo",
            "origin_field_discount_percentage": "Sconto 1 %",
            "origin_field_discount_amount": "Sconto 1 importo",
            "origin_field_discount_days": "Sconto 1 giorni",
            "origin_field_discount_payment_date": "Sconto 1 data",
            "origin_field_discount_percentage2": "Sconto 2 %",
            "origin_field_discount_amount2": "Sconto 2 importo",
            "origin_field_discount_days2": "Sconto 2 giorni",
            "origin_field_discount_payment_date2": "Sconto 2 data",
            "origin_field_lines": "Righe",
            "origin_field_recognized_client_id": "Azienda riconosciuta",
            "origin_field_recognized_supplier_id": "Fornitore riconosciuto",
            "origin_field_recognized_business_partner_id": "Business partner riconosciuto",
            "origin_field_supplier_iban": "IBAN fornitore",
            "origin_field_supplier_bic": "BIC fornitore",
            "origin_field_payment_bank_form_source": "Origine dati bancari",
            "origin_reason_document_extracted": "estratto direttamente dal documento",
            "origin_reason_from_procurement": "copiato dall'ordine assegnato",
            "origin_reason_from_supplier_master_data": "copiato dai dati anagrafici del fornitore",
            "origin_reason_from_business_partner_master_data": "copiato dai dati anagrafici del business partner",
            "origin_reason_invoice_number_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_total_netto_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_total_brutto_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_invoice_date_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_due_date_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_delivery_date_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_document_discount_amount_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_document_discount_base_amount_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_document_discount_percentage_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_document_discount_tax_percentage_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_client_matched_by_receiver_name_or_vat": "abbinato dal nome destinatario o ID IVA riconosciuto",
            "origin_reason_client_matched_by_supplier_name_or_vat": "abbinato dal nome emittente o ID IVA riconosciuto",
            "origin_reason_client_from_creator_profile": "preso dal profilo dell'uploader",
            "origin_reason_client_from_procurement": "copiato dall'ordine assegnato",
            "origin_reason_supplier_matched_by_name_vat_or_iban": "abbinato dal nome fornitore, ID IVA o IBAN riconosciuto",
            "origin_reason_business_partner_matched_by_name_vat_or_iban": "abbinato dal nome controparte, ID IVA o IBAN riconosciuto",
            "origin_reason_business_partner_matched_by_receiver_name_or_vat": "abbinato dal nome destinatario o ID IVA riconosciuto",
            "origin_reason_supplier_from_single_procurement_supplier": "preso dall'unico fornitore dell'ordine assegnato",
            "origin_reason_procurement_matched_by_recognized_reference": "abbinato dal riferimento ordine riconosciuto",
            "origin_reason_procurement_matched_by_invoice_similarity": "abbinato per somiglianza di importo, data e righe",
            "origin_reason_procurement_matched_by_invoice_similarity_without_supplier": "abbinato per somiglianza di importo, data e righe prima della selezione fornitore",
            "origin_reason_ledger_account_from_procurement": "copiato dall'ordine assegnato",
            "origin_reason_cost_center_from_procurement": "copiato dall'ordine assegnato",
            "origin_reason_cost_type_from_procurement": "copiato dall'ordine assegnato",
            "origin_reason_profit_center_from_supplier_master_data": "copiato dai dati anagrafici del fornitore",
            "origin_reason_profit_center_from_business_partner_master_data": "copiato dai dati anagrafici del business partner",
            "origin_reason_department_from_procurement": "copiato dall'ordine assegnato",
            "origin_reason_branch_from_procurement": "copiato dall'ordine assegnato",
            "origin_reason_employee_from_procurement": "copiato dall'ordine assegnato",
            "origin_reason_financial_dimension_from_procurement": "copiato dall'ordine assegnato",
            "origin_reason_ledger_account_from_supplier_master_data": "copiato dai dati anagrafici del fornitore",
            "origin_reason_cost_center_from_supplier_master_data": "copiato dai dati anagrafici del fornitore",
            "origin_reason_ledger_account_from_business_partner_master_data": "copiato dai dati anagrafici del business partner",
            "origin_reason_cost_center_from_business_partner_master_data": "copiato dai dati anagrafici del business partner",
            "origin_reason_posting_key_from_recognized_tax": "derivato dall'aliquota fiscale riconosciuta",
            "origin_reason_supplier_iban_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_supplier_bic_extracted_from_document": "estratto direttamente dal documento",
            "origin_reason_payment_bank_data_extracted_from_document": "impostato dai dati bancari riconosciuti nel documento",
            "no_data_read_label": "Nessun dato riconosciuto.",
            "supplier_external_id_export_validation": "L'ID esterno del fornitore deve essere specificato nell'area di amministrazione.",
            "supplier_name_export_validation": "Il nome del fornitore deve essere specificato nell'area di amministrazione.",
            "recognition_was_repeated": "{user_name} ha ripetuto il riconoscimento documento.",
            "bankdata_recognized_label": "Coordinate bancarie riconosciute dal documento",
            "bankdata_form_source_label": "Coordinate bancarie nel modulo – origine",
            "bankdata_form_changed_label": "Coordinate bancarie nel modulo – modificate",
            "bankdata_matches_masterdata_label": "Coordinate bancarie nel modulo corrispondono ai dati anagrafici",
            "bankdata_written_back_label": "Nuove coordinate bancarie riportate nei dati anagrafici",
            "bank_statement_auto_paid_label": "La fattura è stata contrassegnata automaticamente come pagata tramite l'analisi dell'estratto conto.",
            "payment_date_label": "Data pagamento",
            "payment_amount_label": "Importo",
            "bank_statement_document_label": "Estratto conto",
            "bank_statement_reference_label": "Causale",
            "bank_statement_match_reason_label": "Motivo dell'abbinamento",
            "bank_statement_match_reason_payment_reference": "Riferimento di pagamento",
            "bank_statement_match_reason_invoice_number": "Numero fattura",
            "bank_statement_match_reason_invoice_number_formatted": "Numero interno fattura",
            "bank_statement_match_reason_procurement_number": "Numero ordine",
            "bank_statement_match_reason_supplier_iban": "IBAN del fornitore",
            "bank_statement_match_reason_supplier_name": "Fornitore",
            "contract_id": "Contratto",
            "termination_deadline": "Scadenza disdetta",
            "recipient": "Destinatario",
            "error": "Errore"
        }
    },
    "login": {
        "email": {
            "title": "Accedi",
            "instructions": "Inserisca il suo indirizzo e-mail per accedere.",
            "punchin_instructions": "Per completare il processo, deve effettuare il login e avviare il processo di approvazione dell'ordine.",
            "tenant": "Inquilino",
            "place_holder": "Indirizzo e-mail",
            "last_used_emails": "Indirizzi e-mail utilizzati di recente",
            "delete_last_used_emails": "Cancellare la voce \"Utilizzato di recente\".",
            "has_no_account": "Non ha ancora un account?",
            "login_link_via_email": "Riceva il link di accesso via e-mail",
            "finish_login_title": "Accesso completo",
            "finish_login_instructions": "Riceverà ora un'e-mail con un link di accesso e un codice. Clicchi sul link oppure inserisca il codice di sei caratteri per completare il login. <br><br>L'e-mail di accesso è stata inviata a <br><b>{email}</b><br> e dovrebbe arrivare a breve. Se necessario, controlli la cartella spam.",
            "code_instructions": "In alternativa, inserisca il codice di sei caratteri ricevuto nell'e-mail:",
            "code_label": "Codice di accesso",
            "code_digit_label": "Carattere {index} del codice",
            "code_invalid": "Il codice è errato, scaduto o già utilizzato. Richieda una nuova e-mail di accesso.",
            "resend_code": "Invia una nuova e-mail di accesso",
            "forgot_passwort": {
                "title": "Password dimenticata",
                "login_via_email": "Accesso senza password",
                "instructions": "liftbase non utilizza password. Continui con SSO o con un link via e-mail, oppure usi il pulsante passkey separato."
            },
            "no_email": "Nell'e-mail",
            "no_email_validation": "Inserisca il suo indirizzo e-mail per accedere.",
            "check_email_title": "Controlla l'e-mail",
            "check_email_message": "Controlli ora la sua casella di posta elettronica e clicchi sul link di accesso oppure inserisca il codice."
        },
        "integration": {
            "title": "Collegamento dell'integrazione",
            "instructions": "liftbase sta completando l'autorizzazione. Sarà reindirizzato a breve.",
            "retry": "Impossibile continuare la connessione. Riprovi.",
            "retry_button": "Riconnetti"
        },
        "auto": {
            "login": "Accedi",
            "passkey_retry": "L'accesso con passkey non è riuscito. Può riprovare con il pulsante passkey o continuare con SSO o e-mail.",
            "status": {
                "discover": "Verifica dei metodi di accesso disponibili...",
                "passkey": "Tentativo di accesso con passkey...",
                "saml": "Tentativo di accesso con {provider}...",
                "email": "Invio del link e del codice di accesso via e-mail...",
                "code": "Verifica del codice di accesso..."
            }
        },
        "or": "o",
        "saml": {
            "login": "Continua con {provider}",
            "error": "Accesso SSO non riuscito. Riprovi.",
            "error_expired": "La sessione SSO è scaduta. Riavvii il login.",
            "error_mismatch": "L'account SSO non corrisponde all'e-mail inserita."
        },
        "passkey": {
            "title": "Effettui il login con la chiave d'accesso",
            "login": "Effettui il login con la chiave d'accesso",
            "what_is": {
                "title": "Cosa sono i passepartout?",
                "first": "Effettui il login senza attendere l'e-mail",
                "second": "Con la sua impronta digitale, il suo volto o il PIN",
                "third": "Si configuri ora in pochi passaggi nel suo profilo"
            },
            "error": "Accesso con passkey non riuscito. Riprovi con il pulsante passkey o continui con SSO o e-mail."
        }
    },
    "languages": {
        "de": "Tedesco",
        "en": "Inglese",
        "it": "Italian",
        "cz": "Repubblica Ceca",
        "sk": "Slovacco"
    },
    "translation-component": {
        "repeated": "Non puoi selezionare la stessa lingua più volte.",
        "language_empty": "Devi selezionare la lingua.",
        "translation_empty": "Devi inserire il testo per questa lingua selezionata.",
        "both_empty": "Devi inserire sia la lingua che il testo.",
        "language": "Lingua",
        "no_translation": "Non c'è testo registrato per questa lingua.",
        "at_least_one_required": "Devi fornire almeno un nome.",
        "text_without_translation": "Senza traduzione"
    },
    "mailbox": {
        "invoice_lines_group_by_tax": "Raggruppa le posizioni per aliquota",
        "invoice_lines_group_by_tax_hint": "Se abilitato, le posizioni riconosciute vengono raggruppate per aliquota (es.: Somma 19% imposta).",
        "ai_validation_mode": "Validazione IA",
        "ai_validation_mode_none": "Nessuna validazione IA",
        "ai_skip_to_ready_for_export": "Attiva e sposta a \"Pronto per l'esportazione\"",
        "ai_skip_to_ready_for_export_hint": "Se abilitato, la fattura verrà spostata direttamente allo stato \"Pronto per l'esportazione\" dopo il riconoscimento AI, a condizione che non siano richiesti passaggi di approvazione.",
        "ai_validation_advisory": "Attiva e mantieni invariato lo stato",
        "ai_validation_advisory_hint": "Se abilitata, le fatture importate vengono validate dall'IA, il risultato viene scritto nella timeline e i dettagli del punteggio vengono mostrati senza saltare il normale workflow.",
        "description": "Cassetta della posta",
        "description_plural": "Caselle postali",
        "name": "Nome",
        "username": "Nome utente",
        "password": "Password",
        "host": "Ospite",
        "port": "Porta",
        "smtp_host": "Host SMTP",
        "smtp_port": "Porta SMTP",
        "smtp_username": "E-mail / Username SMTP",
        "smtp_password": "Password SMTP",
        "tab_general": "Generale",
        "tab_import": "Import fatture",
        "tab_supplier_communication": "Comunicazione fornitore",
        "tab_historical_import": "E-mail storiche",
        "section_identity": "Casella e protocollo",
        "section_assignment": "Assegnazione",
        "section_incoming": "Accesso casella",
        "section_processing": "Elaborazione",
        "section_outgoing": "Invio",
        "section_historical_import": "Importa e-mail storiche",
        "protocol": "Protocollo",
        "ms365": "Microsoft 365",
        "ms365_type": "Tipo Microsoft 365",
        "ms365_enterprise_app": "MS365 Enterprise App",
        "app_tenant_id": "Tenant ID",
        "app_client_id": "Client ID",
        "client_secret": "Client Secret",
        "folder": "cartella",
        "mailbox": "MailBox",
        "period_in_days": "Periodo in giorni",
        "period_in_days_column": "Periodo (giorni)",
        "period_in_days_tooltip": "Età delle e-mail in giorni",
        "remove_mailbox_msg": "È sicuro di voler rimuovere questa casella postale?",
        "remove_mailbox_btn": "Rimuovere",
        "import_invoices_automatically": "Importazione delle fatture attiva",
        "use_for_supplier_communication": "Comunicazione fornitore attiva",
        "use_for_supplier_communication_hint": "Se attiva, questa casella viene utilizzata per elaborare le risposte della comunicazione con i fornitori.",
        "supplier_communication_bcase_types": "Tipi di documento per la comunicazione fornitore",
        "supplier_communication_bcase_types_hint": "Seleziona i tipi di documento per cui questa casella può essere usata nella comunicazione con il fornitore.",
        "supplier_communication_bcase_types_placeholder": "Seleziona uno o più tipi di documento",
        "import_mode": "Modalità di importazione",
        "import_mode_per_attachment": "Creare una fattura per ogni allegato email",
        "import_mode_ai_classified_per_attachment": "Importa solo gli allegati classificati come fatture dall'AI",
        "import_mode_per_email": "Creare una fattura per ogni email",
        "last_import_errors": "Ultimi errori di importazione",
        "show_import_errors": "Mostra {count} errori",
        "no_import_errors": "Nessun errore di importazione",
        "check_connection_btn": "Controllare la connessione",
        "connectivity_success_msg": "Connessione stabilita con successo.",
        "connectivity_error_msg": "Non è stato possibile stabilire una connessione. Controlli le sue credenziali.",
        "connectivity_graph_client_secret_read_access_denied_msg": "Microsoft Graph ha negato l'accesso a questa casella postale.<br><br>Controlli in Azure che:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>l'Enterprise App abbia le Application Permissions necessarie:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b></li><li>sia stato concesso l'Admin Consent</li><li>l'app possa accedere a questa casella</li></ul>",
        "connectivity_graph_client_secret_access_denied_msg": "Microsoft Graph ha negato l'accesso a questa casella postale.<br><br>Controlli in Azure che:<ul style='margin:8px 0;padding-left:20px;text-align:left'><li>l'Enterprise App abbia le Application Permissions necessarie:<br><b>Mail.Read</b>, <b>Mail.ReadBasic.All</b>, <b>Mail.ReadWrite</b>, <b>Mail.Send</b></li><li>sia stato concesso l'Admin Consent</li><li>l'app possa accedere a questa casella</li></ul>",
        "connectivity_graph_access_denied_msg": "Microsoft Graph ha negato l'accesso a questa casella postale. Ricolleghi la casella e verifichi che l'utente abbia accesso a questa casella.",
        "save_and_connect_btn": "Salvare e connettersi",
        "disconnect_btn": "Disconnettersi",
        "disconnect_success_msg": "La connessione si è scollegata con successo.",
        "historical_import_info_title": "Importa comunicazioni storiche dei fornitori",
        "historical_import_info": "Importa le e-mail della casella come storico delle comunicazioni. L'importazione delle fatture rimane separata.",
        "historical_import_period": "Periodo",
        "historical_import_range_separator": "a",
        "historical_import_start": "Data iniziale",
        "historical_import_end": "Data finale",
        "historical_import_invoice_warning_title": "Non verranno create fatture",
        "historical_import_invoice_warning": "Le e-mail storiche vengono salvate come comunicazioni. Gli allegati non passano dal riconoscimento fatture.",
        "historical_import_long_period_confirm": "Hai selezionato {days} giorni. L'importazione di un periodo lungo può richiedere tempo e creare molte comunicazioni. Vuoi continuare?",
        "historical_import_long_period_title": "Conferma periodo lungo",
        "historical_import_include_attachments": "Importa gli allegati delle comunicazioni",
        "historical_import_attachment_limit": "Dimensione massima allegato (MB)",
        "historical_import_attachment_skipped": "Allegati ignorati per il limite di dimensione: {count}",
        "historical_import_preview_btn": "Anteprima importazione",
        "historical_import_preview_title": "Anteprima importazione",
        "historical_import_preview_processing_title": "Preparazione dell'anteprima di importazione",
        "historical_import_preview_processing_description": "Sono in corso le verifiche delle e-mail e delle associazioni ai fornitori. Le caselle di posta grandi possono richiedere alcuni minuti.",
        "historical_import_preview_processing_elapsed": "In esecuzione da {seconds}s",
        "historical_import_authentication_error_title": "Accesso al provider e-mail non riuscito",
        "historical_import_authentication_error_description": "Il provider e-mail ha rifiutato l'accesso a questa casella. Controlli le credenziali. Gli account Google con verifica in due passaggi richiedono una password per le app.",
        "historical_import_edit_connection_btn": "Modifica i dati della casella",
        "historical_import_edit_connection_title": "Controlla la connessione della casella",
        "historical_import_edit_connection_description": "Corregga i dati di connessione e li verifichi di nuovo. La password non viene mostrata per motivi di sicurezza.",
        "historical_import_password_placeholder": "Lasci vuoto per mantenere il valore esistente",
        "historical_import_save_connection_to_master_data": "Salva le modifiche nei dati principali",
        "historical_import_test_and_retry_btn": "Verifica e riprova",
        "historical_import_connection_settings_error": "Non è stato possibile caricare i dati della casella.",
        "historical_import_connection_test_failed": "Non è stato possibile stabilire la connessione. Controlli i dati.",
        "historical_import_folder_error_title": "Cartella e-mail configurata non trovata",
        "historical_import_folder_error_description": "La cartella configurata per questa casella non è disponibile presso il provider e-mail. Verifichi il nome della cartella nella configurazione della casella.",
        "historical_import_client_missing_error_title": "Assegna prima un'azienda a questa casella di posta",
        "historical_import_client_missing_error_description": "L'onboarding delle fatture richiede l'azienda della casella di posta per assegnare correttamente le fatture importate.",
        "historical_import_client_required_error_title": "Selezioni un'azienda per questo import",
        "historical_import_client_required_error_description": "Questa casella non è associata a un'azienda. Selezioni un'azienda prima di avviare l'anteprima o l'import.",
        "historical_import_client_invalid_error_title": "Impossibile utilizzare l'azienda",
        "historical_import_client_invalid_error_description": "L'azienda selezionata non è disponibile. Selezioni un'azienda valida.",
        "historical_invoice_onboarding_client_missing_title": "Nessuna azienda associata a questa casella",
        "historical_invoice_onboarding_client_missing_description": "Può scegliere un'azienda fissa oppure lasciare che il riconoscimento determini l'azienda per ogni fattura.",
        "historical_invoice_onboarding_client_selection_title": "Azienda per l'importazione",
        "historical_invoice_onboarding_client_selection_description": "Scelga a quale azienda assegnare le fatture importate.",
        "historical_invoice_onboarding_settings_title": "Impostazioni di importazione",
        "historical_invoice_onboarding_settings_description": "Scelga il periodo e la dimensione massima degli allegati.",
        "historical_invoice_onboarding_full_recognition": "Verifica gli allegati idonei con l'IA e riconosci completamente le fatture",
        "historical_invoice_onboarding_full_recognition_cost_title": "Il riconoscimento completo delle fatture genera costi",
        "historical_invoice_onboarding_full_recognition_cost_description": "Gli allegati idonei vengono prima verificati con l'IA. Solo i documenti riconosciuti come fatture vengono elaborati completamente; i documenti verificati dall'IA generano costi.",
        "historical_invoice_onboarding_full_recognition_gift_title": "Riconoscimento completo delle fatture come omaggio di benvenuto",
        "historical_invoice_onboarding_full_recognition_gift_description": "Gli allegati idonei vengono verificati con l'IA e riconosciuti completamente. Per iniziare vengono elaborate al massimo 30 fatture.",
        "historical_invoice_onboarding_economic_recognition_title": "Riconoscimento economico dei dati master",
        "historical_invoice_onboarding_economic_recognition_alert_title": "Crea dati master a costi contenuti",
        "historical_invoice_onboarding_economic_recognition_description": "Ogni allegato di fattura viene analizzato localmente per creare o associare i dati master di azienda e fornitore. Non sono previsti costi di IA.",
        "historical_invoice_onboarding_preview_recognition_documents": "Verifiche IA stimate: {count}",
        "historical_invoice_onboarding_preview_recognition_unit_price": "Prezzo di fatturazione attuale: {price} per fattura riconosciuta con successo",
        "historical_invoice_onboarding_preview_recognition_cost": "Costo stimato: {cost}",
        "historical_invoice_onboarding_preview_recognition_cost_with_margin": "Stima prudenziale con margine del {margin}%: fino a {cost} (il margine non viene addebitato)",
        "historical_invoice_onboarding_recognition_cost_confirm_title": "Avviare il riconoscimento a pagamento?",
        "historical_invoice_onboarding_recognition_cost_confirm": "Nel periodo selezionato sono state trovate {emails} e-mail ancora da verificare per l'importazione. Tra queste, circa {invoices} potrebbero essere fatture da riconoscere con l'IA. Il totale stimato è fino a {cost}. La stima include un margine di sicurezza del {margin}%; viene addebitato solo il prezzo di fatturazione effettivo. Vuoi continuare?",
        "historical_invoice_onboarding_analysis_limited_with_recognition": "L'analisi e la stima dei costi si basano sulle prime {count} e-mail. Il numero finale può variare.",
        "historical_invoice_onboarding_recognition_requested": "Documenti inviati al riconoscimento: {count}",
        "historical_invoice_onboarding_recognition_skipped": "Documenti analizzati localmente per i dati master: {count}",
        "historical_invoice_onboarding_clients_created": "Aziende create: {count}",
        "historical_invoice_onboarding_clients_matched": "Aziende associate: {count}",
        "historical_invoice_onboarding_suppliers_created": "Fornitori creati: {count}",
        "historical_invoice_onboarding_suppliers_matched": "Fornitori associati: {count}",
        "historical_invoice_onboarding_master_data_conflicts": "Conflitti nei dati master: {count}",
        "historical_invoice_onboarding_master_data_review_title": "Alcuni dati master devono essere verificati",
        "historical_invoice_onboarding_master_data_review_description": "{pending} fatture richiedono un'associazione. Verifica le fatture interessate qui sotto e inserisci il nome dell'azienda o del fornitore se non è stato trovato alcun elemento corrispondente.",
        "historical_invoice_onboarding_master_data_conflicts_title": "{count} conflitti nei dati master richiedono una verifica",
        "historical_invoice_onboarding_master_data_conflicts_description": "Apri le fatture importate e verifica le associazioni. Dopo averle controllate, puoi confermare questo messaggio.",
        "historical_invoice_onboarding_master_data_conflicts_reviewed_btn": "Segna i conflitti come verificati",
        "historical_invoice_onboarding_master_data_conflicts_reviewed_success": "I conflitti nei dati master sono stati segnati come verificati.",
        "historical_invoice_onboarding_master_data_conflicts_reviewed_error": "Non è stato possibile confermare i conflitti nei dati master.",
        "historical_invoice_onboarding_master_data_review_btn": "Verifica dati master",
        "historical_invoice_onboarding_master_data_review_card_title": "Associazioni dati master aperte",
        "historical_invoice_onboarding_master_data_review_card_description": "L'azienda o il fornitore non è stato associato automaticamente per queste fatture. Puoi inserire il nome direttamente qui.",
        "historical_invoice_onboarding_recognition_mode": "Modalità di riconoscimento",
        "historical_invoice_onboarding_recognition_mode_economic": "Riconoscimento economico dei dati master",
        "historical_invoice_onboarding_recognition_mode_full": "Riconoscimento completo delle fatture",
        "historical_invoice_onboarding_item_recognition": "Riconoscimento",
        "historical_invoice_onboarding_item_result": "Risultato",
        "historical_invoice_onboarding_item_show_result": "Mostra risultato",
        "historical_invoice_onboarding_item_result_dialog_title": "Risultato del riconoscimento della fattura",
        "historical_invoice_onboarding_item_invoice_fallback": "Fattura #{id}",
        "historical_invoice_onboarding_item_open_invoice": "Apri fattura",
        "historical_invoice_onboarding_item_client": "Azienda",
        "historical_invoice_onboarding_item_supplier": "Fornitore",
        "historical_invoice_onboarding_item_not_assigned": "Non assegnato",
        "historical_invoice_onboarding_item_invoice": "Fattura",
        "historical_invoice_onboarding_manual_client_btn": "Crea azienda",
        "historical_invoice_onboarding_manual_supplier_btn": "Crea fornitore",
        "historical_invoice_onboarding_manual_name_title": "Crea dati master manualmente",
        "historical_invoice_onboarding_manual_name_title_client": "Crea nuova azienda",
        "historical_invoice_onboarding_manual_name_title_supplier": "Crea nuovo fornitore",
        "historical_invoice_onboarding_manual_name_description": "Non è stato trovato un elemento univoco. Inserisci il nome per {type} e salvalo per associare la fattura.",
        "historical_invoice_onboarding_manual_name_invoice_context_title": "Dati della fattura riconosciuti",
        "historical_invoice_onboarding_manual_name_apply_title": "Applica ad altre fatture aperte ({count})",
        "historical_invoice_onboarding_manual_name_apply_all_btn": "Seleziona tutte le fatture",
        "historical_invoice_onboarding_manual_name_apply_description": "Le seguenti fatture aperte non hanno ancora un'associazione per questo dato anagrafico. Controlla la selezione e associa la nuova voce solo alle fatture corrette.",
        "historical_invoice_onboarding_manual_name_label": "Nome",
        "historical_invoice_onboarding_manual_name_placeholder": "Inserisci un nome",
        "historical_invoice_onboarding_manual_name_save": "Salva e associa",
        "historical_invoice_onboarding_manual_name_save_bulk": "Salva e associa a {count} fatture",
        "historical_invoice_onboarding_manual_name_success": "I dati master sono stati creati e associati alla fattura.",
        "historical_invoice_onboarding_manual_name_bulk_success": "I dati master sono stati creati e associati a {count} fatture.",
        "historical_invoice_onboarding_manual_name_partial_success": "I dati master sono stati creati e associati a {assigned} fatture su {requested}. {skipped} fatture sono state ignorate perché erano già associate.",
        "historical_invoice_onboarding_manual_name_no_assignment": "Nessuna fattura è stata associata. Le fatture selezionate erano già associate.",
        "historical_invoice_onboarding_manual_name_error": "Non è stato possibile salvare i dati master.",
        "historical_import_error": "Errore",
        "historical_invoice_onboarding_target_client": "Azienda per l'importazione",
        "historical_invoice_onboarding_mailbox_client_question": "Questa casella è associata a “{client}”. Vuole usare questa azienda per l'import?",
        "historical_invoice_onboarding_mailbox_client_question_prefix": "Questa casella è associata a",
        "historical_invoice_onboarding_mailbox_client_question_client": "“{client}”",
        "historical_invoice_onboarding_mailbox_client_question_suffix": "Vuole usare questa azienda per l'import?",
        "historical_invoice_onboarding_use_mailbox_client": "Sì, usa questa azienda",
        "historical_invoice_onboarding_choose_other_client": "No, scegli un'altra azienda",
        "historical_invoice_onboarding_use_recognition": "Riconosci l'azienda dalla fattura",
        "historical_invoice_onboarding_recognition_title": "L'azienda verrà riconosciuta automaticamente",
        "historical_invoice_onboarding_recognition_description": "Il riconoscimento usa il nome del destinatario e la partita IVA. Le fatture senza una corrispondenza chiara resteranno disponibili per la revisione.",
        "historical_invoice_onboarding_preview_recognition": "Azienda: riconosciuta dalla fattura",
        "historical_invoice_onboarding_preview_client": "Azienda di destinazione: {client}",
        "historical_import_inactive_error_title": "La casella di posta è disattivata",
        "historical_import_inactive_error_description": "Attivi questa casella nella configurazione prima di avviare l'importazione storica delle fatture.",
        "historical_import_historical_invoice_onboarding_failed_error_title": "Importazione storica delle fatture non riuscita",
        "historical_import_historical_invoice_onboarding_failed_error_description": "L'importazione non può essere completata. Verifichi la configurazione della casella e riprovi.",
        "historical_import_preview_total": "E-mail trovate: {count}",
        "historical_import_preview_limited": "L'anteprima è limitata alle prime {count} e-mail.",
        "historical_import_preview_ambiguous": "Fornitori ambigui: {count}",
        "historical_import_preview_unassigned": "Senza fornitore: {count}",
        "historical_import_previously_processed": "Già elaborate ed escluse: {count}",
        "historical_import_preview_no_eligible": "Tutte le e-mail nel periodo selezionato sono già state elaborate ed escluse.",
        "historical_import_incremental_btn": "Importa nuove e-mail",
        "historical_import_continue_background_btn": "Continua in background",
        "historical_import_cancel_btn": "Annulla importazione",
        "import_close_confirm_title": "Importazione ancora in corso",
        "import_close_confirm_message": "L'importazione non è ancora terminata. Vuole chiudere questa finestra? Può continuare l'importazione in background oppure annullarla.",
        "import_close_confirm_stay_btn": "Resta nella finestra",
        "historical_import_retry_btn": "Riprendi importazione",
        "historical_import_retry_failed_btn": "Riprova le parti non riuscite",
        "historical_invoice_onboarding_finished_btn": "Fatto",
        "historical_invoice_onboarding_close_btn": "Chiudi",
        "historical_import_match_status": "Associazione fornitore",
        "historical_import_match_matched": "Associato",
        "historical_import_match_ambiguous": "Ambiguo",
        "historical_import_match_none": "Non associato",
        "historical_import_history_title": "Cronologia importazioni",
        "historical_import_latest_summary": "Ultima importazione: {date} · {status} · {count} e-mail",
        "historical_import_previous_attention": "L'ultima importazione ha lo stato “{status}”.",
        "historical_import_show_history": "Mostra la cronologia importazioni",
        "historical_import_hide_history": "Nascondi la cronologia importazioni",
        "historical_import_active_selection_locked": "L'importazione attiva deve essere completata prima di visualizzare un'altra esecuzione.",
        "historical_import_history_period": "Periodo",
        "historical_import_history_status": "Stato",
        "historical_import_history_processed": "Elaborate",
        "historical_import_history_duration": "Durata",
        "historical_import_duration_seconds": "{count}s",
        "historical_import_duration_minutes_seconds": "{minutes} min {seconds}s",
        "historical_import_start_btn": "Avvia importazione storica",
        "historical_import_status_title": "Stato importazione",
        "historical_import_status_pending": "In coda",
        "historical_import_status_running": "In corso",
        "historical_import_status_finalizing": "Completamento dei dati anagrafici",
        "historical_import_status_completed": "Completata",
        "historical_invoice_onboarding_status_completed": "Ultima importazione completata",
        "historical_import_status_failed": "Non riuscita",
        "historical_import_status_cancelled": "Annullata",
        "historical_import_processed": "Elaborate: {processed} di {total}",
        "historical_import_eta": "Tempo rimanente stimato: {duration}",
        "historical_import_created": "Create: {count}",
        "historical_import_matched": "Fornitore associato: {count}",
        "historical_import_skipped": "Saltate: {count}",
        "historical_import_failed": "Non riuscite: {count}",
        "historical_import_messages_title": "E-mail storiche importate",
        "historical_import_messages_selected_title": "E-mail dall'importazione del {date}",
        "historical_import_show_all_messages": "Mostra tutte le e-mail importate",
        "historical_import_show_messages": "Mostra e-mail",
        "historical_import_hide_messages": "Nascondi e-mail",
        "historical_import_refresh": "Aggiorna",
        "historical_import_no_messages": "Nessuna e-mail storica importata.",
        "historical_import_subject": "Oggetto",
        "historical_import_sender": "Mittente",
        "historical_import_date": "Data",
        "historical_import_supplier": "Fornitore",
        "tab_invoice_onboarding": "Onboarding fatture",
        "tab_procurement_onboarding": "Onboarding ordini",
        "section_procurement_onboarding": "Ordini storici",
        "procurement_onboarding_info": "Importa gli ordini passati come storico in sola lettura e usa i dati riconosciuti per i dati anagrafici.",
        "historical_procurement_onboarding_initial_hint_title": "Crea i primi dati anagrafici dagli ordini",
        "historical_procurement_onboarding_initial_hint": "Azienda, fornitori e contatti possono essere ricavati dalla casella degli ordini.",
        "historical_procurement_onboarding_confirmed_client": "Conferma azienda",
        "historical_procurement_onboarding_confirmed_client_placeholder": "Inserisci il nome dell'azienda confermato",
        "historical_procurement_onboarding_candidate_evidence": "Candidato trovato in {count} e-mail (confidenza: {confidence}%). Conferma o correggi il nome prima dell'importazione.",
        "historical_procurement_onboarding_client_required": "Conferma l'azienda prima di avviare l'importazione iniziale.",
        "historical_procurement_onboarding_period": "Periodo",
        "historical_procurement_onboarding_mode": "Modalità di importazione",
        "historical_procurement_onboarding_economic": "Economica (senza IA)",
        "historical_procurement_onboarding_ai": "Analisi IA",
        "historical_procurement_onboarding_economic_title": "Estrazione economica",
        "historical_procurement_onboarding_economic_hint": "Usa mittente, oggetto, corpo dell'e-mail e allegati di testo strutturati. Limitata agli ultimi 30 giorni.",
        "historical_procurement_onboarding_gift_title": "Regalo IA di onboarding",
        "historical_procurement_onboarding_gift_hint": "Gratuito durante l'onboarding iniziale: fino a 50 e-mail o 30 allegati.",
        "historical_procurement_onboarding_ai_cost_title": "L'analisi IA è a pagamento",
        "historical_procurement_onboarding_ai_cost_hint": "La stima viene confermata prima dell'importazione e salvata separatamente.",
        "historical_procurement_onboarding_preview": "Anteprima importazione",
        "historical_procurement_onboarding_preview_emails": "E-mail controllate: {count}",
        "historical_procurement_onboarding_preview_documents": "Documenti IA stimati: {count}",
        "historical_procurement_onboarding_preview_cost": "Costo stimato: {cost}",
        "historical_procurement_onboarding_progress": "Elaborati: {processed}; ordini storici creati: {imported}; non riusciti: {failed}",
        "historical_procurement_onboarding_analyse": "Analizza",
        "historical_procurement_onboarding_start": "Avvia importazione",
        "historical_procurement_onboarding_cost_confirm_title": "Avviare l'importazione a pagamento?",
        "historical_procurement_onboarding_cost_confirm": "Costo IA stimato: {cost}. Continuare?",
        "historical_procurement_onboarding_cost_history": "Cronologia costi importazione IA",
        "historical_procurement_onboarding_cost_history_entry": "Stima: {estimate}; effettivo: {actual}",
        "historical_procurement_insufficient_order_evidence": "Non sono state trovate prove affidabili dell'ordine.",
        "historical_procurement_client_confirmation_required": "È richiesta la conferma dell'azienda.",
        "historical_procurement_supplier_review_required": "Il fornitore richiede una verifica manuale.",
        "section_invoice_onboarding": "Onboarding da casella di fatture storiche",
        "invoice_onboarding_info": "Importa allegati di fatture storiche senza modificare le e-mail nella casella. Le fonti già elaborate vengono escluse.",
        "historical_invoice_onboarding_period": "Periodo di onboarding fatture",
        "historical_invoice_onboarding_start": "Avvia onboarding storico delle fatture",
        "historical_invoice_onboarding_analysis_btn": "Analisi dell'importazione",
        "historical_invoice_onboarding_analysis_again_btn": "Nuova analisi dell'importazione",
        "historical_invoice_onboarding_start_again": "Avvia nuovamente l'importazione",
        "historical_invoice_onboarding_completed_title": "L'ultima importazione è completata",
        "historical_invoice_onboarding_completed_description": "Puoi chiudere questa finestra oppure selezionare un nuovo periodo e avviare un'altra analisi o importazione.",
        "historical_invoice_onboarding_analysis_title": "Analisi dell'importazione",
        "historical_invoice_onboarding_analysis_processing_title": "Preparazione dell'analisi dell'importazione",
        "historical_invoice_onboarding_analysis_processing_description": "Le e-mail e gli allegati sono in fase di verifica. Stiamo calcolando il numero stimato di fatture riconosciute e i costi previsti. Attenda un momento.",
        "historical_invoice_onboarding_analysis_description": "Riepilogo delle e-mail trovate nel periodo selezionato e della loro possibile elaborazione. Le singole e-mail non vengono mostrate qui.",
        "historical_invoice_onboarding_analysis_limited": "L'analisi è limitata alle prime {count} e-mail. Il totale include tutte le e-mail trovate nel periodo selezionato.",
        "historical_invoice_onboarding_analysis_failed_title": "Non è stato possibile analizzare alcune e-mail",
        "historical_invoice_onboarding_analysis_failed_description": "Non è stato possibile analizzare {failed} delle {processed} e-mail verificate. Controlli i dati della casella prima di avviare l'importazione.",
        "historical_invoice_onboarding_long_period_confirm": "Hai selezionato {days} giorni. L'importazione delle fatture storiche potrebbe richiedere tempo. Vuoi continuare?",
        "historical_invoice_onboarding_preview_total": "E-mail trovate: {count}",
        "historical_invoice_onboarding_analysis_processed": "E-mail verificate: {count}",
        "historical_invoice_onboarding_preview_eligible": "E-mail con allegati fattura: {count}",
        "historical_invoice_onboarding_preview_no_attachment": "Senza allegato fattura: {count}",
        "historical_invoice_onboarding_preview_failed": "Non analizzate: {count}",
        "historical_invoice_onboarding_preview_failed_title": "Alcune e-mail non possono essere analizzate",
        "historical_invoice_onboarding_preview_failed_description": "Non è stato possibile analizzare {count} e-mail. Controlli i dettagli dell'importazione prima di avviarla.",
        "historical_invoice_onboarding_preview_previously_imported": "Già importate per l'onboarding: {count}",
        "historical_invoice_onboarding_preview_empty": "Non sono stati trovati nuovi allegati fattura nel periodo selezionato.",
        "historical_invoice_onboarding_imported": "E-mail di fatture importate: {count}",
        "historical_invoice_onboarding_master_data_created": "Dati anagrafici creati: {count}",
        "historical_invoice_onboarding_master_data_matched": "Dati anagrafici associati: {count}",
        "historical_invoice_onboarding_master_data_pending": "Dati anagrafici da verificare: {count}",
        "historical_invoice_onboarding_history": "Cronologia onboarding",
        "historical_invoice_onboarding_items": "E-mail dall'onboarding fatture del {date}",
        "historical_invoice_onboarding_no_items": "Nessuna e-mail elaborata per questo onboarding fatture.",
        "historical_invoice_onboarding_attachments": "Allegati fattura",
        "historical_invoice_onboarding_item_imported": "Importata",
        "historical_invoice_onboarding_item_skipped": "Saltata",
        "historical_invoice_onboarding_item_failed": "Non riuscita",
        "historical_invoice_onboarding_item_processing": "In elaborazione"
    },
    "marketplace": {
        "description": "Marketplace",
        "description_plural": "Marketplace",
        "name": "Nome / Alias",
        "provider": "Fornitore",
        "country_code": "Paese",
        "url": "URL",
        "email": "Email",
        "order_url": "URL dell'ordine",
        "order_auth_type": "Autenticazione ordine",
        "order_auth_type_none": "Nessuna",
        "order_auth_type_basic": "HTTP Basic Auth",
        "order_auth_username": "Nome utente",
        "order_auth_password": "Password",
        "identity": "Identità",
        "secret": "Segreto",
        "section_configuration": "Configurazione marketplace",
        "section_sender_identity": "Mittente / Identità",
        "section_order_authentication": "Autenticazione ordine",
        "new": "Nuovo Marketplace",
        "amazon_more_clients_info": "In Liftbase sono configurate più aziende. <br>Per assicurarti che le fatture di Amazon Business siano assegnate all'azienda corretta, <br>segui le istruzioni al seguente link: <br><a href='https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen.' target='_blank'>https://liftbase.de/handbuch/einrichtung/amazon-business-mehrere-unternehmen</a>."
    },
    "payment_options": {
        "label": "Metodo di pagamento dell'azienda fornitrice",
        "AUTOMATIC_DEBIT": "Tramite addebito SEPA",
        "CREDIT_CARD": "Tramite carta di credito",
        "BANK_TRANSFER": "Tramite bonifico bancario (IBAN/BIC)",
        "BANK_TRANSFER_FOREIGN": "Bonifico estero (numero di conto/codice bancario)",
        "ONLINE_PAYMENT": "Servizi di pagamento online"
    },
    "errors": {
        "field_required": "Un campo obbligatorio del modulo non è stato compilato.",
        "specific_field_required": "Il campo {field} è obbligatorio.",
        "invalid_type": "Il valore fornito non è valido.",
        "specific_invalid_type": "Il valore \"{value}\" non è valido per il tipo {type}.",
        "unique_violation": "Questo valore è già in uso.",
        "specific_unique_violation": "Esiste già un record con questo valore nel campo {field}.",
        "foreign_key_violation": "Riferimento non valido a un altro record.",
        "specific_foreign_key_violation": "Il valore nel campo {field} non può essere collegato a un record esistente.",
        "permission_denied": "Non hai il permesso per eseguire questa azione.",
        "check_violation": "I dati inseriti non soddisfano i criteri di sistema.",
        "specific_check_violation": "Il valore nel campo {field} non soddisfa le regole definite.",
        "value_too_long": "Il valore supera la lunghezza consentita.",
        "specific_value_too_long": "Il valore nel campo {field} supera la lunghezza consentita.",
        "not_found": "La risorsa richiesta non è stata trovata.",
        "already_exists": "Questo elemento è già registrato.",
        "validation_failed": "La convalida dei dati non è riuscita.",
        "unexpected": "Qualcosa è andato storto. Riprova o contatta il supporto.",
        "specific_field_not_found": "Il campo {field} non è stato trovato nel tipo {type}.",
        "expected_type_but_found": "Ci si aspettava {field} del tipo {type}, ma è stato trovato {type_found}.",
        "duplicate_key_violation": "Il valore fornito esiste già e viola il vincolo della chiave unica {field}.",
        "unexpected_null_value_for_type": "Valore nullo imprevisto per il tipo {type}.",
        "timeline_changed": "Il documento è stato modificato da un'altra persona. La pagina verrà aggiornata automaticamente. Controlla di nuovo il documento.",
        "timeline_locked": "Il documento è stato appena modificato da {name}. La pagina è stata aggiornata automaticamente. Controlla di nuovo il documento.",
        "save_bcase_error": "Si è verificato un errore durante il salvataggio.<br>Il modulo non può essere salvato.<br>Controlla i dati inseriti e riprova.<br>Se il problema persiste, contatta il supporto."
    },
    "onboarding": {
        "flow_option": "Configurazione",
        "custom_option": "Seleziona i dati demo individualmente",
        "custom_option_description": "Scegli quali dati di esempio utilizzare – ideale per familiarizzare con il sistema senza inserire dati propri.",
        "full_option": "Usa tutti i dati demo (consigliato)",
        "full_option_description": "Utilizza una configurazione completa dei dati demo per iniziare subito a usare il sistema – senza configurazione manuale.",
        "none_option": "Inizia senza dati demo",
        "none_option_description": "Inizia con un ambiente vuoto e configura il sistema interamente con i tuoi dati.",
        "invoice_onboarding_option": "Importa le tue fatture storiche",
        "invoice_onboarding_option_description": "Collega una casella fatture esistente e inizia con documenti reali invece di dati demo.",
        "invoice_onboarding_mailbox_step": "Casella fatture",
        "invoice_onboarding_mailbox_step_title": "Scegli una casella fatture",
        "invoice_onboarding_mailbox_step_description": "Scelga una casella esistente oppure ne configuri una nuova per iniziare l'importazione.",
        "invoice_onboarding_import_step": "Fatture storiche",
        "invoice_onboarding_mailbox": "Casella fatture",
        "invoice_onboarding_mailbox_placeholder": "Seleziona casella",
        "invoice_onboarding_mailbox_default_folder": "INBOX",
        "invoice_onboarding_use_existing_mailbox": "Usa una casella esistente",
        "invoice_onboarding_use_existing_mailbox_description": "Selezioni una casella già configurata per l'importazione.",
        "invoice_onboarding_existing_mailboxes_title": "Abbiamo trovato caselle fatture già configurate.",
        "invoice_onboarding_existing_mailboxes_description": "Vuole usarne una oppure configurare una nuova casella?",
        "invoice_onboarding_create_mailbox": "Configura una nuova casella",
        "invoice_onboarding_create_mailbox_description": "Colleghi una nuova casella e inizi l'importazione.",
        "invoice_onboarding_mailbox_setup_step": "Collega casella",
        "invoice_onboarding_mailbox_setup_title": "Collega la casella fatture",
        "invoice_onboarding_mailbox_setup_description": "Inserisca solo i dati di accesso alla casella. Potrà completare le altre impostazioni in seguito.",
        "invoice_onboarding_mailbox_setup_hint_title": "I dati di accesso vengono memorizzati in modo sicuro",
        "invoice_onboarding_mailbox_setup_hint_description": "Per le fatture storiche è sufficiente l'accesso in lettura alla cartella selezionata.",
        "invoice_onboarding_mailbox_setup_name_placeholder": "ad es. Fatture",
        "invoice_onboarding_mailbox_setup_protocol_imap": "Dati di accesso IMAP",
        "invoice_onboarding_mailbox_setup_protocol_imap_description": "Per Gmail, GMX, IONOS e altre caselle IMAP.",
        "invoice_onboarding_mailbox_setup_protocol_ews": "Microsoft Exchange (EWS)",
        "invoice_onboarding_mailbox_setup_protocol_ews_description": "Acceda con il suo account utente Microsoft 365.",
        "invoice_onboarding_mailbox_setup_protocol_graph": "Microsoft 365 (Microsoft Graph)",
        "invoice_onboarding_mailbox_setup_protocol_graph_description": "Colleghi un account utente tramite Microsoft Graph.",
        "invoice_onboarding_mailbox_setup_protocol_ms365": "Microsoft 365 – applicazione aziendale",
        "invoice_onboarding_mailbox_setup_protocol_ms365_description": "Per accessi centralizzati con ID tenant, ID app e segreto.",
        "invoice_onboarding_mailbox_setup_connect_title": "Accesso a Microsoft 365 richiesto",
        "invoice_onboarding_mailbox_setup_connect_description": "Dopo il salvataggio, l'accesso Microsoft si aprirà in una nuova finestra. Poi torni a questo onboarding.",
        "invoice_onboarding_mailbox_setup_host_placeholder": "ad es. imap.tuo-dominio.it",
        "invoice_onboarding_mailbox_setup_save": "Salva casella e continua",
        "invoice_onboarding_mailbox_setup_save_and_connect": "Salva e connettiti a Microsoft 365",
        "invoice_onboarding_mailbox_setup_saved": "Casella configurata.",
        "invoice_onboarding_no_mailbox": "Non è ancora configurata alcuna casella fatture attiva",
        "invoice_onboarding_no_mailbox_description": "Configuri prima una casella fatture per importare le fatture storiche.",
        "invoice_onboarding_configure_mailbox": "Configura casella",
        "btn_start": "Iniziamo!",
        "btn_finish": "Cominciamo!",
        "select_client": "Seleziona le aziende con cui vuoi lavorare.",
        "select_cost_center": "Seleziona i centri di costo con cui vuoi lavorare.",
        "select_department": "Seleziona i reparti con cui vuoi lavorare.",
        "select_ledger_account": "Seleziona i conti contabili con cui vuoi lavorare.",
        "select_posting_key": "Seleziona le chiavi fiscali con cui vuoi lavorare.",
        "select_supplier": "Seleziona i fornitori con cui vuoi lavorare.",
        "select_product": "Seleziona i prodotti con cui vuoi lavorare.",
        "general_config": "Inserisci le impostazioni di base più importanti.",
        "profile_config": "Inserisci i dati principali del profilo – per processi più veloci e ordini più semplici."
    },
    "contract": {
        "description": "Contratto",
        "name": "Descrizione",
        "contract_date": "Data del contratto",
        "contract_number_formatted": "CT-numero",
        "contract_number": "Numero di contratto",
        "category": "Categoria",
        "status": "Stato",
        "type": "Tipo",
        "notes": "Nota",
        "payment_method": "Metodo di pagamento",
        "payment_direction": "Direzione",
        "external_contract_number": "Numero di contratto esterno",
        "responsible_id": "Responsabile",
        "recurring_invoice": "Fattura ricorrente",
        "start_date": "Data inizio",
        "end_date": "Data fine",
        "duration": "Durata",
        "min_duration": "Durata minima del contratto",
        "duration_unit_type": "Unità di durata",
        "renewal_type": "Tipo di rinnovo",
        "renewal_duration": "Durata del rinnovo",
        "renewal_duration_unit_type": "Unità di rinnovo",
        "notice_period": "Periodo di preavviso",
        "notice_period_unit_type": "Unità di preavviso",
        "termination_special_right": "Diritto di recesso speciale",
        "termination_deadline": "Scadenza per la risoluzione",
        "next_possible_contract_end": "Prossima possibile scadenza",
        "terminated_on": "Terminato il",
        "termination_to": "Risoluzione a",
        "reminder_date": "Data promemoria",
        "reminder_duration": "Promemoria prima della data di disdetta",
        "reminder_unit_type": "Unità di tempo del promemoria di disdetta",
        "term_type": "Tipo di durata",
        "termination_to_options": {
            "none": "Nessuno",
            "day": "Giorno",
            "year_end": "Fine anno",
            "half_year_end": "Fine semestre",
            "quarter_end": "Fine trimestre",
            "month_end": "Fine mese",
            "week_end": "Fine settimana"
        },
        "duration_unit_type_options": {
            "month": "Mese(i)",
            "quarter": "Trimestre",
            "semester": "Semestre",
            "year": "Anno(i)",
            "week": "Settimana(e)"
        },
        "renewal_type_options": {
            "auto": "Rinnovato automaticamente",
            "none": "Nessun rinnovo",
            "once": "Rinnovo unico",
            "manual": "Rinnovato manualmente"
        },
        "payment_timing": "Tempistica di pagamento",
        "payment_timing_options": {
            "advance": "Anticipato",
            "postpaid": "Posticipato",
            "midterm": "A metà periodo"
        },
        "usage_type": "Frequenza di utilizzo",
        "usage_type_options": {
            "usage_based": "In base all'uso",
            "monthly": "Mensile",
            "quarterly": "Trimestrale",
            "semiannually": "Semestrale",
            "yearly": "Annuale"
        },
        "category_options": {
            "service": "Servizio",
            "subscription": "Abbonamento",
            "license": "Licenza",
            "maintenance": "Manutenzione",
            "consulting": "Consulenza",
            "leasing": "Leasing",
            "rental": "Noleggio",
            "support": "Supporto",
            "other": "Altro"
        },
        "term_type_options": {
            "fixed": "A termine",
            "indefinite": "Indeterminato",
            "none": "Senza durata"
        },
        "payment_direction_options": {
            "incoming": "Entrata",
            "outgoing": "Uscita",
            "both": "Entrambe le direzioni"
        },
        "ai": {
            "back": "Indietro",
            "add_title": "Nuovo contratto",
            "add_subtitle": "Scegli come vuoi creare il contratto.",
            "manual_title": "Inserisci i dati del contratto",
            "manual_description": "Crea il contratto manualmente utilizzando il modulo esistente.",
            "ai_title": "Riconosci il contratto con l'IA",
            "ai_description": "Carica un PDF e controlla i dati estratti.",
            "disabled": "L'IA è disattivata per questo tenant.",
            "upload_title": "Riconosci il contratto con l'IA",
            "upload_subtitle": "Carica uno o più PDF. I dati estratti saranno mostrati accanto al documento per la verifica.",
            "upload_info": "Trascina qui i PDF dei contratti o fai clic per selezionarli.",
            "upload_hint": "Solo PDF, massimo 30 MB e 50 pagine.",
            "file_invalid": "Sono supportati solo file PDF.",
            "file_too_large": "Il PDF non può superare i 30 MB.",
            "file_size": "{size} MB",
            "select_file_preview": "Seleziona un file per visualizzarne l'anteprima.",
            "start_recognition": "Invia i contratti al riconoscimento",
            "recognition_failed": "Impossibile riconoscere il contratto. Riprova.",
            "document_review_hint": "Controlla i campi estratti prima di salvare.",
            "document_loading": "Caricamento documento…",
            "new_upload": "Nuovo caricamento",
            "document_preview_failed": "Non è stato possibile caricare l'anteprima del documento. Puoi comunque controllare e salvare i dati riconosciuti.",
            "client_review": "Nel documento “{client}” è indicato come cliente. Verifica l'azienda selezionata.",
            "persistence_failed": "Il contratto è stato creato, ma il PDF e l'analisi AI non sono ancora stati salvati.",
            "retry_save": "Riprova a salvare"
        },
        "statuses": {
            "active": "Attivo",
            "inactive": "Inattivo",
            "declined": "Annullato",
            "expired": "Scaduto",
            "pending": "In sospeso",
            "recognition": "Riconoscimento",
            "completed": "Firmato",
            "check": "Controllo",
            "clearing": "Contract Clearing"
        },
        "page": {
            "new": "Nuovo contratto",
            "create_btn": "Crea contratto",
            "no_edit_permission": "Non hai il permesso di modificare i dati. Invia il contratto per chiarimenti per poter apportare modifiche.",
            "before_leave_msg": "Il contratto non è stato salvato. Sei sicuro di voler lasciare la pagina?",
            "no_procurement": "Non sono stati registrati ordini per questo contratto.",
            "no_invoice": "Non sono state registrate fatture per questo contratto.",
            "recognition_data_title": "Dati grezzi di riconoscimento",
            "no_recognition_data": "Nessun dato riconosciuto.",
            "no_permission_create_contract": "Non hai il permesso di creare un nuovo contratto.",
            "period": "Periodo",
            "no_invoice_for_period": "Nessuna fattura per questo periodo.",
            "confirm_before_leave_msg": "Il tuo contratto non è stato salvato. Sei sicuro di voler lasciare la pagina?",
            "reminder_tooltip": "In questo giorno ti invieremo un promemoria via e-mail riguardo a questo contratto.",
            "tour": {
                "description": "",
                "save_btn": ""
            },
            "validation": {
                "client_id_required": "Seleziona un'azienda.",
                "department_id_required": "Seleziona un dipartimento.",
                "department_id_required_client_missing": "Prima seleziona un'azienda.",
                "cost_center_id_required": "Seleziona un centro di costo.",
                "cost_center_id_required_filters_missing": "Prima seleziona azienda e dipartimento.",
                "cost_center_id_required_department_missing": "Prima seleziona un dipartimento.",
                "cost_center_id_required_client_missing": "Prima seleziona un'azienda."
            }
        },
        "reminder_type": {
            "contract_end": "Fine contratto",
            "cancellation_notice": "Preavviso di cancellazione",
            "invoice_missing": "Fattura mancante",
            "custom": "Personalizzato"
        },
        "procurements": {
            "quantity_ordered": "Ordinato",
            "quantity_received": "Ricevuto"
        },
        "documents": "Documenti"
    },
    "contract_line": {
        "title": "Voce di contratto",
        "new_title": "Nuova voce di contratto",
        "name": "Descrizione",
        "type": "Tipo",
        "type_options": {
            "service": "Servizio",
            "product": "Prodotto",
            "license": "Licenza",
            "maintenance": "Manutenzione",
            "subscription": "Abbonamento",
            "other": "Altro"
        },
        "item_number": "Numero voce",
        "quantity": "Quantità",
        "total": "Totale",
        "image_url": "URL immagine",
        "webshop_url": "URL shop",
        "offer_number": "Numero offerta",
        "offer_date": "Data offerta",
        "usage_type": "Frequenza di utilizzo",
        "add_btn": "Aggiungi nuova voce",
        "delete_btn": "Rimuovi voce di contratto",
        "edit_btn": "Modifica voce di contratto",
        "confirm_before_delete_msg": "Sei sicuro di voler eliminare definitivamente questa voce?",
        "confirm_before_delete_title": "Elimina voce",
        "confirm_before_delete_btn": "Elimina"
    },
    "contract_term": {
        "title": "Durata contratto",
        "add_btn": "Aggiungi nuova durata contratto",
        "delete_btn": "Rimuovi durata contratto",
        "edit_btn": "Modifica durata contratto",
        "section_duration": "Durata",
        "section_renewal": "Rinnovo",
        "section_termination": "Risoluzione",
        "section_reminder": "Promemoria",
        "section_term_type": "Tipo di durata",
        "term_type_indefinite": "I contratti a tempo indeterminato non hanno rinnovo",
        "show_termination_fields_msg": "I contratti rinnovati possono essere risolti alla fine della durata come segue.",
        "do_not_show_termination_fields_msg": "I contratti a termine hanno una scadenza fissa e possono essere risolti anticipatamente solo con diritto speciale.",
        "no_termination_possible_msg": "Scadenza contratto raggiunta, risoluzione non possibile.",
        "no_renewal_msg": "I contratti a tempo indeterminato non hanno rinnovo"
    },
    "copy_contract_dialog": {
        "title": "Trasferisci dati",
        "title_select_contract": "Trasferisci dati contratto",
        "select_contract": "Seleziona un contratto.",
        "message": "Vuoi trasferire alcuni dati dal contratto a questa richiesta d'ordine?",
        "overwrite_checkbox": "Sovrascrivi i dati esistenti nel modulo.",
        "confirm_btn": "Conferma"
    },
    "custom_field": {
        "description": "Campo personalizzato",
        "label": "Etichetta",
        "type": "Tipo di campo",
        "multilingual": "Multilingue",
        "export_enabled": "Usa per l'esportazione",
        "export_field_name": "Nome nell'export {export_name}",
        "bcase_type": "Tipo di documento",
        "bcase_types": {
            "default_value": "Valore predefinito",
            "required": "Campo obbligatorio",
            "readonly": "Sola lettura",
            "show_in_search": "Campo di ricerca",
            "show_in_export": "Campo di esportazione",
            "show_in_column_dialog": "Dialogo colonne",
            "show_in_api": "API",
            "order": "Ordine",
            "visible_in_step_types": "Mostra nei passaggi",
            "all_steps": "Tutti i passaggi"
        },
        "tooltip": "Tooltip",
        "default_value": "Valore predefinito",
        "field_key": "Nome API",
        "type_options": {
            "text": "Testo",
            "textarea": "Testo multilinea",
            "number": "Numero",
            "currency": "Valuta",
            "checkbox": "Checkbox",
            "radio": "Selezione (radio)",
            "enum": "Elenco a discesa",
            "date": "Data",
            "html": "Rich Text (HTML)"
        },
        "page": {
            "new_title": "Nuovo campo",
            "tab_general": "Generale",
            "tab_options": "Opzioni",
            "tab_validation": "Validazione",
            "tab_labels": "Etichette",
            "tab_tooltips": "Tooltips",
            "tab_permissions": "Gruppi di permessi",
            "tab_clients": "Aziende",
            "tab_bcase_types": "Tipi di documenti collegati",
            "tab_bcase_description": "Campi aggiuntivi",
            "validation": {
                "label_required": "Inserisci un'etichetta.",
                "field_key_required": "Inserisci un nome API.",
                "export_field_name_required": "Inserisci un nome campo per l'export."
            },
            "options": {
                "repeated": "Non è possibile inserire la stessa opzione più di una volta.",
                "required_fields": "Devi inserire l'etichetta e l'ID dell'opzione.",
                "language_empty": "Devi selezionare una lingua.",
                "at_least_one_required": "Devi inserire almeno un'opzione."
            }
        }
    },
    "custom_field_label": {
        "description": "Etichette"
    },
    "ai_access_request": {
        "title": "Richiedi l'accesso all'IA",
        "headline": "Ottieni di più dai tuoi dati",
        "intro": "Con l'accesso all'IA puoi usare funzioni intelligenti che riducono il lavoro di routine e velocizzano i processi.",
        "benefit_recognition_title": "Riconosci automaticamente i documenti",
        "benefit_recognition_description": "Acquisisci ed elabora più rapidamente fatture e contenuti rilevanti.",
        "benefit_data_title": "Dati anagrafici migliori",
        "benefit_data_description": "Associa in modo affidabile aziende, fornitori e contenuti dei documenti.",
        "benefit_workflow_title": "Risultati più rapidi",
        "benefit_workflow_description": "Meno lavoro manuale e più tempo per le attività importanti.",
        "description": "L'IA non è ancora attiva per questo tenant. Invia una richiesta al reparto vendite per attivare l'accesso.",
        "action": "Richiedi accesso",
        "requested": "La richiesta è stata inviata al reparto vendite.",
        "already_requested": "Oggi è già stata inviata una richiesta per questa area."
    },
    "custom_field_tooltip": {
        "description": "Tooltips"
    },
    "custom_field_option": {
        "description": "Opzioni"
    },
    "custom_field_bcase_type": {
        "description": "Tipi di documenti collegati",
        "visible_in_step_types": "Mostra nei passaggi"
    },
    "bcase_custom_field": {
        "description": "Campi aggiuntivi"
    }
}
